/* Install section HTML cache (always; separate asset may not be deployed yet) */
(function (global) {
  if (global.fetchSectionHtml && global.fetchSectionHtml._sepPdpCached) return

  var TTL_MS = 30 * 60 * 1000
  var PREFIX = 'sepPdpSec:v3:'
  var MAX_429_RETRIES = 3
  var memory = new Map()
  var inflight = new Map()

  function normalizeUrl(url) {
    try {
      var u = new URL(url, location.origin)
      var params = new URLSearchParams(u.search)
      var keys = []
      params.forEach(function (_v, k) {
        keys.push(k)
      })
      keys.sort()
      var sorted = new URLSearchParams()
      keys.forEach(function (k) {
        params.getAll(k).forEach(function (v) {
          sorted.append(k, v)
        })
      })
      var qs = sorted.toString()
      return u.pathname + (qs ? '?' + qs : '')
    } catch (e) {
      return String(url)
    }
  }

  function storageKey(key) {
    return PREFIX + key
  }

  function read(key) {
    var now = Date.now()
    var mem = memory.get(key)
    if (mem) {
      if (now - mem.ts < TTL_MS && typeof mem.text === 'string' && mem.text.length) {
        return mem.text
      }
      memory.delete(key)
    }
    try {
      var raw = localStorage.getItem(storageKey(key))
      if (!raw) return null
      var parsed = JSON.parse(raw)
      if (
        !parsed ||
        typeof parsed.text !== 'string' ||
        !parsed.text.length ||
        now - parsed.ts >= TTL_MS
      ) {
        localStorage.removeItem(storageKey(key))
        return null
      }
      memory.set(key, parsed)
      return parsed.text
    } catch (e) {
      return null
    }
  }

  function pruneStorage() {
    var entries = []
    for (var i = 0; i < localStorage.length; i++) {
      var k = localStorage.key(i)
      if (!k || k.indexOf(PREFIX) !== 0) continue
      var ts = 0
      try {
        ts = JSON.parse(localStorage.getItem(k) || '{}').ts || 0
      } catch (e) {}
      entries.push({ k: k, ts: ts })
    }
    entries.sort(function (a, b) {
      return a.ts - b.ts
    })
    var removeCount = Math.max(1, Math.ceil(entries.length / 2))
    for (var j = 0; j < removeCount; j++) {
      try {
        localStorage.removeItem(entries[j].k)
      } catch (e) {}
    }
  }

  function write(key, text) {
    if (typeof text !== 'string' || !text.length) return
    var entry = { ts: Date.now(), text: text }
    memory.set(key, entry)
    try {
      localStorage.setItem(storageKey(key), JSON.stringify(entry))
    } catch (e) {
      try {
        pruneStorage()
        localStorage.setItem(storageKey(key), JSON.stringify(entry))
      } catch (e2) {}
    }
  }

  function clearKey(key) {
    memory.delete(key)
    try {
      localStorage.removeItem(storageKey(key))
    } catch (e) {}
  }

  function fetchSectionHtml(url, init, retryCount) {
    retryCount = retryCount || 0
    var key = normalizeUrl(url)
    var cached = read(key)
    if (cached != null) return Promise.resolve(cached)

    if (inflight.has(key)) return inflight.get(key)

    var promise = fetch(url, init)
      .then(function (res) {
        if (!res.ok) {
          var err = new Error('section fetch failed ' + res.status)
          err.status = res.status
          throw err
        }
        return res.text()
      })
      .then(function (text) {
        // Never cache empty/error bodies
        if (typeof text === 'string' && text.length) write(key, text)
        else clearKey(key)
        inflight.delete(key)
        return text
      })
      .catch(function (err) {
        // Never store failed responses (or the key)
        clearKey(key)
        inflight.delete(key)

        if (err && err.status === 429 && retryCount < MAX_429_RETRIES) {
          var delay = 1500 * Math.pow(2, retryCount)
          var retryPromise = new Promise(function (resolve, reject) {
            setTimeout(function () {
              // Drop this placeholder so the retry can claim inflight cleanly
              if (inflight.get(key) === retryPromise) inflight.delete(key)
              fetchSectionHtml(url, init, retryCount + 1).then(resolve, reject)
            }, delay)
          })
          // Coalesce clicks during backoff onto the same delayed retry
          inflight.set(key, retryPromise)
          return retryPromise
        }
        throw err
      })

    inflight.set(key, promise)
    return promise
  }

  fetchSectionHtml.clear = function (url) {
    if (!url) return
    var key = normalizeUrl(url)
    clearKey(key)
    inflight.delete(key)
  }

  fetchSectionHtml._sepPdpCached = true
  global.fetchSectionHtml = fetchSectionHtml
})(window);

if (typeof window.SEP_DESIGN_ZOOM_ENABLED === 'undefined') {
    window.SEP_DESIGN_ZOOM_ENABLED = false
  }
  document.body.classList.toggle('sep-zoom-enabled', window.SEP_DESIGN_ZOOM_ENABLED === true)

  function initSepDesignGalleryEnhancements() {
    const sectionRoot = document.querySelector(window.SEP_DESIGN_PDP.sectionRoot)
    if (!sectionRoot || sectionRoot.dataset.galleryEnhancementsReady === 'true') return
    sectionRoot.dataset.galleryEnhancementsReady = 'true'

    const zoomState = { panel: null, lens: null }
    const zoomFactor = 2.5
    const zoomTypes = new Set(['sunglasses', 'prescription', 'ophthalmic'])

    function hideSepDesignZoom() {
      if (zoomState.panel) zoomState.panel.style.display = 'none'
      if (zoomState.lens) zoomState.lens.style.display = 'none'
    }

    function getSepDesignZoomWrapper(event) {
      const wrapper = event.target.closest('.mainslider-wrapper > .swiper .image-wrapper')
      if (!wrapper) return null
      const slide = wrapper.closest('.swiper-slide')
      if (!slide || slide.classList.contains('hidden')) return null
      const swiperEl = wrapper.closest('.swiper')
      const productType = (swiperEl && swiperEl.getAttribute('data-product-type')) || ''
      if (!zoomTypes.has(productType)) return null
      const mainSlider = wrapper.closest('.product__sep-design__mainSlider')
      if (!mainSlider || mainSlider.classList.contains('hidden')) return null
      if (mainSlider.offsetParent === null && getComputedStyle(mainSlider).display === 'none') return null
      return wrapper
    }

    function handleSepDesignZoom(event) {
      if (window.SEP_DESIGN_ZOOM_ENABLED !== true) return hideSepDesignZoom()
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return hideSepDesignZoom()
      const wrapper = getSepDesignZoomWrapper(event)
      if (!wrapper) return hideSepDesignZoom()
      const img = wrapper.querySelector('img')
      const src = img && (img.currentSrc || img.src)
      if (!src) return hideSepDesignZoom()

      if (!zoomState.panel) {
        zoomState.panel = document.createElement('div')
        zoomState.panel.className = 'sep-zoom-panel'
        document.body.appendChild(zoomState.panel)
      }
      let lens = wrapper.querySelector(':scope > .sep-zoom-lens')
      if (!lens) {
        lens = document.createElement('div')
        lens.className = 'sep-zoom-lens'
        wrapper.appendChild(lens)
      }
      zoomState.lens = lens

      const rect = wrapper.getBoundingClientRect()
      const localX = Math.min(Math.max(event.clientX - rect.left, 0), rect.width)
      const localY = Math.min(Math.max(event.clientY - rect.top, 0), rect.height)
      const fx = rect.width ? localX / rect.width : 0
      const fy = rect.height ? localY / rect.height : 0

      const panel = zoomState.panel
      const panelWidth = rect.width
      const panelHeight = Math.min(Math.max(rect.height * 1.5, 640), window.innerHeight - 32)
      panel.style.width = panelWidth + 'px'
      panel.style.height = panelHeight + 'px'
      panel.style.backgroundImage = `url("${src}")`
      panel.style.backgroundSize = `${zoomFactor * 100}%`
      panel.style.backgroundPosition = `${fx * 100}% ${fy * 100}%`
      panel.style.display = 'block'

      panel.style.left = rect.right + 16 + 'px'
      panel.style.right = 'auto'
      panel.style.top = Math.max(16, (window.innerHeight - panelHeight) / 2) + 'px'

      const lensW = Math.min(rect.width, panelWidth / zoomFactor)
      const lensH = Math.min(rect.height, panelHeight / zoomFactor)
      lens.style.width = lensW + 'px'
      lens.style.height = lensH + 'px'
      lens.style.left = Math.min(Math.max(localX - lensW / 2, 0), rect.width - lensW) + 'px'
      lens.style.top = Math.min(Math.max(localY - lensH / 2, 0), rect.height - lensH) + 'px'
      lens.style.display = 'block'
    }

    sectionRoot.addEventListener('pointermove', handleSepDesignZoom)
    sectionRoot.addEventListener('pointerleave', hideSepDesignZoom)
    window.addEventListener('scroll', hideSepDesignZoom, { passive: true })
  }

  initSepDesignGalleryEnhancements()

  /** Inject safety-pdp.css when landing page was Rx/other and Options navigate to Z87/sun. */
  function ensureSafetyPdpCss() {
    const id = 'sep-safety-pdp-css'
    if (document.getElementById(id)) return Promise.resolve(true)
    if (document.querySelector('link[href*="safety-pdp.css"]')) return Promise.resolve(true)
    const href = window.SEP_DESIGN_PDP?.safetyPdpCssUrl
    if (!href) {
      nvzOptLog('safetyCss:skip', { reason: 'no-url' })
      return Promise.resolve(false)
    }
    return new Promise((resolve) => {
      const link = document.createElement('link')
      link.id = id
      link.rel = 'stylesheet'
      link.href = href
      link.onload = () => {
        nvzOptLog('safetyCss:loaded', { href })
        resolve(true)
      }
      link.onerror = () => {
        nvzOptLog('safetyCss:error', { href })
        resolve(false)
      }
      document.head.appendChild(link)
    })
  }

  /** Enable/disable Safety CSS overrides — never leave .is-safety-pdp on Rx/Oph/Sun. */
  function syncSafetyPdpCssScope(product) {
    const isSafety =
      resolvePdpOptionsType(product) === 'Safety' ||
      product?.product_type === 'Safety' ||
      product?.productType === 'Safety' ||
      /-z87$/.test(product?.handle || '')
    // Z87 PDPs drop the mobile try-on button below the badge row (product-sep-design.css)
    const isZ87 = !!isSafety && normalizeProductTags(product?.tags).includes('Z87')
    document.querySelectorAll('.sep-design-pdp').forEach((el) => {
      el.classList.toggle('is-safety-pdp', !!isSafety)
      el.classList.toggle('is-z87-pdp', isZ87)
    })
    if (isSafety) ensureSafetyPdpCss()
    nvzOptLog('safetyCss:scope', { isSafety, handle: product?.handle })
  }

  /** Z87 is public. Keep helper so existing call sites stay valid. */
  function canSeeSafetyZ87() {
    return true
  }

  function stripZ87DoorwayIfGated(root) {
    if (canSeeSafetyZ87()) return
    const scope = root || document
    scope.querySelectorAll('[data-z87-doorway], [data-pdp-options-item="to_z87"]').forEach((el) => el.remove())
  }

  /**
   * Options plan by product.type only.
   * `included` = static Included✓ row owned by that type (never cross-paint).
   * Size / Z87 / Rx only change doorway handles/copy.
   * Liquid SSR: snippets/product__sep-design__pdpOptions.liquid
   */
  const PDP_OPTIONS_BY_TYPE = {
    Safety: {
      items: ['included_shields_antifog', 'rx_doorway', 'extra_shields', 'to_regular_sun'],
      included: {
        id: 'included_shields_antifog',
        title: 'Side shields & anti-fog',
        sub: 'Both in the box on every pair',
        kind: 'safety_shields'
      }
    },
    Sunglasses: {
      items: ['included_lens_features', 'to_z87', 'to_rx'],
      included: {
        id: 'included_lens_features',
        kind: 'sunglasses_lens',
        tagLabels: [
          { tag: '_style_feature:polarized', label: 'Polarized' },
          { tag: '_lens_rating:UV400', label: 'UV400' }
        ],
        fallbackTitle: 'Polarized · UV400',
        sub: 'Included on every pair'
      }
    },
    Prescription: {
      items: ['to_sunglasses'],
      included: null
    }
  }

  function getPdpOptionsPlan(type) {
    return PDP_OPTIONS_BY_TYPE[type] || null
  }

  function sunglassesIncludedTitle(product) {
    const cfg = PDP_OPTIONS_BY_TYPE.Sunglasses.included
    const parts = []
    ;(cfg.tagLabels || []).forEach((entry) => {
      if (productHasTag(product, entry.tag)) parts.push(entry.label)
    })
    return parts.length ? parts.join(' · ') : cfg.fallbackTitle
  }

  /** Sync static Included✓ row for this product.type only — never mix Safety ↔ Sunglasses copy. */
  function syncPdpOptionsIncluded(product) {
    const type = resolvePdpOptionsType(product)
    const plan = getPdpOptionsPlan(type)
    const optsRoot = getVisiblePdpOptions()
    if (!optsRoot || !plan) return

    const liveType = optsRoot.getAttribute('data-pdp-options-type')
    if (liveType && liveType !== type.toLowerCase()) return

    const includedCfg = plan.included
    let row = optsRoot.querySelector('[data-pdp-options-included]')

    if (!includedCfg) {
      if (row) row.remove()
      return
    }

    if (includedCfg.kind === 'safety_shields') {
      // Liquid owns Safety included markup; only refresh antifog subcopy.
      if (!row) return
      const titleEl = row.querySelector('[data-pdp-included-title]')
      if (titleEl && includedCfg.title) titleEl.textContent = includedCfg.title
      syncSafetyLensHelperCopy(window.pdp.selectedVariant)
      return
    }

    if (includedCfg.kind === 'sunglasses_lens') {
      const items = optsRoot.querySelector('[data-pdp-options-items], .rx-toggle-lensbox')
      if (!items) return
      const title = sunglassesIncludedTitle(product)
      if (!row) {
        row = document.createElement('div')
        row.className = 'rx-toggle-lensrow rx-toggle-lensrow--included'
        row.setAttribute('data-pdp-options-item', includedCfg.id)
        row.setAttribute('data-pdp-options-included', '')
        row.innerHTML =
          '<span class="rx-toggle-ic" aria-hidden="true">🕶</span>' +
          '<span class="rx-toggle-tx"><b data-pdp-included-title></b><span data-pdp-included-sub></span></span>' +
          '<span class="rx-toggle-chk">Included ✓</span>'
        const before =
          items.querySelector('[data-z87-doorway]') ||
          items.querySelector('.rx-toggle-action:not([data-z87-doorway])')
        if (before) items.insertBefore(row, before)
        else items.prepend(row)
      }
      row.setAttribute('data-pdp-options-item', includedCfg.id)
      const titleEl = row.querySelector('[data-pdp-included-title]')
      const subEl = row.querySelector('[data-pdp-included-sub]')
      if (titleEl) titleEl.textContent = title
      if (subEl) subEl.textContent = includedCfg.sub
    }
  }

  function resolvePdpOptionsType(product) {
    if (!product) return ''
    const t = product.product_type || product.productType || ''
    if (t === 'Safety' || t === 'Sunglasses' || t === 'Prescription') return t
    const h = product.handle || ''
    if (/-z87$/.test(h)) return 'Safety'
    if (/-rx$/.test(h)) return 'Prescription'
    if (t !== 'Ophthalmic' && h && !/-z87$/.test(h)) return 'Sunglasses'
    return t
  }

  function getVisibleOtherProductsContainer() {
    return document.querySelector('.other-products-container:not(.hidden)')
  }

  function getVisiblePdpOptions() {
    const visible = getVisibleOtherProductsContainer()
    return visible?.querySelector('[data-pdp-options]') || null
  }

  function getVisibleRxToggle() {
    const visible = getVisibleOtherProductsContainer()
    if (visible) {
      return (
        visible.querySelector('.product__information_block.rx-toggle[data-pdp-options]') ||
        visible.querySelector('.product__information_block.rx-toggle') ||
        null
      )
    }
    // Injected fallback only (no Liquid other-products mount yet)
    return document.querySelector('.product__information_block.rx-toggle[data-rx-toggle-injected]:not(.hidden)')
  }

  function pdpOptionsTypeKey(productOrType) {
    if (!productOrType) return ''
    if (typeof productOrType === 'string') return productOrType.toLowerCase()
    return resolvePdpOptionsType(productOrType).toLowerCase()
  }

  /** Single entry: bind / reveal Options for current product.type. Prefer Liquid remount. */
  function syncPdpOptions(product, opts) {
    const live = getVisiblePdpOptions()
    const liveType = live?.getAttribute('data-pdp-options-type') || null
    const pending = window.pdp.pendingProductSwitch
    // After other-products remount, Liquid card is source of truth (product.type can lag 1 tick).
    let type = resolvePdpOptionsType(product)
    if (opts?.force && liveType === 'safety') type = 'Safety'
    else if (opts?.force && liveType === 'sunglasses') type = 'Sunglasses'
    else if (opts?.force && liveType === 'prescription') type = 'Prescription'

    const plan = getPdpOptionsPlan(type)
    const planItems = plan?.items || []
    const wantType = pdpOptionsTypeKey(type)
    const doorwayHandle = pending?.targetKey || product?.handle || ''

    nvzOptLog('syncPdpOptions', {
      type,
      plan: planItems,
      included: plan?.included?.id || null,
      handle: product?.handle,
      doorwayHandle,
      liveType,
      force: !!opts?.force,
      pending
    })

    // Mid size / Z87 / Rx switch: wait for other-products Liquid remount.
    // Early paint used to strip Safety OPTIONS + inject duplicates.
    if (
      !opts?.force &&
      pending &&
      (pending.kind === 'safety' || pending.kind === 'size' || pending.kind === 'rx') &&
      liveType !== wantType
    ) {
      nvzOptLog('syncPdpOptions:defer', { wantType, liveType, pending })
      return
    }

    if (type === 'Safety' || type === 'Sunglasses' || type === 'Prescription') {
      syncSafetyPdpCssScope(
        type === 'Safety'
          ? { ...(product || {}), product_type: 'Safety', handle: doorwayHandle || product?.handle }
          : { ...(product || {}), product_type: type }
      )
    }

    if (type === 'Safety') {
      cancelForceRevealSunglassesOptions()
      document.querySelectorAll('[data-rx-toggle-injected]').forEach((el) => el.remove())
      const optsEl = getVisiblePdpOptions()
      if (optsEl && optsEl.getAttribute('data-pdp-options-type') === 'safety') {
        // Color change keeps same other-products mount — retarget regular-sun doorway.
        const regularHandle = toRegularHandle(doorwayHandle)
        const sunBtn = optsEl.querySelector(
          '[data-pdp-options-item="to_regular_sun"], [data-pdp-switch-kind="safety-sun"]'
        )
        if (sunBtn && regularHandle) {
          bindSafetySunDoorway(sunBtn, regularHandle)
        }
        syncSafetyRegularSunDoorway({ ...(product || {}), handle: doorwayHandle, product_type: 'Safety' })
        syncPdpOptionsIncluded({ ...(product || {}), handle: doorwayHandle, product_type: 'Safety' })
        initSafetyShieldsUi()
        syncSafetyLensTypeButtons(window.pdp.selectedVariant)
        nvzOptLog('syncPdpOptions:safety-live', { ok: true, regularHandle })
        return
      }
      revealSafetyOptionsAfterSwitch(doorwayHandle || product?.handle)
      return
    }

    if (type === 'Sunglasses') {
      stripStaleSunSafetyOptionsBlocks()
      const optsEl = getVisiblePdpOptions()
      if (optsEl && optsEl.getAttribute('data-pdp-options-type') === 'sunglasses') {
        // Drop any injected duplicate once Liquid Options are present.
        document.querySelectorAll('[data-rx-toggle-injected]').forEach((el) => {
          if (el !== optsEl) el.remove()
        })
        optsEl.classList.remove('hidden', 'is-busy')
        const titleProduct = {
          ...(product || {}),
          handle: doorwayHandle,
          product_type: 'Sunglasses',
          title: product?.title
        }
        if (!canSeeSafetyZ87()) {
          stripZ87DoorwayIfGated(optsEl)
        } else {
          const safetyHandle = toSafetyHandle(doorwayHandle)
          const z87Btn = optsEl.querySelector('[data-z87-doorway]')
          const retargetZ87Btn = (btn) => {
            bindSafetySunDoorway(btn, safetyHandle)
            const titleEl = btn.querySelector('[data-z87-doorway-title]')
            if (titleEl) titleEl.textContent = z87DoorwayTitleForSunProduct(titleProduct)
            btn.classList.remove('hidden')
            rememberZ87Handle(safetyHandle)
          }
          if (
            z87Btn &&
            (z87Btn.getAttribute('data-pdp-switch-handle') === safetyHandle || z87KnownForRegular(titleProduct))
          ) {
            retargetZ87Btn(z87Btn)
          } else if (z87Btn) {
            // Color switch reuses the previous color's card: only retarget its Z87 row
            // once the new color's -z87 product is confirmed (e.g. no Surge Z87 exists).
            z87Btn.classList.add('hidden')
            verifyZ87Exists(safetyHandle).then((exists) => {
              // A newer switch owns the row now.
              if (!z87Btn.isConnected || window.pdp.currentProduct?.handle !== doorwayHandle) return
              if (exists) {
                retargetZ87Btn(z87Btn)
              } else {
                z87Btn.remove()
              }
            })
          } else if (z87KnownForRegular(titleProduct)) {
            ensureZ87DoorwayRow(optsEl.querySelector('[data-pdp-options-items], .rx-toggle-lensbox'), {
              handle: safetyHandle,
              title: z87DoorwayTitleForSunProduct(titleProduct),
              sub: 'ANSI Z87+ high impact'
            })
            rememberZ87Handle(safetyHandle)
          }
          rememberZ87FromDom()
        }
        syncSunglassesRxRow(optsEl, doorwayHandle)
        syncPdpOptionsIncluded({ ...titleProduct, product_type: 'Sunglasses' })
        updateRxToggleUI(false, { ...titleProduct, product_type: 'Sunglasses' })
        nvzOptLog('syncPdpOptions:sun-live', {
          ok: true,
          canSeeZ87: canSeeSafetyZ87(),
          items: Array.from(optsEl.querySelectorAll('[data-pdp-options-item]')).map((el) =>
            el.getAttribute('data-pdp-options-item')
          )
        })
        return
      }
      // Fallback when section HTML missing Options (Storefront-only remount).
      const sunProduct = {
        ...(product || {}),
        handle: doorwayHandle || product?.handle,
        product_type: product?.product_type || product?.productType || 'Sunglasses'
      }
      rebuildSunglassesOptionsCard(sunProduct)
      if (
        window.pdp._safetySunPair?.regular === sunProduct.handle ||
        opts?.force ||
        pending?.kind === 'safety'
      ) {
        forceRevealSunglassesOptionsAfterSafetySwitch(sunProduct.handle)
      }
      return
    }

    if (type === 'Prescription') {
      document.querySelectorAll('[data-rx-toggle-injected]').forEach((el) => el.remove())
      const rx = getVisibleRxToggle()
      if (rx && rx.getAttribute('data-pdp-options-type') === 'prescription') {
        rx.classList.remove('hidden', 'is-busy')
        syncPdpOptionsIncluded({ ...(product || {}), product_type: 'Prescription' })
        updateRxToggleUI(true, product)
        nvzOptLog('syncPdpOptions:rx-live', { ok: true })
        return
      }
      if (rx) {
        rx.classList.remove('hidden', 'is-busy')
        syncPdpOptionsIncluded({ ...(product || {}), product_type: 'Prescription' })
        updateRxToggleUI(true, product)
      }
    }
  }

  function scheduleSyncPdpOptionsRetries(product) {
    const handle = product?.handle
    const gen = (window.pdp._optionsSyncGen = (window.pdp._optionsSyncGen || 0) + 1)
    const run = (label) => {
      if (gen !== window.pdp._optionsSyncGen) return
      const p = window.pdp.currentProduct
      if (!p || (handle && p.handle !== handle)) return
      syncPdpOptions(p, { force: true })
      nvzOptLog('syncPdpOptions:retry', {
        label,
        liveType: getVisiblePdpOptions()?.getAttribute('data-pdp-options-type') || null
      })
    }
    requestAnimationFrame(() => {
      run('raf')
      setTimeout(() => run('50ms'), 50)
      setTimeout(() => run('200ms'), 200)
      setTimeout(() => run('500ms'), 500)
    })
  }

  function updateRxToggleUI(isRx, product) {
    const rxToggle = getVisibleRxToggle()
    if (!rxToggle) return
    const textEl = rxToggle.querySelector('.rx-toggle-text')
    const subEl = rxToggle.querySelector('.rx-toggle-sub')
    const iconEl = rxToggle.querySelector('.rx-toggle-action:not([data-z87-doorway]) .rx-toggle-ic')
    if (isRx) {
      rxToggle.classList.add('rx')
      rxToggle.classList.remove('sunglasses')
      if (textEl) textEl.textContent = 'Click for sunglasses option'
      if (subEl) subEl.textContent = 'Switch back to non-Rx lenses'
      if (iconEl) iconEl.textContent = '🕶'
    } else {
      rxToggle.classList.add('sunglasses')
      rxToggle.classList.remove('rx')
      if (textEl) textEl.textContent = 'Click to add prescription'
      if (subEl) subEl.textContent = ''
      if (iconEl) iconEl.textContent = '👓'
    }
    syncPdpOptionsIncluded(product || window.pdp.currentProduct)
  }

  function syncRxToggleIncludedFeatures(product) {
    // Back-compat alias — included rows are type-owned now.
    syncPdpOptionsIncluded(product)
  }

  function z87DoorwayTitleForSunProduct(product) {
    const handle = product?.handle || ''
    const isXxl = handle.includes('-xxl') || /\bXXL\b/i.test(product?.title || '')
    const isXl = !isXxl && (handle.includes('-xl') || /\bXL\b/i.test(product?.title || ''))
    let name = String(product?.title || '')
      .replace(/\s*Z87\+?/gi, '')
      .replace(/\s*XXL\b/gi, '')
      .replace(/\s*XL\b/gi, '')
      .trim()
    const sizeBit = isXxl ? 'XXL ' : isXl ? 'XL ' : ''
    return 'Click for ' + sizeBit + name + ' Z87+ Safety'
  }

  function ensureZ87DoorwayRow(lensbox, { handle, title, sub }) {
    if (!canSeeSafetyZ87()) return null
    if (!lensbox || !handle) return null
    let row = lensbox.querySelector('[data-z87-doorway]')
    if (!row) {
      row = document.createElement('a')
      row.className = 'rx-toggle-lensrow rx-toggle-action rx-toggle-z87'
      row.setAttribute('data-z87-doorway', '')
      row.setAttribute('data-pdp-switch-kind', 'safety-sun')
      row.innerHTML =
        '<span class="rx-toggle-ic" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3 4.5 6v6c0 4.4 3.1 7.9 7.5 9 4.4-1.1 7.5-4.6 7.5-9V6L12 3Z"/><path d="m9.2 12.1 2 2 3.6-3.9"/></svg>' +
        '</span>' +
        '<span class="rx-toggle-tx"><b data-z87-doorway-title></b><span data-z87-doorway-sub></span></span>' +
        '<span class="rx-toggle-chev" aria-hidden="true">›</span>'
      const rxAction = lensbox.querySelector('.rx-toggle-action:not([data-z87-doorway])')
      if (rxAction) lensbox.insertBefore(row, rxAction)
      else lensbox.appendChild(row)
    }
    bindSafetySunDoorway(row, handle)
    const titleEl = row.querySelector('[data-z87-doorway-title]')
    const subEl = row.querySelector('[data-z87-doorway-sub]')
    if (titleEl && title) titleEl.textContent = title
    if (subEl && sub) subEl.textContent = sub
    return row
  }

  function productHasTag(product, needle) {
    const want = String(needle || '').toLowerCase()
    const pools = [product?.tags]
    if (product?.handle) {
      const fromCol = (window.pdp.mainCollectionProducts || []).find((p) => p.handle === product.handle)
      if (fromCol?.tags) pools.push(fromCol.tags)
      if (window.pdp.products?.[product.handle]?.tags) pools.push(window.pdp.products[product.handle].tags)
    }
    return pools.some((raw) =>
      normalizeProductTags(raw).some((tag) => String(tag).toLowerCase() === want)
    )
  }

  function sunglassesHasRxTag(product) {
    return productHasTag(product, '_sunglasses:has_rx')
  }

  function rememberZ87Handle(safetyHandle) {
    if (!safetyHandle) return
    if (!window.pdp._z87Exists) window.pdp._z87Exists = {}
    window.pdp._z87Exists[safetyHandle] = true
    window.pdp._lastSafetyHandle = safetyHandle
  }

  function rememberZ87FromDom() {
    document.querySelectorAll('[data-z87-doorway][data-pdp-switch-handle]').forEach((btn) => {
      rememberZ87Handle(btn.getAttribute('data-pdp-switch-handle'))
    })
  }

  const Z87_EXISTS_QUERY =
    'query Z87Exists($handle: String!) { product(handle: $handle) { handle productType } }'

  /** Storefront API: does a -z87 Safety product exist for this handle? Cached per page view. */
  function verifyZ87Exists(safetyHandle) {
    if (!safetyHandle) return Promise.resolve(false)
    if (window.pdp._z87Exists?.[safetyHandle]) return Promise.resolve(true)
    if (window.pdp._z87Missing?.[safetyHandle]) return Promise.resolve(false)
    if (!sepStorefrontEnabled()) return Promise.resolve(false)
    if (!window.pdp._z87Checks) window.pdp._z87Checks = {}
    if (window.pdp._z87Checks[safetyHandle]) return window.pdp._z87Checks[safetyHandle]
    const check = window.sepStorefront
      .graphql(Z87_EXISTS_QUERY, { handle: safetyHandle })
      .then((data) => {
        const p = data?.product
        const exists = !!p && p.handle === safetyHandle && p.productType === 'Safety'
        delete window.pdp._z87Checks[safetyHandle]
        if (exists) {
          if (!window.pdp._z87Exists) window.pdp._z87Exists = {}
          window.pdp._z87Exists[safetyHandle] = true
        } else {
          if (!window.pdp._z87Missing) window.pdp._z87Missing = {}
          window.pdp._z87Missing[safetyHandle] = true
        }
        return exists
      })
      .catch(() => {
        delete window.pdp._z87Checks[safetyHandle]
        return false
      })
    window.pdp._z87Checks[safetyHandle] = check
    return check
  }

  const RX_AVAILABLE_QUERY =
    'query RxAvailable($handle: String!) { product(handle: $handle) { handle productType availableForSale } }'

  /** Sunglasses → Rx counterpart: `legend` → `legend-rx`, `legend-xl` → `legend-xl-rx`. */
  function toRxHandle(handle) {
    if (!handle || /-rx$/.test(handle)) return handle || ''
    return handle + '-rx'
  }

  /** Storefront API: is the -rx Prescription product live and for sale? Cached per page view. */
  function verifyRxAvailable(rxHandle) {
    if (!rxHandle) return Promise.resolve(false)
    if (!window.pdp._rxAvailable) window.pdp._rxAvailable = {}
    if (rxHandle in window.pdp._rxAvailable) return Promise.resolve(window.pdp._rxAvailable[rxHandle])
    if (!window.pdp._rxChecks) window.pdp._rxChecks = {}
    if (window.pdp._rxChecks[rxHandle]) return window.pdp._rxChecks[rxHandle]
    // Ajax product JSON fallback when Storefront is off or errors (404 → no Rx version).
    const viaAjax = () =>
      fetch(`/products/${rxHandle}.js`).then((res) => {
        if (res.status === 404) return false
        if (!res.ok) throw new Error('rx check ' + res.status)
        return res.json().then((p) => !!p && p.handle === rxHandle && p.type === 'Prescription' && !!p.available)
      })
    const lookup = sepStorefrontEnabled()
      ? window.sepStorefront
          .graphql(RX_AVAILABLE_QUERY, { handle: rxHandle })
          .then((data) => {
            const p = data?.product
            return !!p && p.handle === rxHandle && p.productType === 'Prescription' && !!p.availableForSale
          })
          .catch(viaAjax)
      : viaAjax()
    const check = lookup
      .then((available) => {
        delete window.pdp._rxChecks[rxHandle]
        window.pdp._rxAvailable[rxHandle] = available
        return available
      })
      .catch(() => {
        delete window.pdp._rxChecks[rxHandle]
        return false
      })
    window.pdp._rxChecks[rxHandle] = check
    return check
  }

  /** Show the to_rx row (and "How Rx works") only once the frame's -rx product is confirmed for sale; drop it otherwise (e.g. Legend). */
  function syncSunglassesRxRow(optsEl, handle) {
    const lensbox = optsEl?.querySelector('[data-pdp-options-items], .rx-toggle-lensbox')
    if (!lensbox || !handle) return
    const rxHandle = toRxHandle(handle)
    const known = window.pdp._rxAvailable?.[rxHandle]
    const howLink = optsEl.querySelector('[data-rx-how-open]')
    if (howLink) howLink.hidden = known !== true
    if (known === false) {
      lensbox.querySelector('.rx-toggle-action:not([data-z87-doorway])')?.remove()
      return
    }
    const row = ensureRxActionRow(lensbox)
    row.setAttribute('data-pdp-options-item', 'to_rx')
    row.hidden = known !== true
    if (known === true) return
    verifyRxAvailable(rxHandle).then(() => {
      // A newer switch owns the card now; a failed check leaves the row hidden.
      if (!optsEl.isConnected || window.pdp.currentProduct?.handle !== handle) return
      if (rxHandle in window.pdp._rxAvailable) syncSunglassesRxRow(optsEl, handle)
    })
  }

  function z87KnownForRegular(product) {
    if (!product?.handle) return false
    const safetyHandle = toSafetyHandle(product.handle)
    if (window.pdp._z87Exists?.[safetyHandle]) return true
    if (window.pdp._lastSafetyHandle === safetyHandle) return true
    if (window.pdp._safetySunPair?.safety === safetyHandle) return true
    if (window.pdp._safetySunPair?.regular === product.handle) return true
    return !!document.querySelector(
      '.product__information_block.rx-toggle [data-z87-doorway][data-pdp-switch-handle="' +
        String(safetyHandle).replace(/\\/g, '\\\\').replace(/"/g, '\\"') +
        '"]'
    )
  }

  function ensureRxActionRow(lensbox) {
    if (!lensbox) return null
    let row = lensbox.querySelector('.rx-toggle-action:not([data-z87-doorway])')
    if (row) return row
    row = document.createElement('div')
    row.className = 'rx-toggle-lensrow rx-toggle-action'
    row.setAttribute('role', 'button')
    row.tabIndex = 0
    row.innerHTML =
      '<span class="rx-toggle-ic" aria-hidden="true">👓</span>' +
      '<span class="rx-toggle-tx">' +
      '<b class="rx-toggle-text">Click to add prescription</b>' +
      '<span class="rx-toggle-sub"></span>' +
      '</span>' +
      '<span class="rx-toggle-chev" aria-hidden="true">›</span>'
    lensbox.appendChild(row)
    return row
  }

  function nvzOptLog() {}

  /** Remove stale Safety OPTIONS left after switching to Sunglasses. Never touch live Safety card mid-switch. */
  function stripStaleSunSafetyOptionsBlocks() {
    const p = window.pdp.currentProduct
    const handle = p?.handle || ''
    const pending = window.pdp.pendingProductSwitch
    // Never strip while on / switching to Safety — that deletes the real Safety OPTIONS card.
    if (
      p?.product_type === 'Safety' ||
      p?.productType === 'Safety' ||
      /-z87$/.test(handle) ||
      (pending?.kind === 'safety' && /-z87$/.test(pending.targetKey || ''))
    ) {
      nvzOptLog('stripStale:skip', {
        reason: 'safety-context',
        handle,
        type: p?.product_type,
        pending
      })
      return
    }
    const before = document.querySelectorAll(
      '[data-safety-options-sun], .other-products-container [data-safety-options]'
    ).length
    document.querySelectorAll('[data-safety-options-sun]').forEach((el) => el.remove())

    document.querySelectorAll('.other-products-container [data-safety-options]').forEach((el) => {
      const container = el.closest('.other-products-container')
      if (!container) return
      // Hidden containers = previous mounts after size/type switch.
      if (container.classList.contains('hidden')) {
        el.remove()
        return
      }
      // Visible: only remove Safety OPTIONS if Sunglasses OPTIONS already present (duplicate).
      if (container.querySelector('[data-pdp-options-type="sunglasses"]')) {
        el.remove()
      }
    })

    const after = document.querySelectorAll(
      '[data-safety-options-sun], .other-products-container [data-safety-options]'
    ).length
    if (before || after) nvzOptLog('stripStale', { before, after, pt: p?.product_type })
  }

  function cancelForceRevealSunglassesOptions() {
    window.pdp._forceRevealGen = (window.pdp._forceRevealGen || 0) + 1
    ;(window.pdp._forceRevealTimers || []).forEach((id) => clearTimeout(id))
    window.pdp._forceRevealTimers = []
    nvzOptLog('forceReveal:cancel', { gen: window.pdp._forceRevealGen })
  }

  function hideInjectedSunglassesOptions() {
    // Only injected fallbacks — never hide Liquid Options inside other-products.
    document.querySelectorAll('[data-rx-toggle-injected]').forEach((el) => {
      el.classList.add('hidden')
      el.classList.remove('is-busy')
    })
  }

  function revealSafetyOptionsAfterSwitch(targetHandle) {
    cancelForceRevealSunglassesOptions()
    hideInjectedSunglassesOptions()
    const gen = window.pdp._forceRevealGen || 0
    const run = (label) => {
      if (gen !== window.pdp._forceRevealGen) return
      const p = window.pdp.currentProduct
      if (!p || (targetHandle && p.handle !== targetHandle)) {
        nvzOptLog('safetyOpts:' + label, { ok: false, reason: 'handle-mismatch', got: p?.handle })
        return
      }
      if (p.product_type !== 'Safety' && !/-z87$/.test(p.handle || '')) {
        nvzOptLog('safetyOpts:' + label, { ok: false, reason: 'not-safety' })
        return
      }
      hideInjectedSunglassesOptions()
      const visible = document.querySelector('.other-products-container:not(.hidden)')
      const opts = visible?.querySelector('[data-safety-options]')
      nvzOptLog('safetyOpts:' + label, {
        ok: !!opts,
        hasLens: !!visible?.querySelector('[data-safety-lens-inline]'),
        hasShields: !!visible?.querySelector('[data-safety-shields-json]')
      })
      if (opts) {
        initSafetyShieldsUi()
        syncSafetyLensTypeButtons(window.pdp.selectedVariant)
      }
    }
    run('now')
    requestAnimationFrame(() => {
      run('raf')
      const t1 = setTimeout(() => run('50ms'), 50)
      const t2 = setTimeout(() => run('200ms'), 200)
      const t3 = setTimeout(() => run('500ms'), 500)
      window.pdp._forceRevealTimers = [t1, t2, t3]
    })
  }

  function isSunglassesPdpProduct(product) {
    if (!product) return false
    const t = product.product_type || product.productType || ''
    if (t === 'Sunglasses') return true
    // Mid-switch Storefront payloads sometimes omit type — infer from handle.
    const h = product.handle || ''
    return !!(h && !/-z87$/.test(h) && !/-rx$/.test(h) && t !== 'Safety' && t !== 'Prescription' && t !== 'Ophthalmic')
  }

  function ensureRxToggleDom() {
    let rx = getVisibleRxToggle()
    if (rx) return rx

    // Drop injected nodes stuck in hidden other-products mounts.
    document.querySelectorAll('[data-rx-toggle-injected]').forEach((el) => {
      const parent = el.closest('.other-products-container')
      if (parent?.classList.contains('hidden')) el.remove()
    })

    rx = document.querySelector('.product__information_block.rx-toggle[data-rx-toggle-injected]')
    if (rx) {
      rx.classList.remove('hidden', 'is-busy')
      return rx
    }

    nvzOptLog('ensureRxToggleDom:create', {})
    rx = document.createElement('div')
    rx.className = 'product__information_block rx-toggle sunglasses'
    rx.setAttribute('data-rx-toggle-injected', '1')
    rx.setAttribute('data-pdp-options', '')
    rx.setAttribute('data-pdp-options-type', 'sunglasses')
    rx.innerHTML =
      '<div class="rx-toggle-lab">' +
      '<span class="rx-toggle-lab-title">Options</span>' +
      '<button type="button" class="rx-toggle-lab-link" data-rx-how-open aria-haspopup="dialog">How Rx works</button>' +
      '</div>' +
      '<div class="rx-toggle-lensbox" data-pdp-options-items></div>'

    const visible = getVisibleOtherProductsContainer()
    const info = document.querySelector('.product__information')
    const other = document.querySelector('.product__information_block.other-products')
    const freeship = document.querySelector('.product__information_block.freeshipping, .product__information .sep-perks')
    if (visible) {
      visible.appendChild(rx)
    } else if (other && other.parentNode) {
      other.insertAdjacentElement('afterend', rx)
    } else if (freeship && freeship.parentNode) {
      freeship.insertAdjacentElement('beforebegin', rx)
    } else if (info) {
      info.appendChild(rx)
    } else {
      nvzOptLog('ensureRxToggleDom:fail', { reason: 'no-mount-point' })
      return null
    }

    // Bind How Rx modal if present elsewhere on page; otherwise click is harmless.
    const modal = document.getElementById('rx-how-works-modal')
    const openBtn = rx.querySelector('[data-rx-how-open]')
    if (modal && openBtn && openBtn.dataset.nvzBound !== '1') {
      openBtn.dataset.nvzBound = '1'
      openBtn.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        modal.hidden = false
        document.documentElement.style.overflow = 'hidden'
      })
    }

    nvzOptLog('ensureRxToggleDom:mounted', {
      afterOther: !!other,
      inVisible: !!visible,
      className: rx.className
    })
    return rx
  }

  function paintSunglassesOptionsCard(product, showZ87) {
    const rxToggle = ensureRxToggleDom()
    nvzOptLog('paint:enter', {
      showZ87,
      productHandle: product?.handle,
      productType: product?.product_type || product?.productType,
      isSun: isSunglassesPdpProduct(product),
      hasRxToggle: !!rxToggle,
      injected: rxToggle?.hasAttribute('data-rx-toggle-injected')
    })
    if (!rxToggle || !product) {
      nvzOptLog('paint:abort', { reason: !rxToggle ? 'no-rx-toggle-in-dom' : 'no-product' })
      return
    }
    if (!isSunglassesPdpProduct(product) && product.product_type !== 'Sunglasses') {
      nvzOptLog('paint:abort', { reason: 'not-sunglasses', type: product.product_type || product.productType })
      return
    }

    stripStaleSunSafetyOptionsBlocks()
    const lensbox = rxToggle.querySelector('.rx-toggle-lensbox')
    if (!lensbox) {
      nvzOptLog('paint:abort', { reason: 'no-lensbox' })
      return
    }

    const safetyHandle = toSafetyHandle(product.handle)
    const title = z87DoorwayTitleForSunProduct(product)

    const allowZ87 = canSeeSafetyZ87() && !!showZ87

    if (allowZ87) {
      rememberZ87Handle(safetyHandle)
      ensureZ87DoorwayRow(lensbox, {
        handle: safetyHandle,
        title,
        sub: 'ANSI Z87+ high impact'
      })
    } else {
      stripZ87DoorwayIfGated(lensbox)
    }

    syncSunglassesRxRow(rxToggle, product.handle)
    const z87Row = lensbox.querySelector('[data-z87-doorway]')
    if (z87Row) z87Row.setAttribute('data-pdp-options-item', 'to_z87')
    const included = lensbox.querySelector('.rx-toggle-lensrow--included, [data-pdp-options-included]')
    if (included) included.setAttribute('data-pdp-options-item', 'included_lens_features')

    // Sunglasses-type static included only (never Safety shields copy).
    syncPdpOptionsIncluded({ ...product, product_type: 'Sunglasses' })

    updateRxToggleUI(false, { ...product, product_type: 'Sunglasses' })

    // Always reveal — never leave Safety's .hidden stuck on.
    rxToggle.classList.remove('hidden')
    rxToggle.classList.remove('is-busy')
    rxToggle.classList.add('sunglasses')
    rxToggle.classList.remove('rx')

    nvzOptLog('paint:done', {
      showZ87,
      safetyHandle,
      stillHidden: rxToggle.classList.contains('hidden'),
      computedDisplay: getComputedStyle(rxToggle).display,
      parentHidden: !!rxToggle.closest('.hidden'),
      rowCount: rxToggle.querySelectorAll('.rx-toggle-lensrow').length
    })
  }

  function rebuildSunglassesOptionsCard(product) {
    nvzOptLog('rebuild:enter', {
      productHandle: product?.handle,
      productType: product?.product_type || product?.productType,
      isSun: isSunglassesPdpProduct(product)
    })
    if (!product || !isSunglassesPdpProduct(product)) {
      nvzOptLog('rebuild:abort', { reason: 'not-sunglasses-product' })
      return
    }
    const rxToggle = ensureRxToggleDom()
    if (!rxToggle) {
      nvzOptLog('rebuild:abort', { reason: 'no-rx-toggle-in-dom' })
      return
    }

    const safetyHandle = toSafetyHandle(product.handle)
    const gen = (window.pdp._optionsRebuildGen = (window.pdp._optionsRebuildGen || 0) + 1)

    // After Z87 → regular, show Z87 row only for staff (@neveneyewear.com).
    const forceZ87 =
      canSeeSafetyZ87() &&
      (z87KnownForRegular(product) ||
        window.pdp._safetySunPair?.regular === product.handle ||
        window.pdp._lastSafetyHandle === safetyHandle ||
        window.pdp.pendingProductSwitch?.kind === 'safety' ||
        !!rxToggle.querySelector('[data-z87-doorway]'))

    nvzOptLog('rebuild:forceZ87', {
      forceZ87,
      canSeeZ87: canSeeSafetyZ87(),
      known: z87KnownForRegular(product),
      pairRegular: window.pdp._safetySunPair?.regular,
      lastSafety: window.pdp._lastSafetyHandle,
      pendingKind: window.pdp.pendingProductSwitch?.kind
    })

    paintSunglassesOptionsCard(product, !!forceZ87)
  }

  function forceRevealSunglassesOptionsAfterSafetySwitch(targetHandle) {
    cancelForceRevealSunglassesOptions()
    const gen = (window.pdp._forceRevealGen = (window.pdp._forceRevealGen || 0) + 1)
    nvzOptLog('forceReveal:schedule', { targetHandle, gen })
    const run = (label) => {
      if (gen !== window.pdp._forceRevealGen) {
        nvzOptLog('forceReveal:' + label, { ok: false, reason: 'cancelled' })
        return false
      }
      const p = window.pdp.currentProduct
      if (!p || (targetHandle && p.handle !== targetHandle)) {
        nvzOptLog('forceReveal:' + label, {
          ok: false,
          reason: 'handle-mismatch',
          want: targetHandle,
          got: p?.handle
        })
        return false
      }
      if (/-z87$/.test(p.handle || '') || p.product_type === 'Safety') {
        nvzOptLog('forceReveal:' + label, { ok: false, reason: 'on-safety-abort' })
        return false
      }
      rememberZ87Handle(toSafetyHandle(p.handle))
      const rx = ensureRxToggleDom()
      if (!rx) {
        nvzOptLog('forceReveal:' + label, { ok: false, reason: 'no-rx-toggle-in-dom' })
        return false
      }
      paintSunglassesOptionsCard(
        { ...p, product_type: p.product_type || p.productType || 'Sunglasses' },
        canSeeSafetyZ87()
      )
      const ok = !rx.classList.contains('hidden') && getComputedStyle(rx).display !== 'none'
      nvzOptLog('forceReveal:' + label, {
        ok,
        display: getComputedStyle(rx).display,
        rowCount: rx.querySelectorAll('.rx-toggle-lensrow').length
      })
      return ok
    }
    run('now')
    requestAnimationFrame(() => {
      run('raf')
      const t1 = setTimeout(() => run('50ms'), 50)
      const t2 = setTimeout(() => run('200ms'), 200)
      const t3 = setTimeout(() => run('500ms'), 500)
      window.pdp._forceRevealTimers = [t1, t2, t3]
    })
  }

  function syncZ87DoorwayInRxToggle(product) {
    if (!canSeeSafetyZ87()) {
      stripZ87DoorwayIfGated()
      if (isSunglassesPdpProduct(product)) rebuildSunglassesOptionsCard(product)
      return
    }
    if (isSunglassesPdpProduct(product)) {
      rebuildSunglassesOptionsCard(product)
      return
    }
    const rxToggle = document.querySelector('.product__information_block.rx-toggle')
    if (!rxToggle) return
    const lensbox = rxToggle.querySelector('.rx-toggle-lensbox')
    if (!lensbox) return

    if (product?.product_type === 'Safety' || product?.productType === 'Safety') {
      rememberZ87Handle(product.handle)
      window.pdp._safetySunPair = {
        safety: product.handle,
        regular: toRegularHandle(product.handle)
      }
      ensureRxActionRow(lensbox)
      ensureZ87DoorwayRow(lensbox, {
        handle: product.handle,
        title: z87DoorwayTitleForSunProduct({
          handle: toRegularHandle(product.handle),
          title: product.title
        }),
        sub: 'ANSI Z87+ high impact'
      })
      return
    }

    const existing = lensbox.querySelector('[data-z87-doorway]')
    if (existing && !rxToggle.hasAttribute('data-rx-toggle-safety-shell')) existing.remove()
  }

  function syncVisibleAtcBlocks(productId) {
    const id = productId != null
      ? String(productId)
      : String(window.pdp.currentProduct?.id || '')
    if (!id) return
    document.querySelectorAll('.product__information > .product__information_block.atc').forEach((atc) => {
      if (atc.classList.contains('rx-config-modal__atc')) return
      atc.classList.toggle('hidden', String(atc.getAttribute('product_id')) !== id)
    })
  }

  // Keep server-rendered block order; do not reorder on RX <-> sunglasses toggle.
  function syncPdpBlockOrderForProductType(_productType) {}

  function placeRxToggleForProductType(_productType) {}

  function hasJudgemeHtmlCache(handle) {
    return !!(handle && window.pdp.judgemeHtmls && Object.prototype.hasOwnProperty.call(window.pdp.judgemeHtmls, handle))
  }

  function getJudgemeBadgeRoot() {
    return (
      document.querySelector('.product__information > .pdp-lead .product__information_block.judgeme-badge') ||
      document.querySelector('.product__information .product__information_block.judgeme-badge')
    )
  }

  function applyJudgemeBadgeForHandle(handle) {
    if (!hasJudgemeHtmlCache(handle)) return false
    const badgeRoot = getJudgemeBadgeRoot()
    if (!badgeRoot) return false

    const html = window.pdp.judgemeHtmls[handle] || ''
    const div = new DOMParser().parseFromString(html, 'text/html')
    const wrap = div.querySelector('.jdgm-prev-badge')
    const widget = div.querySelector('.jdgm-widget.jdgm-preview-badge')
    const container = badgeRoot.querySelector('.reviews-badge-container') || badgeRoot
    const existingWidget = container.querySelector('.jdgm-widget.jdgm-preview-badge')
    const existingWrap = container.querySelector('.jdgm-prev-badge')

    // No reviews / empty badge HTML for this product
    if (!wrap || !wrap.querySelector('.jdgm-prev-badge__stars')) {
      badgeRoot.classList.add('hidden')
      if (typeof window.syncGalleryPdpLead === 'function') window.syncGalleryPdpLead()
      return true
    }

    badgeRoot.classList.remove('hidden')
    // Replace whole widget/badge so data-id + data-number-of-reviews stay in sync
    // (partial star swap left stale attrs; formatSepDesignReviewBadge then overwrote count)
    if (widget && existingWidget) {
      existingWidget.outerHTML = widget.outerHTML
    } else if (existingWrap) {
      existingWrap.outerHTML = wrap.outerHTML
    } else if (widget) {
      container.insertAdjacentHTML('afterbegin', widget.outerHTML)
    } else {
      container.insertAdjacentHTML('afterbegin', wrap.outerHTML)
    }

    const liveWrap = container.querySelector('.jdgm-prev-badge')
    const textElement = liveWrap?.querySelector('.jdgm-prev-badge__text')
    if (liveWrap && textElement) {
      const reviewCount = liveWrap.getAttribute('data-number-of-reviews') || '0'
      textElement.textContent = `(${Number(reviewCount).toLocaleString('en-US')})`
    }
    if (typeof window.formatSepDesignReviewBadge === 'function') {
      window.formatSepDesignReviewBadge()
    }
    if (typeof window.syncGalleryPdpLead === 'function') window.syncGalleryPdpLead()
    return true
  }

  function ensureJudgemeHtmlForHandle(handle) {
    if (!handle) return Promise.resolve()
    if (!window.pdp.judgemeHtmls) window.pdp.judgemeHtmls = {}
    if (hasJudgemeHtmlCache(handle)) return Promise.resolve()
    if (!window.pdp._judgemeEnsurePromises) window.pdp._judgemeEnsurePromises = {}
    if (window.pdp._judgemeEnsurePromises[handle]) return window.pdp._judgemeEnsurePromises[handle]

    const promise = fetchSectionHtml(`/products/${handle}?section_id=sep-pdp-judgeme`)
      .then((data) => {
        const div = new DOMParser().parseFromString(data, 'text/html')
        const p = div.querySelector('#shopify-section-sep-pdp-judgeme judgeme, judgeme, #shopify-section-sep-pdp-judgeme')
        window.pdp.judgemeHtmls[handle] = p ? p.innerHTML : ''
      })
      .catch(() => {})
      .finally(() => {
        delete window.pdp._judgemeEnsurePromises[handle]
      })

    window.pdp._judgemeEnsurePromises[handle] = promise
    return promise
  }

  // Size family: std / xl / xxl. Always check -xxl before -xl (substring trap).
  function getSizeKeyFromHandle(handle) {
    if (!handle) return 'std'
    if (handle.includes('-xxl')) return 'xxl'
    if (handle.includes('-xl')) return 'xl'
    return 'std'
  }

  function getSizeBaseHandle(handle) {
    if (!handle) return ''
    return handle
      .replace('-xxl-rx', '-rx')
      .replace('-xl-rx', '-rx')
      .replace('-xxl-z87', '-z87')
      .replace('-xl-z87', '-z87')
      .replace('-xxl', '')
      .replace('-xl', '')
  }

  function getSizeHandleForKey(baseHandle, sizeKey) {
    if (!baseHandle) return ''
    const isRx = baseHandle.includes('-rx')
    const isZ87 = /-z87$/.test(baseHandle)
    if (sizeKey === 'std') return baseHandle
    if (sizeKey === 'xl') {
      if (isRx) return baseHandle.replace('-rx', '-xl-rx')
      if (isZ87) return baseHandle.replace(/-z87$/, '-xl-z87')
      return baseHandle + '-xl'
    }
    if (sizeKey === 'xxl') {
      if (isRx) return baseHandle.replace('-rx', '-xxl-rx')
      if (isZ87) return baseHandle.replace(/-z87$/, '-xxl-z87')
      return baseHandle + '-xxl'
    }
    return baseHandle
  }

  function getSizeFamilyHandles(handle) {
    const base = getSizeBaseHandle(handle)
    const isZ87 = /-z87$/.test(base)
    return {
      base,
      current: getSizeKeyFromHandle(handle),
      std: getSizeHandleForKey(base, 'std'),
      xl: getSizeHandleForKey(base, 'xl'),
      xxl: isZ87 ? '' : getSizeHandleForKey(base, 'xxl')
    }
  }

  function getSizeCounterpartHandle(handle) {
    const family = getSizeFamilyHandles(handle)
    if (family.current === 'std') return family.xl
    return family.std
  }

  /** Safety ↔ regular sunglasses handle map (size stays; `-z87` suffix only). */
  function toRegularHandle(handle) {
    if (!handle) return ''
    return handle
      .replace(/-xxl-z87$/, '-xxl')
      .replace(/-xl-z87$/, '-xl')
      .replace(/-z87$/, '')
  }

  function toSafetyHandle(handle) {
    if (!handle) return ''
    if (/-z87$/.test(handle)) return handle
    return handle + '-z87'
  }

  function pdpProductHref(handle) {
    return handle ? '/products/' + handle : ''
  }

  function bindSafetySunDoorway(el, handle) {
    if (!el || !handle) return
    el.setAttribute('data-pdp-switch-handle', handle)
    el.setAttribute('data-pdp-switch-kind', 'safety-sun')
    if (el.tagName === 'A') el.setAttribute('href', pdpProductHref(handle))
  }

  function syncSafetyRegularSunDoorway(product) {
    if (!product || !isSafetyPdpProduct(product)) return
    const regularHandle = toRegularHandle(product.handle)
    const key = getSizeKeyFromHandle(product.handle)
    const sizeWord = key === 'xxl' ? 'XXL ' : key === 'xl' ? 'XL ' : ''
    document.querySelectorAll('[data-pdp-options-item="to_regular_sun"]').forEach((btn) => {
      if (regularHandle) bindSafetySunDoorway(btn, regularHandle)
      const title = btn.querySelector('.nvz-tx > b')
      if (!title) return
      title.textContent = String(title.textContent || '').replace(
        /^Click for regular (?:XXL |XL )?/i,
        'Click for regular ' + sizeWord
      )
    })
  }

  function pdpVisibleTitleHtml(title, productType) {
    const raw = String(title || '')
    const safetyTitle =
      productType === 'Safety' ||
      !!document.querySelector('.sep-design-pdp.is-side-shield-pdp')
    if (!safetyTitle || !/Z87/i.test(raw)) return raw
    const visible = raw.replace(/\s*Z87\+?/gi, '').replace(/\s+/g, ' ').trim()
    return visible + '<span class="offscreen">Z87+</span>'
  }

  function normalizeProductTags(tags) {
    if (Array.isArray(tags)) return tags
    if (typeof tags === 'string') {
      return tags.split(',').map(tag => tag.trim()).filter(Boolean)
    }
    return []
  }

  function updateSepPerkFeatures(product) {
    const sepPerks = document.querySelector('.product__information_block.sep-perks')
    if (!sepPerks || !product) return

    const isSunglasses = product.product_type === 'Sunglasses'
    const isSafety = product.product_type === 'Safety'
    const isPrescription = product.product_type === 'Prescription'
    const isOphthalmic =
      typeof window.isOphthalmicPdpProduct === 'function'
        ? window.isOphthalmicPdpProduct(product)
        : product.product_type === 'Ophthalmic'
    const showShip3 = isPrescription || isOphthalmic
    const useSunglassesPerks = isSunglasses || isSafety
    sepPerks.querySelector('[data-perk="sunglasses"]')?.classList.toggle('hidden', !useSunglassesPerks)
    sepPerks.querySelector('[data-perk="prescription"]')?.classList.toggle('hidden', !showShip3)
    sepPerks.querySelector('[data-perk="default"]')?.classList.toggle('hidden', useSunglassesPerks || showShip3)
  }

  function getPdpSizeSelectorElement() {
    const visibleContainer = document.querySelector('.other-products-container:not(.hidden)')
    return visibleContainer?.querySelector('[data-size-selector]') ||
      document.querySelector('[data-size-selector]')
  }

  function getFrameTagValues(tags) {
    const values = { width: '', size: '' }
    normalizeProductTags(tags).forEach(tag => {
      const value = String(tag)
      if (value.includes('_frame_width:')) {
        values.width = value.replace('_frame_width:', '').replace('number:', '')
      } else if (value.includes('_frame_size:')) {
        values.size = value.replace('_frame_size:', '').replace(/_/g, ' ')
      }
    })
    return values
  }

  function frameTagsFromProductOrDataset(product, sizeSelector, sizeKey) {
    if (product?.handle) return getFrameTagValues(product.tags)
    const width =
      sizeKey === 'xxl'
        ? sizeSelector.dataset.xxlWidth || ''
        : sizeKey === 'xl'
          ? sizeSelector.dataset.xlWidth || ''
          : sizeSelector.dataset.stdWidth || ''
    const size = sizeKey === 'std' ? sizeSelector.dataset.stdSize || '' : ''
    return { width, size }
  }

  function fitTagValue(tags, key, rxKey) {
    let value = ''
    normalizeProductTags(tags).forEach((raw) => {
      const tag = String(raw)
      if (rxKey && tag.indexOf(rxKey) === 0) value = tag.slice(rxKey.length)
      else if (tag.indexOf(key) === 0) value = tag.slice(key.length)
    })
    return value.replace(/^number:/, '').trim()
  }

  function getFitDimsFromTags(tags) {
    return {
      frame: fitTagValue(tags, '_frame_width:', '_rx_frame_width:'),
      lensW: fitTagValue(tags, '_lens_width:', '_rx_lens_width:'),
      lensH: fitTagValue(tags, '_lens_height:', '_rx_lens_height:'),
      bridge: fitTagValue(tags, '_bridge_width:', '_rx_bridge_width:'),
      temple: fitTagValue(tags, '_temple_length:', '_rx_temple_length:')
    }
  }

  function formatFitMm(value) {
    const s = String(value || '').trim()
    if (!s) return '—'
    return /mm$/i.test(s) ? s : s + 'mm'
  }

  function formatFitLens(w, h) {
    const a = String(w || '').trim()
    const b = String(h || '').trim()
    if (!a && !b) return '—'
    return a + ' × ' + b
  }

  function isZ87FitProduct(product) {
    if (!product) return false
    if (product.product_type === 'Safety') return true
    return /-z87(?:-|$)/.test(product.handle || '')
  }

  function rememberFitFamily(byKey, fromFetch) {
    if (!window.pdp.fitFamily) window.pdp.fitFamily = { std: null, xl: null, xxl: null }
    ;['std', 'xl', 'xxl'].forEach((key) => {
      if (byKey && byKey[key] && byKey[key].handle) window.pdp.fitFamily[key] = byKey[key]
    })
    if (fromFetch) {
      window.pdp.fitFamilyPainted = true
      paintPdpFitModal()
    }
  }

  function paintPdpFitModal() {
    const modal = document.getElementById('pdp-fit-modal')
    const tb = modal && modal.querySelector('[data-fit-rows]')
    if (!tb) return
    const product = window.pdp.currentProduct
    if (!product || !product.handle) return
    const family = getSizeFamilyHandles(product.handle)
    const fam = window.pdp.fitFamily || {}
    const pick = (key, handle) => {
      if (!handle) return null
      if (product.handle === handle) return product
      if (fam[key] && fam[key].handle === handle) return fam[key]
      return null
    }
    const stdP = pick('std', family.std)
    const xlP = pick('xl', family.xl)
    const xxlP = pick('xxl', family.xxl)
    const z87 = isZ87FitProduct(product)
    const rows = [
      { key: 'std', label: 'Standard', product: stdP, off: false },
      { key: 'xl', label: 'XL', product: xlP, off: false }
    ]
    if (xxlP && xxlP.handle && !z87) {
      rows.push({ key: 'xxl', label: 'XXL', product: xxlP, off: false })
    } else if (z87) {
      rows.push({ key: 'xxl', label: 'XXL', product: null, off: true, frame: '157' })
    }
    tb.innerHTML = rows
      .map((row) => {
        const dims = getFitDimsFromTags(row.product && row.product.tags)
        const frame = row.off ? formatFitMm(row.frame || '157') : formatFitMm(dims.frame)
        const lens = row.off ? '—' : formatFitLens(dims.lensW, dims.lensH)
        const bridge = row.off ? '—' : formatFitMm(dims.bridge)
        return (
          '<tr' +
          (row.off ? ' class="is-off"' : '') +
          ' data-fit-row="' +
          row.key +
          '"><td>' +
          row.label +
          '</td><td data-fit-cell="frame">' +
          frame +
          '</td><td data-fit-cell="lens">' +
          lens +
          '</td><td data-fit-cell="bridge">' +
          bridge +
          '</td></tr>'
        )
      })
      .join('')
    const note = modal.querySelector('[data-fit-note]')
    if (note) {
      const temple =
        getFitDimsFromTags(stdP && stdP.tags).temple ||
        getFitDimsFromTags(xlP && xlP.tags).temple ||
        '135'
      const templeMm = formatFitMm(temple)
      if (z87) {
        note.textContent =
          'Temple length is ' +
          templeMm +
          ' on both. XXL runs 157mm but there is no Z87+ XXL yet — the regular line has it.'
      } else {
        note.textContent = 'Temple length is ' + templeMm + ' on both.'
      }
    }
  }

  function roundWidthMm(width) {
    if (width == null || width === '') return ''
    const n = Number.parseFloat(String(width).replace(/[^\d.-]/g, ''))
    if (!Number.isFinite(n)) return ''
    return String(Math.round(n))
  }

  function sizeSelectorHelpText(sizeKey, width) {
    const mm = roundWidthMm(width)
    const prefix = sizeKey === 'xl' ? 'For wider faces' : sizeKey === 'xxl' ? 'Our widest frame yet' : 'Our everyday fit'
    if (mm) return `${prefix} — ${mm}mm.`
    return `${prefix}.`
  }

  function buildPdpSizeSelectorCopy(stdWidth, stdSize, xlWidth, xxlWidth) {
    const stdMm = roundWidthMm(stdWidth)
    const xlMm = roundWidthMm(xlWidth)
    const xxlMm = roundWidthMm(xxlWidth)
    return {
      stdTitle: 'Standard',
      stdLabel: stdMm ? `Standard · ${stdMm}mm` : 'Standard',
      stdDesc: stdMm ? `${stdMm}mm` : '',
      stdHelp: sizeSelectorHelpText('std', stdWidth),
      xlTitle: 'XL',
      xlLabel: xlMm ? `XL · ${xlMm}mm` : 'XL',
      xlDesc: xlMm ? `${xlMm}mm` : '',
      xlHelp: sizeSelectorHelpText('xl', xlWidth),
      xxlTitle: 'XXL',
      xxlLabel: xxlMm ? `XXL · ${xxlMm}mm` : 'XXL',
      xxlDesc: xxlMm ? `${xxlMm}mm` : '',
      xxlHelp: sizeSelectorHelpText('xxl', xxlWidth)
    }
  }

  function productHasNewSizeBadge(product) {
    return normalizeProductTags(product?.tags).some((tag) => String(tag) === '_size_badge:new')
  }

  function sizeKeyHasNewBadge(product, sizeSelector, sizeKey, fromFetch) {
    if (product?.handle) return productHasNewSizeBadge(product)
    if (fromFetch) return false
    if (sizeKey === 'xxl') return sizeSelector.dataset.xxlBadgeNew === 'true'
    if (sizeKey === 'xl') return sizeSelector.dataset.xlBadgeNew === 'true'
    return sizeSelector.dataset.stdBadgeNew === 'true'
  }

  function syncSizeSelectorNewBadge(btn, show) {
    let badge = btn.querySelector('.pdp-size-selector__new')
    if (show) {
      if (!badge) {
        badge = document.createElement('span')
        badge.className = 'pdp-size-selector__new'
        badge.textContent = 'NEW'
        btn.prepend(badge)
      }
      return
    }
    if (badge) badge.remove()
  }

  function applyPdpSizeSelectorState(sizeSelector, currentProduct, sizeProductsByKey) {
    if (!sizeSelector || !currentProduct?.handle) return

    const family = getSizeFamilyHandles(currentProduct.handle)
    const byKey = Object.assign(
      { std: null, xl: null, xxl: null },
      sizeProductsByKey || {}
    )
    byKey[family.current] = currentProduct

    const omitXxl =
      currentProduct.product_type === 'Safety' || /-z87$/.test(currentProduct.handle || '')
    const hasXxl = omitXxl
      ? false
      : !!(byKey.xxl && byKey.xxl.handle) || sizeSelector.dataset.hasXxl === 'true'
    sizeSelector.dataset.hasXxl = hasXxl ? 'true' : 'false'
    sizeSelector.classList.toggle('pdp-size-selector--tri', hasXxl)

    const stdTags = frameTagsFromProductOrDataset(byKey.std, sizeSelector, 'std')
    const xlTags = frameTagsFromProductOrDataset(byKey.xl, sizeSelector, 'xl')
    const xxlTags = frameTagsFromProductOrDataset(byKey.xxl, sizeSelector, 'xxl')
    const copy = buildPdpSizeSelectorCopy(
      stdTags.width,
      stdTags.size,
      xlTags.width,
      xxlTags.width
    )

    sizeSelector.dataset.stdHandle = family.std
    sizeSelector.dataset.xlHandle = family.xl
    sizeSelector.dataset.xxlHandle = family.xxl
    sizeSelector.dataset.stdWidth = stdTags.width
    sizeSelector.dataset.stdSize = stdTags.size
    sizeSelector.dataset.xlWidth = xlTags.width
    sizeSelector.dataset.xxlWidth = xxlTags.width
    if (byKey.std?.handle) {
      sizeSelector.dataset.stdBadgeNew = productHasNewSizeBadge(byKey.std) ? 'true' : 'false'
    }
    if (byKey.xl?.handle) {
      sizeSelector.dataset.xlBadgeNew = productHasNewSizeBadge(byKey.xl) ? 'true' : 'false'
    }
    if (byKey.xxl?.handle) {
      sizeSelector.dataset.xxlBadgeNew = productHasNewSizeBadge(byKey.xxl) ? 'true' : 'false'
    }

    const fromFetch = !!sizeProductsByKey
    const configs = [
      { key: 'std', title: copy.stdTitle, label: copy.stdLabel, desc: copy.stdDesc, help: copy.stdHelp },
      { key: 'xl', title: copy.xlTitle, label: copy.xlLabel, desc: copy.xlDesc, help: copy.xlHelp },
      { key: 'xxl', title: copy.xxlTitle, label: copy.xxlLabel, desc: copy.xxlDesc, help: copy.xxlHelp }
    ]

    configs.forEach(({ key, title, label, desc, help }) => {
      const btn = sizeSelector.querySelector(`[data-size="${key}"]`)
      if (!btn) return
      if (sizeProductsByKey) {
        const available = !!(byKey[key] && byKey[key].handle)
        btn.classList.toggle('hidden', !available)
      }
      btn.classList.toggle('on', family.current === key)
      btn.dataset.label = label
      btn.dataset.help = help
      const titleEl = btn.querySelector('.pdp-size-selector__t')
      const descEl = btn.querySelector('.pdp-size-selector__d')
      if (titleEl) titleEl.textContent = title
      if (descEl) {
        descEl.textContent = desc || ''
        descEl.hidden = !desc
      }
      syncSizeSelectorNewBadge(btn, sizeKeyHasNewBadge(byKey[key], sizeSelector, key, fromFetch))
    })

    const visibleCount = configs.filter(({ key }) => {
      const btn = sizeSelector.querySelector(`[data-size="${key}"]`)
      return btn && !btn.classList.contains('hidden')
    }).length
    const seg = sizeSelector.querySelector('.pdp-size-selector__seg')
    if (seg) seg.dataset.n = String(visibleCount)

    if (!sizeSelector.querySelector('.pdp-size-selector__help')) {
      const helpRow = document.createElement('div')
      helpRow.className = 'pdp-size-selector__help'
      helpRow.innerHTML =
        '<span data-size-help></span><a href="#pdp-fit-modal" data-pdp-open-fit-modal>Find your fit →</a>'
      sizeSelector.appendChild(helpRow)
    }
    retargetPdpSizeFitLinks()
    rememberFitFamily(byKey, fromFetch)

    const active = configs.find((c) => c.key === family.current)
    const labelEl = sizeSelector.querySelector('[data-size-label]')
    if (labelEl && active) labelEl.textContent = active.label
    const helpEl = sizeSelector.querySelector('[data-size-help]')
    if (helpEl && active) helpEl.textContent = active.help
  }

  function isSizeSelectableProductType(productType) {
    return productType === 'Sunglasses' || productType === 'Prescription' || productType === 'Safety'
  }

  function cacheSepDesignProductSectionAssets(handle, div) {
    if (!handle || !div) return

    if (!window.pdp.swiperHtmls[handle]) {
      const p = div.querySelector('sep-pdp-mainslider')
      if (p) {
        const inner =
          p.querySelector('.product__sep-design__mainSlider.swiper-' + handle) ||
          p.querySelector('.product__sep-design__mainSlider[class*="swiper-"]') ||
          p.querySelector('.product__sep-design__mainSlider')
        window.pdp.swiperHtmls[handle] = inner ? inner.outerHTML : p.innerHTML
      }
    }

    if (!window.pdp.productPriceHtmls[handle]) {
      const p = div.querySelector('sep-pdp-price')
      if (p) window.pdp.productPriceHtmls[handle] = p.innerHTML
    }

    if (!hasJudgemeHtmlCache(handle)) {
      const p = div.querySelector('judgeme')
      if (p) window.pdp.judgemeHtmls[handle] = p.innerHTML
    }
    if (window.pdp.currentProduct?.handle === handle) {
      applyJudgemeBadgeForHandle(handle)
    }

    const varPrices = div.querySelector('sep-pdp-varprices')
    if (varPrices) {
      varPrices.querySelectorAll('.variant-price').forEach(pElement => {
        const variantId = pElement.getAttribute('data-variant-id')
        if (variantId) {
          window.pdp.variantPriceHtmls[variantId] = pElement.innerHTML
        }
      })
    }

    const p = div.querySelector('sep-pdp-atc')
    if (p && p.innerHTML) {
      applyAtcHtmlForHandle(handle, p.innerHTML)
    }
  }

  function swiperHostEl(swiper) {
    if (!swiper) return null
    const el = swiper.el
    if (el && typeof el.closest === 'function') return el
    if (el && el[0] && typeof el[0].closest === 'function') return el[0]
    return null
  }

  function swiperClosest(swiper, selector) {
    const el = swiperHostEl(swiper)
    return el ? el.closest(selector) : null
  }

  function isOtherProductsSwiperEntry(entry) {
    return !!(entry && swiperClosest(entry.swiper, '.other-products-container'))
  }

  function getMainSliderRootForHandle(handle) {
    if (!handle) return null
    const roots = document.querySelectorAll('.product__sep-design__mainSlider.swiper-' + handle)
    const entry = window.pdp.swipers && window.pdp.swipers[handle]
    if (isOtherProductsSwiperEntry(entry)) {
      return roots.length ? roots[roots.length - 1] : null
    }
    if (roots.length === 1) return roots[0]
    if (roots.length > 1) {
      const preferred =
        swiperClosest(entry?.thumbSwiper, '.product__sep-design__mainSlider') ||
        swiperClosest(entry?.swiper, '.product__sep-design__mainSlider') ||
        roots[roots.length - 1]
      return preferred
    }
    if (!entry) return null
    return (
      swiperClosest(entry.thumbSwiper, '.product__sep-design__mainSlider') ||
      swiperClosest(entry.swiper, '.product__sep-design__mainSlider') ||
      null
    )
  }

  function destroyMainSwiperEntry(handle) {
    const entry = window.pdp.swipers && window.pdp.swipers[handle]
    if (!entry) return
    try {
      if (entry.swiper && typeof entry.swiper.destroy === 'function') entry.swiper.destroy(true, true)
    } catch (e) {}
    try {
      if (entry.thumbSwiper && typeof entry.thumbSwiper.destroy === 'function') {
        entry.thumbSwiper.destroy(true, true)
      }
    } catch (e) {}
    delete window.pdp.swipers[handle]
  }

  function findMainSliderWrapperForHandle(handle) {
    if (!handle) return null
    const entry = window.pdp.swipers && window.pdp.swipers[handle]
    const root = getMainSliderRootForHandle(handle)
    return (
      swiperClosest(entry?.swiper, '.mainslider-wrapper') ||
      document.querySelector('.main-swiper-' + handle)?.closest('.mainslider-wrapper') ||
      document.querySelector('.product__main > .mainslider-wrapper.handle-' + handle) ||
      (root && root.querySelector('.mainslider-wrapper')) ||
      null
    )
  }

  function restoreMainSliderWrapperIntoRoot(handle, root) {
    const mainslider = root || getMainSliderRootForHandle(handle)
    if (!mainslider) return
    const wrapper = findMainSliderWrapperForHandle(handle)
    if (!wrapper) return
    wrapper.classList.add('handle-' + handle)
    const galleryMedia = mainslider.querySelector('.product-gallery-media')
    const restoreTarget = galleryMedia || mainslider
    if (wrapper.parentNode !== restoreTarget) {
      const thumbs = restoreTarget.querySelector(':scope > .thumbnail-wrapper')
      if (thumbs) thumbs.after(wrapper)
      else restoreTarget.insertBefore(wrapper, restoreTarget.firstChild)
    }
    wrapper.classList.remove('hidden', 'sticky', 'floating')
  }

  function handleFromMainSliderWrapper(wrap) {
    if (!wrap || !wrap.querySelector) return ''
    const named = Array.from(wrap.classList || []).find((c) => c.indexOf('handle-') === 0)
    if (named) return named.slice('handle-'.length)
    const swiperEl = wrap.querySelector('[class*="main-swiper-"]')
    if (!swiperEl) return ''
    const cls = Array.from(swiperEl.classList).find((c) => c.indexOf('main-swiper-') === 0)
    return cls ? cls.slice('main-swiper-'.length) : ''
  }

  // Mobile hoists .mainslider-wrapper onto .product__main. Hiding the old root
  // does not hide that wrapper — Fits/size swap then paints two galleries.
  function restoreAllHoistedMainSliderWrappers(keepHandle) {
    const productMain = document.querySelector('.product__main')
    if (!productMain) return
    const keepWrap = keepHandle ? findMainSliderWrapperForHandle(keepHandle) : null
    Array.from(productMain.querySelectorAll(':scope > .mainslider-wrapper')).forEach((wrap) => {
      if (keepWrap && wrap === keepWrap) {
        wrap.classList.remove('hidden')
        return
      }
      const handle = handleFromMainSliderWrapper(wrap)
      if (handle) restoreMainSliderWrapperIntoRoot(handle)
      if (wrap.parentNode === productMain) wrap.classList.add('hidden')
    })
  }

  // Mobile hoists a gallery's .mainslider-wrapper onto .product__main, outside its root.
  // Removing only the root left that wrapper behind: a second slideshow stacked over the
  // remounted one (Z87 XL <-> regular size swaps).
  function removeMainSliderForHandle(handle) {
    document.querySelectorAll('.product__sep-design__mainSlider.swiper-' + handle).forEach((el) => el.remove())
    document.querySelectorAll('.product__main > .mainslider-wrapper').forEach((wrap) => {
      if (handleFromMainSliderWrapper(wrap) === handle) wrap.remove()
    })
  }

  // A hoisted wrapper is a leftover when it duplicates keepWrap's gallery, or its gallery root
  // is gone or already holds a wrapper again
  function removeOrphanedMainSliderWrappers(keepWrap) {
    const keepHandle = keepWrap ? handleFromMainSliderWrapper(keepWrap) : ''
    document.querySelectorAll('.product__main > .mainslider-wrapper').forEach((wrap) => {
      if (wrap === keepWrap) return
      const handle = handleFromMainSliderWrapper(wrap)
      if (!handle) return
      const root = document.querySelector('.product__sep-design__mainSlider.swiper-' + handle)
      if (handle === keepHandle || !root || root.querySelector('.mainslider-wrapper')) wrap.remove()
    })
  }

  function dedupeMainSliderRoots(handle) {
    const roots = Array.from(
      document.querySelectorAll('.product__sep-design__mainSlider.swiper-' + handle)
    )
    if (!roots.length) return null
    if (roots.length === 1) return roots[0]
    const entry = window.pdp.swipers && window.pdp.swipers[handle]
    const preferred =
      swiperClosest(entry?.thumbSwiper, '.product__sep-design__mainSlider') ||
      swiperClosest(entry?.swiper, '.product__sep-design__mainSlider') ||
      roots[roots.length - 1]
    roots.forEach((root) => {
      if (root === preferred) return
      root.remove()
    })
    return preferred
  }

  function refreshMainSwiperForHandle(handle) {
    const entry = window.pdp.swipers && window.pdp.swipers[handle]
    const root = getMainSliderRootForHandle(handle)
    if (root && root.classList.contains('hidden')) return
    try {
      const el = entry && entry.swiper && entry.swiper.el
      if (el && el.clientWidth < 2) {
        if (!window.pdp._swiperReinitOnce) window.pdp._swiperReinitOnce = {}
        if (!window.pdp._swiperReinitOnce[handle]) {
          window.pdp._swiperReinitOnce[handle] = true
          destroyMainSwiperEntry(handle)
          if (window.sepStorefront) window.sepStorefront.initMainSliderForHandle(handle)
          return
        }
      }
      if (!entry) return
      if (entry.swiper) {
        entry.swiper.update()
        if (typeof entry.swiper.updateSize === 'function') entry.swiper.updateSize()
      }
      if (entry.thumbSwiper) {
        entry.thumbSwiper.update()
        if (typeof entry.thumbSwiper.updateSize === 'function') entry.thumbSwiper.updateSize()
      }
      if (typeof entry.syncPagination === 'function') entry.syncPagination()
    } catch (e) {}
  }

  function hoistNestedMainSliders() {
    const images = document.querySelector('.product__images')
    if (!images) return
    let nested = images.querySelector('.product__sep-design__mainSlider .product__sep-design__mainSlider')
    while (nested) {
      images.appendChild(nested)
      nested = images.querySelector('.product__sep-design__mainSlider .product__sep-design__mainSlider')
    }
    Array.from(images.children).forEach((el) => {
      if (!el.classList || !el.classList.contains('product__sep-design__mainSlider')) return
      if (!el.querySelector('.swiper-slide')) el.remove()
    })
  }

  function unhideMainSliderAncestors(el) {
    let climb = el && el.parentElement
    while (climb && climb !== document.body) {
      if (
        climb.classList &&
        climb.classList.contains('hidden') &&
        (climb.classList.contains('product__sep-design__mainSlider') ||
          climb.tagName === 'SEP-PDP-MAINSLIDER')
      ) {
        climb.classList.remove('hidden')
      }
      if (climb.classList && climb.classList.contains('product__images')) break
      climb = climb.parentElement
    }
  }

  function revealMainSliderForHandle(handle) {
    if (!handle) return false

    // Pull every gallery wrapper back into its own root before toggling visibility.
    // Otherwise sticky moves leave wrappers under .product__main while roots stay .hidden.
    restoreAllHoistedMainSliderWrappers()
    Object.keys(window.pdp.swipers || {}).forEach((h) => {
      if (!window.pdp.swipers[h]?.swiper && !window.pdp.swipers[h]?.thumbSwiper) return
      restoreMainSliderWrapperIntoRoot(h)
    })

    hoistNestedMainSliders()
    const shown = dedupeMainSliderRoots(handle) || getMainSliderRootForHandle(handle)
    if (!shown) return false

    if (!window.pdp._mainSliderShowGen) window.pdp._mainSliderShowGen = 0
    const gen = ++window.pdp._mainSliderShowGen
    window.pdp._activeMainSliderHandle = handle

    document.querySelectorAll('.product__sep-design__mainSlider').forEach((el) => {
      el.classList.add('hidden')
    })
    shown.classList.remove('hidden')
    unhideMainSliderAncestors(shown)
    restoreMainSliderWrapperIntoRoot(handle, shown)
    restoreAllHoistedMainSliderWrappers(handle)
    const slides = shown.querySelectorAll('.swiper-slide')
    if (slides.length && !shown.querySelector('.swiper-slide:not(.hidden)')) {
      slides.forEach((s) => s.classList.remove('hidden'))
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (gen !== window.pdp._mainSliderShowGen) return
        if (window.pdp._activeMainSliderHandle !== handle) return
        refreshMainSwiperForHandle(handle)
        if (typeof window.syncGalleryPdpLead === 'function') window.syncGalleryPdpLead()
        if (typeof handleMainSliderPosition === 'function') handleMainSliderPosition(handle)
      })
    })
    return true
  }

  function parseMainSliderRootFromHtml(htmlString, handle) {
    if (!htmlString) return null
    const doc = new DOMParser().parseFromString(htmlString, 'text/html')
    return (
      doc.querySelector('.product__sep-design__mainSlider.swiper-' + handle) ||
      doc.querySelector('.product__sep-design__mainSlider[class*="swiper-"]') ||
      doc.querySelector('.product__sep-design__mainSlider')
    )
  }

  function cacheLiveMainSliderHtml(handle) {
    if (!handle || window.pdp.swiperHtmls[handle]) return
    const root = document.querySelector('.product__sep-design__mainSlider.swiper-' + handle)
    if (!root || !root.querySelector('.swiper-slide')) return
    const clone = root.cloneNode(true)
    clone.classList.remove('hidden')
    clone.querySelectorAll('.swiper-initialized, .swiper-container-initialized').forEach((el) => {
      el.classList.remove('swiper-initialized', 'swiper-container-initialized')
    })
    window.pdp.swiperHtmls[handle] = clone.outerHTML
  }

  function isZ87GalleryHandle(handle) {
    return /-z87$/.test(handle || '') || isSafetyPdpProduct(window.pdp.currentProduct)
  }

  function seedSafetyGalleryHtml(product) {
    if (!product?.handle || !window.sepStorefront) return false
    const p = Object.assign({}, product)
    if ((!p.media || !p.media.length) && (!p.images || !p.images.length) && p.image) {
      p.images = [p.image]
    }
    const html = window.sepStorefront.buildMainSliderHtml(p)
    if (!html || html.indexOf('swiper-slide') === -1) return false
    window.pdp.swiperHtmls[product.handle] = html
    return true
  }

  function mountMainSwiperForHandle(productHandle) {
    if (!productHandle) return false
    const z87 = isZ87GalleryHandle(productHandle)
    cacheLiveMainSliderHtml(window.pdp._activeMainSliderHandle)
    if (!z87) cacheLiveMainSliderHtml(productHandle)
    hoistNestedMainSliders()

    if (!z87) {
      const existing = getMainSliderRootForHandle(productHandle)
      if (existing && existing.querySelector('.swiper-slide')) {
        return revealMainSliderForHandle(productHandle)
      }
    }

    if (!window.pdp.swiperHtmls[productHandle]) return false

    removeMainSliderForHandle(productHandle)
    destroyMainSwiperEntry(productHandle)

    const parsed = parseMainSliderRootFromHtml(window.pdp.swiperHtmls[productHandle], productHandle)
    const productImages = document.querySelector('.product__images')
    if (!parsed || !productImages) return false

    const node = document.importNode(parsed, true)
    node.classList.remove('hidden')
    productImages.appendChild(node)
    hoistNestedMainSliders()
    const mounted = getMainSliderRootForHandle(productHandle) || node
    mounted.classList.remove('hidden')
    // Liquid slider scripts use global Swiper selectors and boot while nested/hidden
    // (Z87 size swap). Storefront HTML has no script — init after the root is visible.
    if (!z87) runAllScripts(mounted)
    const revealed = revealMainSliderForHandle(productHandle)
    if (window.sepStorefront) {
      window.sepStorefront.initMainSliderForHandle(productHandle)
    }
    if (window.PXUTheme?.video?.init) window.PXUTheme.video.init()
    return revealed
  }

  function showPdpGalleryForHandle(handle) {
    if (!handle) return Promise.resolve(false)
    hoistNestedMainSliders()
    const finish = () => {
      if (
        window.pdp.currentProduct?.handle !== handle &&
        window.pdp.currentProductHandle !== handle
      ) {
        return false
      }
      if (isZ87GalleryHandle(handle) && window.pdp.currentProduct?.handle === handle) {
        seedSafetyGalleryHtml(window.pdp.currentProduct)
      }
      const ok = mountMainSwiperForHandle(handle)
      if (typeof changeSliderImages === 'function') changeSliderImages()
      const root = getMainSliderRootForHandle(handle)
      if (root) {
        const slides = root.querySelectorAll('.swiper-slide')
        if (slides.length && !root.querySelector('.swiper-slide:not(.hidden)')) {
          slides.forEach((s) => s.classList.remove('hidden'))
        }
      }
      requestAnimationFrame(() => {
        if (typeof changeSliderImages === 'function') changeSliderImages()
        refreshMainSwiperForHandle(handle)
        if (typeof handleMainSliderPosition === 'function') handleMainSliderPosition(handle)
      })
      return ok
    }
    if (isZ87GalleryHandle(handle) && window.pdp.currentProduct?.handle === handle) {
      seedSafetyGalleryHtml(window.pdp.currentProduct)
    }
    const liveRoot = getMainSliderRootForHandle(handle)
    const liveOk = !!(liveRoot && liveRoot.querySelector('.swiper-slide'))
    if (liveOk && (!isZ87GalleryHandle(handle) || window.pdp.swiperHtmls[handle])) {
      finish()
      return Promise.resolve(true)
    }
    return ensureSepDesignProductAssets(handle).then(() => finish())
  }

  function sepStorefrontEnabled() {
    return !!(window.sepStorefront && typeof window.sepStorefront.enabled === 'function' && window.sepStorefront.enabled())
  }

  // Storefront-first variant prices: fill variantPriceHtmls from GraphQL variant data.
  // Returns true on success; false (never throws) so callers can fall back to Section Rendering.
  function populateVariantPricesFromStorefront(handle, productType) {
    if (!sepStorefrontEnabled() || !handle) return Promise.resolve(false)
    return window.sepStorefront
      .productByHandle(handle)
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) return false
        const pt = productType || product.product_type
        product.variants.forEach(function (v) {
          if (v.id == null) return
          const html = buildSepDesignRxPriceBlockHtml(v, pt)
          if (html) window.pdp.variantPriceHtmls[v.id] = html
        })
        return true
      })
      .catch(function () {
        return false
      })
  }

  // Storefront-first subtitle from custom.product_subtitle metafield.
  function applySubtitleFromStorefront(handle) {
    if (!sepStorefrontEnabled() || !handle) return Promise.resolve(false)
    return window.sepStorefront
      .productByHandle(handle)
      .then(function (product) {
        if (!product) return false
        const subtitle = (product.metafields && product.metafields.product_subtitle) || ''
        window.pdp.subtitleHtmls[handle] = subtitle
        const subtitleElement = document.querySelector('.product__information_block.subtitle')
        if (subtitleElement) {
          if (subtitle) {
            subtitleElement.innerHTML = subtitle
            subtitleElement.classList.remove('hidden')
          } else {
            subtitleElement.innerHTML = ''
            subtitleElement.classList.add('hidden')
          }
        }
        return true
      })
      .catch(function () {
        return false
      })
  }

  function applyAtcHtmlForHandle(handle, atcHtml) {
    if (!handle || !atcHtml) return
    window.pdp.atcHtmls[handle] = atcHtml
    const wrap = document.createElement('div')
    wrap.innerHTML = atcHtml
    const newAtc = wrap.querySelector('.product__information_block.atc, .atc')
    const newProductId = newAtc?.getAttribute('product_id')
    const atcElement =
      document.querySelector('.product__information > atc') ||
      document.querySelector('.product__information > .product__information_block.atc')
    if (atcElement && newAtc && newProductId) {
      const existing = document.querySelector(
        `.product__information > .product__information_block.atc[product_id="${newProductId}"]`
      )
      if (!existing) {
        atcElement.insertAdjacentHTML('afterend', newAtc.outerHTML)
      }
      syncVisibleAtcBlocks(window.pdp.currentProduct?.id)
      if (typeof window.syncPdpMobileStickyAtc === 'function') window.syncPdpMobileStickyAtc()
      if (typeof placeRxToggleForProductType === 'function' && window.pdp.currentProduct?.product_type) {
        placeRxToggleForProductType(window.pdp.currentProduct.product_type)
      }
      if (typeof renderWishlistButton === 'function') renderWishlistButton()
    }
  }

  function cacheSepDesignProductAssetsFromStorefront(handle, product) {
    if (!handle || !product || !window.sepStorefront) return false
    if (!window.pdp.swiperHtmls[handle]) {
      const html = window.sepStorefront.buildMainSliderHtml(product)
      if (html && html.indexOf('swiper-slide') !== -1) {
        window.pdp.swiperHtmls[handle] = html
      }
    }
    const atcHtml = window.pdp.atcHtmls[handle] || window.sepStorefront.buildAtcHtml(product)
    if (document.querySelector('.sep-design-pdp.is-side-shield-pdp')) {
      if (atcHtml) window.pdp.atcHtmls[handle] = atcHtml
    } else {
      applyAtcHtmlForHandle(handle, atcHtml)
    }
    const pt = product.product_type
    ;(product.variants || []).forEach(function (v) {
      if (v.id == null) return
      if (window.pdp.variantPriceHtmls[v.id]) return
      const html = buildSepDesignRxPriceBlockHtml(v, pt)
      if (html) window.pdp.variantPriceHtmls[v.id] = html
    })
    if (typeof product.metafields?.product_subtitle === 'string' && window.pdp.subtitleHtmls[handle] == null) {
      window.pdp.subtitleHtmls[handle] = product.metafields.product_subtitle
    }
    return !!(window.pdp.swiperHtmls[handle] && window.pdp.atcHtmls[handle])
  }

  function ensureSepDesignProductAssets(handle) {
    if (!handle) return Promise.resolve()
    if (!window.pdp._assetEnsurePromises) window.pdp._assetEnsurePromises = {}
    // Initial PDP product already has a live swiper in the DOM; do not require swiperHtmls
    const hasLiveSwiper = !!(window.pdp.swipers?.[handle]?.swiper && window.pdp.swipers?.[handle]?.thumbSwiper)
    const assetsReady =
      ((window.pdp.swiperHtmls[handle] || hasLiveSwiper) && window.pdp.atcHtmls[handle]) ||
      (hasLiveSwiper &&
        document.querySelector('.product__information_block.atc, .product__information > .atc, atc')) ||
      (window.pdp.swiperHtmls[handle] && window.pdp.atcHtmls[handle])

    // Gallery/ATC may already be cached while Judge.me badge is still missing.
    // Do not block size/product swaps on the badge section fetch.
    if (assetsReady) {
      ensureJudgemeHtmlForHandle(handle).then(() => {
        if (window.pdp.currentProduct?.handle === handle) applyJudgemeBadgeForHandle(handle)
      })
      return Promise.resolve()
    }
    if (window.pdp._assetEnsurePromises[handle]) {
      return window.pdp._assetEnsurePromises[handle]
    }

    const fetchViaSection = () =>
      fetchSectionHtml(`/products/${handle}?section_id=sep-pdp-product`).then(data => {
        const div = new DOMParser().parseFromString(data, 'text/html')
        cacheSepDesignProductSectionAssets(handle, div)
      })

    const promise = (
      sepStorefrontEnabled()
        ? window.sepStorefront
            .productByHandle(handle)
            .then(product => {
              if (!product || !cacheSepDesignProductAssetsFromStorefront(handle, product)) {
                return fetchViaSection()
              }
              // Judge.me badge still needs Liquid; fill if missing (Glasson stays empty wrapper)
              return ensureJudgemeHtmlForHandle(handle).then(() => {
                if (window.pdp.currentProduct?.handle === handle) applyJudgemeBadgeForHandle(handle)
              })
            })
            .catch(() => fetchViaSection())
        : fetchViaSection()
    )
      .then(() => ensureJudgemeHtmlForHandle(handle))
      .then(() => {
        if (window.pdp.currentProduct?.handle !== handle) return
        paintPdpProductChrome(window.pdp.currentProduct)
        if (window.pdp.currentProductHandle === handle) {
          mountMainSwiperForHandle(handle)
        }
      })
      .catch(() => {})
      .finally(() => {
        // Always drop so a later click can refetch after 429/errors (success stays in swiperHtmls/atcHtmls)
        delete window.pdp._assetEnsurePromises[handle]
      })
    window.pdp._assetEnsurePromises[handle] = promise
    return promise
  }

  function paintPdpSizeSelectorSelection(targetHandle, sizeSelector = getPdpSizeSelectorElement()) {
    if (!sizeSelector || !targetHandle) return
    const key = getSizeKeyFromHandle(targetHandle)
    ;['std', 'xl', 'xxl'].forEach((sizeKey) => {
      const btn = sizeSelector.querySelector(`[data-size="${sizeKey}"]`)
      if (btn) btn.classList.toggle('on', sizeKey === key)
    })
    const label = sizeSelector.querySelector('[data-size-label]')
    const activeBtn = sizeSelector.querySelector(`[data-size="${key}"]`)
    if (label && activeBtn?.dataset.label) {
      label.textContent = activeBtn.dataset.label
    }
    const helpEl = sizeSelector.querySelector('[data-size-help]')
    if (helpEl && activeBtn?.dataset.help) {
      helpEl.textContent = activeBtn.dataset.help
    }
  }

  function refreshOtherProductsForHandle(handle, opts) {
    if (!handle) return Promise.resolve()

    const applyOtherProductsMount = (collectionHandle, htmlNodeOrString, products) => {
      const otherProductsRoot = $(document).find('.product__information_block.other-products')
      otherProductsRoot.find('.other-products-container').addClass('hidden')

      if (collectionHandle && window.pdp.swipers[collectionHandle]) {
        $(window.pdp.swipers[collectionHandle].swiper.el)
          .closest('.other-products-container')
          .removeClass('hidden')
        window.pdp.mainCollection = collectionHandle
      } else if (htmlNodeOrString) {
        if (typeof htmlNodeOrString === 'string') {
          otherProductsRoot.append(htmlNodeOrString)
          if (collectionHandle && window.sepStorefront) {
            window.sepStorefront.mountOtherProductsSwiper(collectionHandle)
          }
        } else {
          otherProductsRoot.append(htmlNodeOrString)
          runAllScripts(htmlNodeOrString.get ? htmlNodeOrString.get(0) : htmlNodeOrString)
        }
        if (collectionHandle) window.pdp.mainCollection = collectionHandle
      }

      const pending = window.pdp.pendingSizeHandle
      if (pending) {
        paintPdpSizeSelectorSelection(pending)
      } else {
        requestAnimationFrame(updatePdpSizeSelector)
      }

      if (collectionHandle && products) {
        window.pdp.mainCollectionProducts = products
      }

      requestAnimationFrame(() => {
        syncPdpOptions(window.pdp.currentProduct, { force: true })
        scheduleSyncPdpOptionsRetries(window.pdp.currentProduct)
      })
    }

    const viaSection = () =>
      fetchSectionHtml(`/products/${handle}?section_id=sep-pdp-otherproducts`).then(data => {
        const div = new DOMParser().parseFromString(data, 'text/html')
        const content = $(div).find('#shopify-section-sep-pdp-otherproducts')
        const newContainer = content.find('.other-products-container').get(0)
        if (!newContainer) return

        const collectionClass = Array.from(newContainer.classList).find(c =>
          c.startsWith('other-products-swiper-container-')
        )
        const collectionHandle = collectionClass
          ? collectionClass.replace('other-products-swiper-container-', '')
          : ''

        applyOtherProductsMount(collectionHandle, content, null)

        if (collectionHandle) {
          if (sepStorefrontEnabled()) {
            window.sepStorefront
              .collectionByHandle(collectionHandle)
              .then(collection => {
                if (!collection) return
                window.pdp.mainCollectionProducts = collection.products
              })
              .catch(() => {})
          } else {
            fetch(`/collections/${collectionHandle}/products.json`)
              .then(res => res.json())
              .then(collectionData => {
                window.pdp.mainCollectionProducts = collectionData.products
              })
              .catch(() => {})
          }
        }
      })

    // Sunglasses/Safety: always Liquid section so Z87↔regular OPTIONS + Safety lens survive refresh.
    // Product JSON / gallery / ATC still come from Storefront via ensureSepDesignProductAssets.
    const forceSection =
      opts?.forceSection ||
      window.pdp.pendingProductSwitch?.kind === 'safety' ||
      window.pdp.pendingProductSwitch?.kind === 'rx' ||
      window.pdp.currentProduct?.product_type === 'Safety' ||
      window.pdp.currentProduct?.product_type === 'Sunglasses' ||
      window.pdp.currentProduct?.product_type === 'Prescription' ||
      /-z87$/.test(handle || '') ||
      /-rx$/.test(handle || '')

    if (sepStorefrontEnabled() && !forceSection) {
      return window.sepStorefront
        .loadOtherProductsForHandle(handle)
        .then(payload => {
          if (!payload || !payload.html) return viaSection()
          applyOtherProductsMount(payload.collectionHandle, payload.html, payload.collection.products)
        })
        .catch(() => viaSection())
        .catch(() => {})
    }

    return viaSection().catch(() => {})
  }

  function setPdpSizeSelectorBusy(busy) {
    const sizeSelector = getPdpSizeSelectorElement()
    if (!sizeSelector) return
    sizeSelector.classList.toggle('is-busy', !!busy)
    sizeSelector.setAttribute('aria-busy', busy ? 'true' : 'false')
  }

  function setPdpProductSwitchBusyUi(busy) {
    setPdpSizeSelectorBusy(busy)
    getVisibleRxToggle()?.classList.toggle('is-busy', !!busy)
    document.querySelector('.product__information_block.other-products')?.classList.toggle('is-busy', !!busy)
  }

  function isPdpProductSwitchBusy() {
    return !!(window.pdp.pendingProductSwitch || window.pdp.pendingSizeHandle)
  }

  function beginPdpProductSwitch(kind, targetKey) {
    // Allow replacing an in-flight size / safety toggle so rapid clicks don't stack stale reveals
    if (isPdpProductSwitchBusy()) {
      const pendingKind = window.pdp.pendingProductSwitch?.kind
      if (
        (kind === 'size' && pendingKind === 'size') ||
        (kind === 'safety' && pendingKind === 'safety') ||
        (kind === 'frame' && pendingKind === 'frame')
      ) {
        window.pdp.pendingProductSwitch = { kind, targetKey }
        if (kind === 'size') window.pdp.pendingSizeHandle = targetKey
        if (!window.pdp._mainSliderShowGen) window.pdp._mainSliderShowGen = 0
        window.pdp._mainSliderShowGen++
        setPdpProductSwitchBusyUi(true)
        if (window.pdp._productSwitchUnlockTimer) clearTimeout(window.pdp._productSwitchUnlockTimer)
        window.pdp._productSwitchUnlockTimer = setTimeout(() => {
          endPdpProductSwitch(kind, targetKey, true)
        }, 8000)
        return true
      }
      return false
    }
    window.pdp.pendingProductSwitch = { kind, targetKey }
    if (kind === 'size') window.pdp.pendingSizeHandle = targetKey
    if (kind === 'size' || kind === 'safety' || kind === 'frame') {
      if (!window.pdp._mainSliderShowGen) window.pdp._mainSliderShowGen = 0
      window.pdp._mainSliderShowGen++
    }
    setPdpProductSwitchBusyUi(true)
    if (window.pdp._productSwitchUnlockTimer) clearTimeout(window.pdp._productSwitchUnlockTimer)
    window.pdp._productSwitchUnlockTimer = setTimeout(() => {
      endPdpProductSwitch(kind, targetKey, true)
    }, 8000)
    return true
  }

  function endPdpProductSwitch(kind, targetKey, force) {
    const pending = window.pdp.pendingProductSwitch
    if (!pending && !window.pdp.pendingSizeHandle) {
      setPdpProductSwitchBusyUi(false)
      return
    }
    if (!force && pending) {
      if (kind && pending.kind !== kind) return
      if (targetKey && pending.targetKey !== targetKey) return
    }
    if (window.pdp._productSwitchUnlockTimer) {
      clearTimeout(window.pdp._productSwitchUnlockTimer)
      window.pdp._productSwitchUnlockTimer = null
    }
    window.pdp.pendingProductSwitch = null
    window.pdp.pendingSizeHandle = null
    setPdpProductSwitchBusyUi(false)
  }

  function resolvePdpProductSwitchFromProduct(product) {
    const pending = window.pdp.pendingProductSwitch
    if (!pending || !product) return
    if (pending.kind === 'size' || pending.kind === 'frame' || pending.kind === 'safety') {
      const candidates = [product.handle, window.pdp.currentProductHandle]
      if (typeof window.getOphSplitSliderHandle === 'function') {
        candidates.push(window.getOphSplitSliderHandle(product.handle))
      }
      if (candidates.includes(pending.targetKey)) endPdpProductSwitch(pending.kind, pending.targetKey)
      return
    }
    if (pending.kind === 'rx') {
      const expectedType = pending.targetKey === 'prescription' ? 'Prescription' : 'Sunglasses'
      if (product.product_type === expectedType) endPdpProductSwitch('rx', pending.targetKey)
    }
  }

  window.isPdpProductSwitchBusy = isPdpProductSwitchBusy
  window.beginPdpProductSwitch = beginPdpProductSwitch
  window.endPdpProductSwitch = endPdpProductSwitch

  function navigateToPdpHandle(handle) {
    if (!handle) return
    window.location.assign('/products/' + encodeURIComponent(handle))
  }

  function seedCurrentProductHandle(handle) {
    if (!handle || window.pdp.currentProductHandle) return
    window.pdp.currentProductHandle = handle
  }

  function paintPdpProductChrome(product) {
    if (!product) return

    const titleHtml = pdpVisibleTitleHtml(product.title, product.product_type)
    document.querySelectorAll('.pdp-lead .product__information_block.title h1').forEach((el) => {
      el.innerHTML = titleHtml
    })
    const titleFallback = document.querySelector('.product__information .product__information_block.title h1')
    if (titleFallback && !titleFallback.closest('.pdp-lead')) {
      titleFallback.innerHTML = titleHtml
    }
    if (typeof window.syncGalleryPdpLead === 'function') window.syncGalleryPdpLead()

    try {
      const url = new URL(window.location)
      url.pathname = url.pathname.replace(/\/products\/[^/]+/, `/products/${product.handle}`)
      if (product.product_type === 'Safety' || product.productType === 'Safety') {
        const safetyVar = findSafetyLensTypeVariant(product)
        if (safetyVar?.id) url.searchParams.set('variant', String(safetyVar.id))
        else if (!window.pdp.lock?.variantParam) url.searchParams.delete('variant')
      } else if (!window.pdp.lock?.variantParam) {
        url.searchParams.delete('variant')
      }
      window.history.replaceState({}, '', url)
    } catch (e) {}

    if (product.product_type === 'Safety' || product.productType === 'Safety') {
      const safetyVar = findSafetyLensTypeVariant(product)
      if (safetyVar) applyPriceBlockForVariant(safetyVar)
    } else {
      const priceVariantId = product.variants?.[0]?.id
      const priceHtml =
        (priceVariantId && window.pdp.variantPriceHtmls[priceVariantId]) ||
        window.pdp.productPriceHtmls?.[product.handle]
      if (priceHtml) {
        const priceElement =
          document.querySelector('.product__information > .pdp-lead .product__information_block.price-block') ||
          document.querySelector('.product__information .product__information_block.price-block')
        if (priceElement) priceElement.innerHTML = priceHtml
      }
    }

    if (!document.querySelector('.sep-design-pdp.is-side-shield-pdp')) {
      if (window.pdp.atcHtmls?.[product.handle]) {
        applyAtcHtmlForHandle(product.handle, window.pdp.atcHtmls[product.handle])
      }
      syncVisibleAtcBlocks(product.id)
    }
    if (typeof window.syncPdpMobileStickyAtc === 'function') window.syncPdpMobileStickyAtc()
    if (product.product_type === 'Safety' && typeof paintSafetyAtcTotal === 'function') {
      paintSafetyAtcTotal()
    }
  }

  function isSafetyPdpProduct(product) {
    if (!product) return false
    const t = product.product_type || product.productType || ''
    return t === 'Safety' || /-z87$/.test(product.handle || '')
  }

  function snapshotSafetyShieldsByTitle() {
    const cfg = typeof getSafetyShieldCfg === 'function' ? getSafetyShieldCfg() : { shields: [] }
    const byTitle = {}
    Object.keys(window.pdp.safetyShields || {}).forEach((id) => {
      const qty = window.pdp.safetyShields[id]
      if (!qty) return
      const c = (cfg.shields || []).find((s) => String(s.id) === String(id))
      const key = String(c?.title || '').trim()
      if (key) byTitle[key] = qty
    })
    const wrap = document.querySelector('.other-products-container:not(.hidden) [data-safety-shield-wrap]')
      || document.querySelector('[data-safety-shield-wrap]')
    return {
      byTitle,
      expanded: !!(wrap && !wrap.hasAttribute('hidden')) || Object.keys(byTitle).length > 0
    }
  }

  function restoreSafetyShieldsByTitle(snap) {
    if (!snap) return
    const cfg = typeof getSafetyShieldCfg === 'function' ? getSafetyShieldCfg() : { shields: [] }
    const next = {}
    Object.keys(snap.byTitle || {}).forEach((title) => {
      const c = (cfg.shields || []).find((s) => String(s.title || '').trim() === title)
      if (c) next[c.id] = snap.byTitle[title]
    })
    window.pdp.safetyShields = next
    if (typeof renderSafetyShields === 'function') renderSafetyShields()
    if (typeof paintSafetyShieldSummary === 'function') paintSafetyShieldSummary()
    if (typeof paintSafetyAtcTotal === 'function') paintSafetyAtcTotal()
    const hasQty = Object.keys(next).length > 0
    if (snap.expanded && hasQty) {
      document.querySelectorAll('[data-safety-shield-wrap]').forEach((el) => el.removeAttribute('hidden'))
      document.querySelectorAll('[data-safety-shield-toggle]').forEach((btn) => {
        btn.setAttribute('aria-expanded', 'true')
      })
    }
  }

  function applySafetySelectionToProduct(product) {
    const p = product || window.pdp.currentProduct
    if (!isSafetyPdpProduct(p)) return
    const wanted = window.pdp._safetyLensWanted || window.pdp.safetyLensType
    if (wanted) window.pdp.safetyLensType = wanted
    refreshSafetyLensInlineFromProduct(p)
    const picked = findSafetyLensTypeVariant(p)
    if (picked) {
      setState['selectedVariant'](picked)
      applyPriceBlockForVariant(picked)
      writeSafetyVariantToUrl(picked)
      updateSafetyTrioBadge(picked)
    }
    paintSafetyAtcTotal()
  }

  function refreshSafetyShieldJsonForHandle(handle, snap) {
    if (!handle) {
      restoreSafetyShieldsByTitle(snap)
      return Promise.resolve()
    }
    return fetchSectionHtml(`/products/${handle}?section_id=sep-pdp-otherproducts`)
      .then((data) => {
        const div = new DOMParser().parseFromString(data, 'text/html')
        const fresh = div.querySelector('[data-safety-shields-json]')
        const live =
          document.querySelector('.other-products-container:not(.hidden) [data-safety-shields-json]') ||
          document.querySelector('[data-safety-shields-json]')
        if (fresh && live) live.textContent = fresh.textContent
        restoreSafetyShieldsByTitle(snap)
      })
      .catch(() => restoreSafetyShieldsByTitle(snap))
  }

  function applyPdpSizeProductSwap(product, targetHandle) {
    const wantedLens = window.pdp.safetyLensType
    const shieldSnap = isSafetyPdpProduct(window.pdp.currentProduct) || isSafetyPdpProduct(product)
      ? snapshotSafetyShieldsByTitle()
      : null
    if (wantedLens) window.pdp._safetyLensWanted = wantedLens
    seedCurrentProductHandle(window.pdp.currentProduct?.handle)
    if (wantedLens) window.pdp.safetyLensType = wantedLens
    if (isSafetyPdpProduct(product)) seedSafetyGalleryHtml(product)
    setState['currentProduct'](product)
    setState['currentProductHandle'](targetHandle)
    paintPdpSizeSelectorSelection(targetHandle)
    showPdpGalleryForHandle(targetHandle)
    // Other Products slider must show the new size's colors. Safety keeps its mount (lens + shields).
    if (!isSafetyPdpProduct(product)) refreshOtherProductsForHandle(targetHandle)

    const finish = () => {
      if (window.pdp.currentProduct?.handle !== targetHandle) return
      if (wantedLens) window.pdp.safetyLensType = wantedLens
      applySafetySelectionToProduct(window.pdp.currentProduct)
      syncSafetyRegularSunDoorway(window.pdp.currentProduct)
      if (typeof retargetPdpSizeFitLinks === 'function') retargetPdpSizeFitLinks()
      if (shieldSnap) restoreSafetyShieldsByTitle(shieldSnap)
    }

    // Size stays in the same OPTIONS mount. Remounting wiped lens + extra shields.
    finish()
    requestAnimationFrame(finish)
    if (shieldSnap) refreshSafetyShieldJsonForHandle(targetHandle, shieldSnap).then(finish)
    setTimeout(finish, 200)
  }

  function switchPdpSizeProduct(targetHandle, opts) {
    opts = opts || {}
    if (!targetHandle || targetHandle === window.pdp.currentProduct?.handle) return
    const kind = opts.kind || 'size'
    if (!beginPdpProductSwitch(kind, targetHandle)) return

    if (kind === 'size') paintPdpSizeSelectorSelection(targetHandle)
    cacheLiveMainSliderHtml(window.pdp.currentProduct?.handle)
    window.pdp._sizeSwitchGen = (window.pdp._sizeSwitchGen || 0) + 1
    const sizeSwitchGen = window.pdp._sizeSwitchGen

    const isStaleSizeSwitch = () => {
      if (window.pdp._sizeSwitchGen !== sizeSwitchGen) return true
      const pending = window.pdp.pendingProductSwitch
      if (pending && pending.targetKey && pending.targetKey !== targetHandle) return true
      const pendingSize = window.pdp.pendingSizeHandle
      return !!(pendingSize && pendingSize !== targetHandle)
    }

    const fallbackNav = () => {
      if (isStaleSizeSwitch()) return
      endPdpProductSwitch(kind, targetHandle, true)
      if (opts.allowFallbackNav === false) return
      navigateToPdpHandle(targetHandle)
    }

    // Gallery/ATC/Judge.me must not gate title, URL, ATC, or description.
    ensureSepDesignProductAssets(targetHandle)

    const applyFromPayload = (data) => {
      if (isStaleSizeSwitch()) return false
      if (!data?.product?.handle) return false
      applyPdpSizeProductSwap(data.product, targetHandle)
      return true
    }

    const ajaxJson = fetch('/products/' + encodeURIComponent(targetHandle) + '.json').then((r) => {
      if (!r.ok) throw r
      return r.json()
    })
    const mergedJson = fetchProductJsonMerged('/products/' + targetHandle + '.json')

    let applied = false
    const tryApply = (data) => {
      if (applied) return
      if (applyFromPayload(data)) applied = true
    }

    ajaxJson.then(tryApply).catch(() => {})
    mergedJson.then(tryApply).catch(() => {})
    Promise.allSettled([ajaxJson, mergedJson]).then((results) => {
      if (applied || isStaleSizeSwitch()) return
      const ok = results.some((r) => r.status === 'fulfilled' && r.value?.product?.handle)
      if (!ok) fallbackNav()
    })
  }
  window.switchPdpSizeProduct = switchPdpSizeProduct

  /** Z87 ↔ Sunglasses: real PDP navigation. Do not prefetch / in-place swap. */
  function switchPdpSafetySunProduct(targetHandle) {
    nvzOptLog('switch:nav', {
      targetHandle,
      fromHandle: window.pdp.currentProduct?.handle,
      fromType: window.pdp.currentProduct?.product_type
    })
    if (!targetHandle || targetHandle === window.pdp.currentProduct?.handle) {
      nvzOptLog('switch:abort', { reason: 'same-handle-or-empty' })
      return
    }
    if (/-z87$/.test(targetHandle) && !canSeeSafetyZ87()) {
      nvzOptLog('switch:abort', { reason: 'z87-gated' })
      return
    }
    window.location.assign(pdpProductHref(targetHandle))
  }

  window.switchPdpSafetySunProduct = switchPdpSafetySunProduct
  window.toRegularHandle = toRegularHandle
  window.toSafetyHandle = toSafetyHandle

  function updatePdpSizeSelector() {
    const sizeSelector = getPdpSizeSelectorElement()
    if (!sizeSelector) return

    const currentProduct = window.pdp.currentProduct
    const currentHandle = currentProduct?.handle
    const pendingHandle = window.pdp.pendingSizeHandle

    // Mid-switch: ignore stale currentProduct so the toggle does not bounce
    if (pendingHandle && currentHandle !== pendingHandle) {
      paintPdpSizeSelectorSelection(pendingHandle, sizeSelector)
      setPdpProductSwitchBusyUi(true)
      return
    }
    if (pendingHandle && currentHandle === pendingHandle) {
      endPdpProductSwitch('size', pendingHandle)
    }

    if (!currentHandle || !isSizeSelectableProductType(currentProduct?.product_type)) {
      sizeSelector.classList.add('hidden')
      return
    }

    const family = getSizeFamilyHandles(currentHandle)
    const sizeKeys = ['std', 'xl', 'xxl']

    const matchesInitialRender =
      sizeSelector.dataset.hasCounterpart === 'true' &&
      [sizeSelector.dataset.stdHandle, sizeSelector.dataset.xlHandle, sizeSelector.dataset.xxlHandle].includes(
        currentHandle
      )

    if (matchesInitialRender) {
      sizeSelector.classList.remove('hidden')
      applyPdpSizeSelectorState(sizeSelector, currentProduct, null)
    }

    const siblingFetches = sizeKeys
      .filter((key) => family[key] && family[key] !== currentHandle)
      .map((key) => {
        const handle = family[key]
        const missing = window.pdp._missingProductJson || (window.pdp._missingProductJson = {})
        if (missing[handle]) return Promise.resolve({ key, product: null })
        return fetchProductJsonMerged(`/products/${handle}.json`)
          .then((res) => ({ key, product: res?.product?.handle ? res.product : null }))
          .catch(() => {
            missing[handle] = true
            return { key, product: null }
          })
      })

    Promise.all(siblingFetches)
      .then((results) => {
        if (window.pdp.pendingSizeHandle && window.pdp.pendingSizeHandle !== currentHandle) {
          paintPdpSizeSelectorSelection(window.pdp.pendingSizeHandle)
          return
        }
        if (window.pdp.currentProduct?.handle !== currentHandle) return

        const byKey = { std: null, xl: null, xxl: null }
        byKey[family.current] = currentProduct
        results.forEach(({ key, product }) => {
          byKey[key] = product
        })

        const availableCount = sizeKeys.filter((key) => byKey[key]?.handle).length
        if (availableCount < 2) {
          sizeSelector.classList.add('hidden')
          sizeSelector.dataset.hasCounterpart = 'false'
          return
        }

        sizeSelector.classList.remove('hidden')
        sizeSelector.dataset.hasCounterpart = 'true'
        applyPdpSizeSelectorState(sizeSelector, currentProduct, byKey)
      })
      .catch(() => {
        if (window.pdp.pendingSizeHandle && window.pdp.pendingSizeHandle !== currentHandle) {
          paintPdpSizeSelectorSelection(window.pdp.pendingSizeHandle)
          return
        }
        if (window.pdp.currentProduct?.handle !== currentHandle) return
        if (matchesInitialRender) {
          sizeSelector.classList.remove('hidden')
          applyPdpSizeSelectorState(sizeSelector, currentProduct, null)
        } else {
          sizeSelector.classList.add('hidden')
        }
      })
  }

  console.log("INITIALIZING SET STATE")

  function coerceVariantPriceDollars(raw) {
    if (raw == null || raw === '') return NaN
    if (typeof raw === 'object') {
      if (raw.amount != null) return coerceVariantPriceDollars(raw.amount)
      if (typeof raw.cents === 'number') return raw.cents / 100
    }
    const str = String(raw).trim()
    const n = parseFloat(str)
    if (isNaN(n)) return NaN
    if (str.indexOf('.') === -1 && Number.isInteger(n) && Math.abs(n) >= 1000) return n / 100
    return n
  }

  function isSepOfferProductType(pt) {
    return pt === 'Sunglasses' || pt === 'Prescription' || pt === 'Ophthalmic' || pt === 'Safety'
  }

  function formatSepDesignOfferMoney(amount) {
    const moneyFormat = document.body.getAttribute('data-money-format') || (typeof Shopify !== 'undefined' && Shopify.money_format) || (window.SEP_DESIGN_PDP.moneyFormat || '')
    const dollars = coerceVariantPriceDollars(amount)
    const cents = Math.round(dollars * 100)
    if (isNaN(cents)) return ''
    let formatted
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoneyOrigin === 'function') {
      formatted = Shopify.formatMoneyOrigin(String(cents), moneyFormat)
    } else {
      formatted = '$' + (cents / 100).toFixed(2)
    }
    return String(formatted).replace(/\.00(?!\d)/, '')
  }
  window.formatSepDesignOfferMoney = formatSepDesignOfferMoney

  function buildAtcInlinePriceHtml(variant, opts = {}) {
    const priceRaw = variant?.price ?? window.pdp.currentProduct?.variants?.[0]?.price
    const price = parseFloat(priceRaw)
    if (isNaN(price)) return ''
    const pt = window.pdp.currentProduct?.product_type
    const useOffer =
      opts.applyRxDiscount ||
      pt === 'Sunglasses' ||
      pt === 'Prescription' ||
      pt === 'Ophthalmic' ||
      pt === 'Safety'
    let html = ''
    if (useOffer) {
      const disc = formatSepDesignOfferMoney(price * 0.7)
      const full = formatSepDesignOfferMoney(price)
      if (disc) html += '<span class="price-block price">' + disc + '</span>'
      if (full) html += '<span class="price-block compare-at-price">' + full + '</span>'
    } else {
      const main = formatSepDesignOfferMoney(price)
      if (main) html += '<span class="price-block price">' + main + '</span>'
      const compareAt = variant?.compare_at_price != null ? parseFloat(variant.compare_at_price) : NaN
      if (!isNaN(compareAt) && compareAt > price) {
        const cmp = formatSepDesignOfferMoney(compareAt)
        if (cmp) html += '<span class="price-block compare-at-price">' + cmp + '</span>'
      }
    }
    return html
  }

  function getAddToCartButtonText(variant, opts = {}) {
    let base = 'ADD TO CART'
    if (window.pdp.editMode) {
      base = 'UPDATE YOUR PAIR'
    } else if (
      opts.hidePrice &&
      (window.pdp.currentProduct?.product_type === 'Prescription' ||
        window.pdp.currentProduct?.product_type === 'Ophthalmic' ||
        (typeof window.isOphthalmicPdpProduct === 'function' &&
          window.isOphthalmicPdpProduct(window.pdp.currentProduct)))
    ) {
      base = 'CHOOSE YOUR LENSES'
    }
    if (opts.hidePrice) return base
    // Safety ATC stays clean (mockup); shield total paints into [data-safety-atc-amt]
    if (window.pdp.currentProduct?.product_type === 'Safety') {
      return '<span class="atc-button__label">' + base + '</span><span class="atc-button__amt" data-safety-atc-amt></span>'
    }
    const priceHtml = buildAtcInlinePriceHtml(variant, opts)
    if (!priceHtml) return base
    return (
      '<span class="atc-button__label">' + base + '</span>' +
      '<span class="atc-button__prices">' + priceHtml + '</span>'
    )
  }

  function usesRxConfigModal() {
    const t = window.pdp.currentProduct?.product_type
    if (t === 'Prescription' || t === 'Ophthalmic') return true
    return false
  }

  function getMainAtcButton() {
    const productId = window.pdp.currentProduct?.id
    if (!productId) return document.querySelector('.product__information .product__information_block.atc:not(.rx-config-modal__atc) .atc-button')
    return document.querySelector(`.product__information .product__information_block.atc[product_id="${productId}"] .atc-button`)
  }

  function getMainAtcBlock() {
    const productId = window.pdp.currentProduct?.id
    if (productId) {
      const byId = document.querySelector(`.product__information .product__information_block.atc:not(.hidden)[product_id="${productId}"]`)
      if (byId) return byId
    }
    return document.querySelector('.product__information .product__information_block.atc:not(.hidden):not(.rx-config-modal__atc)')
  }

  function getRxConfigStickyAtcButton() {
    return document.querySelector('#rx-config-modal .rx-config-modal__atc .atc-button')
  }

  function syncRxConfigModalProductId() {
    const stickyAtc = document.querySelector('#rx-config-modal .rx-config-modal__atc')
    if (stickyAtc && window.pdp.currentProduct?.id) {
      stickyAtc.setAttribute('product_id', String(window.pdp.currentProduct.id))
    }
  }

  function mountRxConfigModal() {
    const modal = document.getElementById('rx-config-modal')
    const slot = document.getElementById('rx-config-modal-options')
    const source = document.querySelector('[data-rx-config-source]') || document.querySelector('.product__information_block.rx-information')
    if (!modal || !slot) return
    if (source && source.parentElement !== slot) {
      source.classList.add('rxc-options')
      slot.appendChild(source)
      source.classList.remove('hidden')
    }
    if (modal.dataset.bound === '1') return
    modal.dataset.bound = '1'
    modal.querySelectorAll('[data-rx-config-close]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        closeRxConfigModal()
      })
    })
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) closeRxConfigModal()
    })
    syncRxConfigModalProductId()
  }
  window.mountRxConfigModal = mountRxConfigModal

  function syncRxConfigModalGallery() {
    if (typeof window.updateRxConfigModalPreview === 'function') {
      window.updateRxConfigModalPreview()
    } else if (window.RxConfigModalSteps && typeof window.RxConfigModalSteps.updatePreviewMeta === 'function') {
      window.RxConfigModalSteps.updatePreviewMeta()
    }
  }

  function keepRxConfigOptionPanelsOpen() {
    const modal = document.getElementById('rx-config-modal')
    const root = modal || document
    root.querySelectorAll(
      '.dropdown.lens-style .dropdown-panel, .dropdown.lens-color .dropdown-panel, .dropdown.lens-type .dropdown-panel, .dropdown.oph-type .dropdown-panel, .dropdown.lens-upgrade .dropdown-panel'
    ).forEach((panel) => {
      panel.classList.remove('disabled')
    })
  }
  window.keepRxConfigOptionPanelsOpen = keepRxConfigOptionPanelsOpen

  function openRxConfigModal() {
    mountRxConfigModal()
    const modal = document.getElementById('rx-config-modal')
    if (!modal) return
    renderSafetyLensTypeModalOptions(window.pdp.currentProduct)
    syncRxConfigModalProductId()
    keepRxConfigOptionPanelsOpen()
    modal.hidden = false
    document.documentElement.style.overflow = 'hidden'
    requestAnimationFrame(() => {
      modal.classList.add('is-open')
      keepRxConfigOptionPanelsOpen()
      if (typeof changeSliderImages === 'function') changeSliderImages()
      if (typeof window.syncRxLensColorProductImages === 'function') {
        window.syncRxLensColorProductImages()
      }
      updateATCText()
      if (window.RxConfigModalSteps && typeof window.RxConfigModalSteps.onOpen === 'function') {
        window.RxConfigModalSteps.onOpen()
      }
      if (typeof window.syncPdpMobileStickyAtc === 'function') window.syncPdpMobileStickyAtc()
    })
    const closeBtn = modal.querySelector('.rx-config-modal__close')
    if (closeBtn) closeBtn.focus()
  }
  window.openRxConfigModal = openRxConfigModal

  function closeRxConfigModal() {
    const modal = document.getElementById('rx-config-modal')
    if (!modal || modal.hidden) return
    modal.classList.remove('is-open')
    document.documentElement.style.overflow = ''
    let closed = false
    const finish = () => {
      if (closed) return
      closed = true
      modal.hidden = true
      modal.removeEventListener('transitionend', onEnd)
      // Re-apply lens color to gallery thumbs + frame swatches after modal unmounts
      if (typeof changeSliderImages === 'function') changeSliderImages()
      if (typeof window.syncPdpMobileStickyAtc === 'function') window.syncPdpMobileStickyAtc()
    }
    const onEnd = (e) => {
      if (e.target !== modal.querySelector('.rx-config-modal__shell')) return
      finish()
    }
    modal.addEventListener('transitionend', onEnd)
    setTimeout(finish, 400)
  }
  window.closeRxConfigModal = closeRxConfigModal

  function setSepDesignB1g2fContent(productType, price) {
    const b1g2fWrapper = document.querySelector('.product__information_block.b1g2f')
    if (!b1g2fWrapper) return
    if (document.querySelector('.sep-design-pdp.is-side-shield-pdp')) {
      b1g2fWrapper.classList.add('hidden')
      b1g2fWrapper.hidden = true
      return
    }

    if (productType === 'Sunglasses' || productType === 'Blue Light' || productType === 'Safety') {
      const amount = price != null ? price : window.pdp.selectedVariant?.price || window.pdp.currentProduct?.variants?.[0]?.price
      const isSafety = productType === 'Safety'
      const badgePrice = formatSepDesignOfferMoney(amount)
      b1g2fWrapper.classList.remove('hidden')
      b1g2fWrapper.classList.add('pdp-offer')
      b1g2fWrapper.classList.remove('pdp-offer--rx')
      const sub = isSafety
          ? 'Add any 2 more pairs — safety or sunglasses.'
          : 'Add All 3 Pairs to Your Cart. Rx & Mystery Pairs Excluded.'
      b1g2fWrapper.innerHTML =
        '<span class="pdp-offer__gift" aria-hidden="true">🕶</span>' +
        '<div class="pdp-offer__text">' +
          '<b>Buy 1, get any 2 free<sup>™</sup></b>' +
          '<span>' + sub + '</span>' +
        '</div>' +
        '<span class="pdp-offer__badge"' + (isSafety ? ' data-safety-trio-badge' : '') + '>3 for ' + badgePrice + '</span>'
      return
    }

    if (productType === 'Prescription' || productType === 'Ophthalmic') {
      b1g2fWrapper.classList.remove('hidden')
      b1g2fWrapper.classList.add('pdp-offer', 'pdp-offer--rx')
      b1g2fWrapper.innerHTML =
        '<span class="pdp-offer__gift" aria-hidden="true">🕶</span>' +
        '<div class="pdp-offer__text">' +
          '<b>30% OFF ANY SINGLE PAIR</b>' +
          '<span>Auto-applied at checkout.</span>' +
        '</div>' +
        '<span class="pdp-offer__badge">SAVE 30%</span>'
      return
    }

    b1g2fWrapper.classList.remove('hidden')
    b1g2fWrapper.classList.remove('pdp-offer', 'pdp-offer--rx')
    b1g2fWrapper.innerHTML = '<div><strong><em>' + (window.SEP_DESIGN_PDP.b1g2fRandomCopy || '') + '</em>&trade;</strong> | JUST ADD ALL 3 PAIRS TO CART</div><div>or 30% OFF ANY SINGLE PAIR</div>'
  }

  function coerceProductTags(tags) {
    if (Array.isArray(tags)) return tags
    if (typeof tags === 'string' && tags.trim()) {
      return tags.split(',').map((t) => t.trim()).filter(Boolean)
    }
    return []
  }

  const setState = {
    'currentProductHandle': (value) => {
      if (window.pdp.currentProductHandle === value) return
      if (!value) return

      window.pdp.mainSliderPosition.isFirstLoad = true
      // Prefer currentProductHandle (sync) over currentProduct.handle (lags until JSON returns)
      const prevHandle = window.pdp.currentProductHandle || window.pdp.currentProduct?.handle || value

      if (prevHandle && prevHandle !== value) {
        restoreMainSliderWrapperIntoRoot(prevHandle)
      }

      window.pdp.currentProductHandle = value
      document.dispatchEvent(new CustomEvent('state:change:currentProductHandle', {
        detail: {
          value
        }
      }))
    },
    'currentProduct': (value) => {
      if (value) {
        value.tags = coerceProductTags(value.tags)
        if (!value.product_type && (value.productType === 'Safety' || /-z87$/.test(value.handle || ''))) {
          value.product_type = 'Safety'
        }
      }
      const prev = window.pdp.currentProduct
      if (
        prev?.handle &&
        value?.handle &&
        prev.handle !== value.handle &&
        isSafetyPdpProduct(prev) &&
        isSafetyPdpProduct(value)
      ) {
        window.pdp._safetyShieldSnap = snapshotSafetyShieldsByTitle()
        if (window.pdp.safetyLensType) window.pdp._safetyLensWanted = window.pdp.safetyLensType
      }
      window.pdp.currentProduct = value
      document.dispatchEvent(new CustomEvent('state:change:currentProduct', {
        detail: {
          value
        }
      }))
    },
    'initialized': (value) => {
      if (window.pdp.initialized === value) return
      window.pdp.initialized = value
      document.dispatchEvent(new CustomEvent('state:change:initialized', {
        detail: {
          value
        }
      }))
    },
    'currentProductType': (value) => {
      if (window.pdp.currentProductType === value) return
      window.pdp.currentProductType = value
      document.dispatchEvent(new CustomEvent('state:change:currentProductType', {
        detail: {
          value
        }
      }))
    },
    'mainCollection': (value) => {
      if (window.pdp.mainCollection === value) return
      window.pdp.mainCollection = value
      document.dispatchEvent(new CustomEvent('state:change:mainCollection', {
        detail: {
          value
        }
      }))
    },
    'lens-color': (value) => {
      // if (window.pdp.rx['lens-color'] === value) return

      // Handle transition from tinted colors to clear/black/brown (or new standard colors)
      const previousLensColor = window.pdp.rx['lens-color']
      const standardColors = ['clear', 'black', 'brown', 'yellow', 'photochromic-gray', 'photochromic-brown']
      const tintedLensColors = ['coastal-blue', 'rose-pink', 'silver', 'green-vibrant', 'purple-pastel']
      if (tintedLensColors.includes(previousLensColor) &&
          standardColors.includes(value)) {
        
        // Check if impact-resistant is selected
        if (window.pdp.rx['lens-upgrade'] && window.pdp.rx['lens-upgrade']['impact-resistant']) {
          // Mark impact-resistant as false and make standard true
          const currentUpgrades = Object.keys(window.pdp.rx['lens-upgrade']).filter(k => 
            window.pdp.rx['lens-upgrade'][k] && k !== 'impact-resistant'
          )
          currentUpgrades.push('standard')
          setState['lens-upgrade'](currentUpgrades)
          console.log('[lens-color] switched from impact-resistant to standard due to color change', {
            from: previousLensColor,
            to: value,
            newUpgrades: currentUpgrades
          })
        }
      }
      
      window.pdp.rx['lens-color'] = value
      document.dispatchEvent(new CustomEvent('state:change:lens-color', {
        detail: {
          value
        }
      }))
    },
    'lens-type': (value) => {
      // if (window.pdp.rx['lens-type'] === value) return
      window.pdp.rx['lens-type'] = value
      document.dispatchEvent(new CustomEvent('state:change:lens-type', {
        detail: {
          value
        }
      }))
    },
    'lens-style': (value) => {
      window.pdp.rx['lens-style'] = value
      document.dispatchEvent(new CustomEvent('state:change:lens-style', {
        detail: {
          value
        }
      }))
    },
    'oph-type': (value) => {
      // if (window.pdp.rx['oph-type'] === value) return
      window.pdp.rx['oph-type'] = value
      document.dispatchEvent(new CustomEvent('state:change:oph-type', {
        detail: {
          value
        }
      }))
    },
    'lens-upgrade': (value) => {
      if (compareArrays(Object.keys(window.pdp.rx['lens-upgrade']).filter(k => window.pdp.rx['lens-upgrade'][k]).map(k => window.pdp.rx['lens-upgrade'][k]), value)) return
      Object.keys(window.pdp.rx['lens-upgrade']).forEach(k => {
        if (value.includes(k)) {
          window.pdp.rx['lens-upgrade'][k] = true
        } else {
          window.pdp.rx['lens-upgrade'][k] = false
        }
      })
      document.dispatchEvent(new CustomEvent('state:change:lens-upgrade', {
        detail: {
          value
        }
      }))
    },
    'selectedVariant': (value) => {
      // if (!value) return
      if (window.pdp.selectedVariant?.id === value?.id) return
      window.pdp.selectedVariant = value
      document.dispatchEvent(new CustomEvent('state:change:selectedVariant', {
        detail: {
          value
        }
      }))
    },
    'variant-id': (value) => {
      if (window.pdp.variantId === value) return
      window.pdp.variantId = value
      document.dispatchEvent(new CustomEvent('state:change:variant-id', {
        detail: {
          value
        }
      }))
    }
  }

  window.pdpSetCurrentProductHandle = setState['currentProductHandle']

  function fetchCollectionProductsStorefrontFirst(collectionHandle) {
    if (!collectionHandle) return Promise.resolve([])
    if (sepStorefrontEnabled()) {
      return window.sepStorefront
        .collectionByHandle(collectionHandle)
        .then(collection => (collection && collection.products) || [])
        .catch(() =>
          fetch(`/collections/${collectionHandle}/products.json`)
            .then(res => res.json())
            .then(data => data.products || [])
        )
    }
    return fetch(`/collections/${collectionHandle}/products.json`)
      .then(res => res.json())
      .then(data => data.products || [])
  }

  fetchProductJsonMerged('/products/' + window.SEP_DESIGN_PDP.productHandle + '.json')
    .then(data => {
      const handle = data?.product?.handle
      if (!handle) return
      if (window.pdp.pendingSizeHandle && window.pdp.pendingSizeHandle !== handle) return
      if (window.pdp.currentProductHandle && window.pdp.currentProductHandle !== handle) return
      seedCurrentProductHandle(handle)
      setState['currentProduct'](data.product)
      setState['initialized'](true)
    })
  
  if (window.pdp.mainCollection) {
    fetchCollectionProductsStorefrontFirst(window.pdp.mainCollection).then(products => {
      window.pdp.mainCollectionProducts = products
    })
  }
    
  function fetchProductsByHandles(handles) {
    const list = [...new Set((handles || []).filter(Boolean))]
    if (!list.length) return Promise.resolve()
    const concurrency = 2
    let index = 0
    const workers = Array.from({ length: Math.min(concurrency, list.length) }, async () => {
      while (index < list.length) {
        const handle = list[index++]
        await ensureSepDesignProductAssets(handle)
      }
    })
    return Promise.all(workers).then(() => {})
  }

  function pdpBackgroundTask() {
    const currentProduct = window.pdp.currentProduct
    if (currentProduct?.handle) fetchProductsByHandles([currentProduct.handle])
  }

  function haveSameElements(arr1, arr2) {
    return arr1.length === arr2.length && 
      arr1.every(item => arr2.includes(item))
  }

  function updateLensUpgradeAvailability() {
    if (window.pdp.currentProduct?.product_type !== 'Prescription' && window.pdp.currentProduct?.product_type !== 'Ophthalmic') return
    
    const lensUpgradeOptions = document.querySelectorAll('.dropdown.lens-upgrade .dropdown-option[data-value]')
    
    // Reset all options to visible first
    lensUpgradeOptions.forEach(option => {
      if (option) {
        option.classList.remove('hidden')
      }
    })
    
    if (window.pdp.currentProduct?.product_type === 'Prescription') {
      const lensColor = window.pdp.rx['lens-color']
      // Apply restrictions based on lens color
      if (['clear', 'yellow', 'photochromic-gray', 'photochromic-brown'].includes(lensColor)) {
        const antiReflectiveOption = document.querySelector('.dropdown-option[data-value="anti-reflective-coating"]')
        const blueLightOption = document.querySelector('.dropdown-option[data-value="blue-light"]')
        const polarizationOption = document.querySelector('.dropdown-option[data-value="polarized"]')

        if (polarizationOption) {
          polarizationOption.classList.add('hidden')
          // Set polarization to false using setState
          if (window.pdp.rx['lens-upgrade']) {
            const currentUpgrades = Object.keys(window.pdp.rx['lens-upgrade']).filter(k => window.pdp.rx['lens-upgrade'][k] && k !== 'polarized')
            setState['lens-upgrade'](currentUpgrades)
          }
        }
        
        if (antiReflectiveOption) {
          antiReflectiveOption.classList.remove('hidden')
        }
        
        if (blueLightOption) {
          // Photochromic has no Blue Light variants in Shopify
          if (['photochromic-gray', 'photochromic-brown'].includes(lensColor)) {
            blueLightOption.classList.add('hidden')
            if (window.pdp.rx['lens-upgrade']) {
              const currentUpgrades = Object.keys(window.pdp.rx['lens-upgrade']).filter(k => window.pdp.rx['lens-upgrade'][k] && k !== 'blue-light')
              setState['lens-upgrade'](currentUpgrades)
            }
          } else {
            blueLightOption.classList.remove('hidden')
          }
        }
      } else if (['black', 'brown'].includes(lensColor)) {
        // Show anti-reflective coating and polarized; hide blue light
        const antiReflectiveOption = document.querySelector('.dropdown-option[data-value="anti-reflective-coating"]')
        const blueLightOption = document.querySelector('.dropdown-option[data-value="blue-light"]')
        const polarizationOption = document.querySelector('.dropdown-option[data-value="polarized"]')
        
        if (antiReflectiveOption) {
          antiReflectiveOption.classList.remove('hidden')
        }
        
        if (polarizationOption) {
          polarizationOption.classList.remove('hidden')
        }

        if (blueLightOption) {
          blueLightOption.classList.add('hidden')
          // Set polarization to false using setState
          if (window.pdp.rx['lens-upgrade']) {
            const currentUpgrades = Object.keys(window.pdp.rx['lens-upgrade']).filter(k => window.pdp.rx['lens-upgrade'][k] && k !== 'blue-light')
            setState['lens-upgrade'](currentUpgrades)
          }
        }
      } else if (['coastal-blue', 'rose-pink', 'silver', 'green-vibrant', 'purple-pastel'].includes(lensColor)) {
        // Mirrored: Standard not available. Hide AR + blue light. Default to Impact Resistant if Standard was selected.
        const standardOption = document.querySelector('.dropdown-option[data-value="standard"]')
        const antiReflectiveOption = document.querySelector('.dropdown-option[data-value="anti-reflective-coating"]')
        const blueLightOption = document.querySelector('.dropdown-option[data-value="blue-light"]')

        if (standardOption) {
          standardOption.classList.add('hidden')
        }

        if (antiReflectiveOption) {
          antiReflectiveOption.classList.add('hidden')
        }
        
        if (blueLightOption) {
          blueLightOption.classList.add('hidden')
        }
        
        if (window.pdp.rx['lens-upgrade']) {
          const currentUpgrades = Object.keys(window.pdp.rx['lens-upgrade']).filter(k => 
            window.pdp.rx['lens-upgrade'][k] && 
            k !== 'anti-reflective-coating' && 
            k !== 'blue-light' &&
            k !== 'standard'
          )
          if (window.pdp.rx['lens-upgrade']['standard']) currentUpgrades.push('impact-resistant')
          setState['lens-upgrade'](currentUpgrades)
        }
        
        const polarizationOption = document.querySelector('.dropdown-option[data-value="polarized"]')
        if (polarizationOption) {
          polarizationOption.classList.remove('hidden')
        }
      }
    }

    if (window.pdp.currentProduct?.product_type === 'Ophthalmic') {
      const ophType = window.pdp.rx['oph-type']

      const standardOption = document.querySelector('.dropdown-option[data-value="standard"]')
      const impactResistantOption = document.querySelector('.dropdown-option[data-value="impact-resistant"]')
      const blueLightOption = document.querySelector('.dropdown-option[data-value="blue-light"]')
      const highIndexOption = document.querySelector('.dropdown-option[data-value="high-index"]')
      const antiReflectiveCoatingOption = document.querySelector('.dropdown-option[data-value="anti-reflective-coating"]')
      const polarizedOption = document.querySelector('.dropdown-option[data-value="polarized"]')

      if (ophType === 'prescription') {

        if (polarizedOption) {
          polarizedOption.classList.add('hidden')
        }

        if (standardOption) {
          standardOption.classList.remove('hidden')
        }

        if (impactResistantOption) {
          impactResistantOption.classList.remove('hidden')
        }

        if (blueLightOption) {
          blueLightOption.classList.remove('hidden')
        }

        if (highIndexOption) {
          highIndexOption.classList.remove('hidden')
        }

        if (antiReflectiveCoatingOption) {
          antiReflectiveCoatingOption.classList.remove('hidden')
        }

        if (window.pdp.rx['lens-upgrade']) {
          const currentUpgrades = Object.keys(window.pdp.rx['lens-upgrade']).filter(k => window.pdp.rx['lens-upgrade'][k] && k !== 'polarized')
          setState['lens-upgrade'](currentUpgrades)
        }
      } else if (ophType === 'readers') {
        if (standardOption) {
          standardOption.classList.add('hidden')
        }

        if (impactResistantOption) {
          impactResistantOption.classList.add('hidden')
        }

        if (highIndexOption) {
          highIndexOption.classList.add('hidden')
        }

        if (antiReflectiveCoatingOption) {
          antiReflectiveCoatingOption.classList.add('hidden')
        }

        if (polarizedOption) {
          polarizedOption.classList.add('hidden')
        }

        if (blueLightOption) {
          blueLightOption.classList.remove('hidden')
        }

        if (window.pdp.rx['lens-upgrade']) {
          const currentUpgrades = Object.keys(window.pdp.rx['lens-upgrade']).filter(k => window.pdp.rx['lens-upgrade'][k] && k !== 'standard' && k !== 'impact-resistant' && k !== 'high-index' && k !== 'anti-reflective-coating' && k !== 'polarized')
          currentUpgrades.push('standard')
          setState['lens-upgrade'](currentUpgrades)
        }
      } else {
        setState['lens-upgrade'](['standard'])
      }
    }
    
    // Update the dropdown display to reflect current selections
    const upgradeSelect = document.querySelector('[data-dropdown="lens-upgrade"]')
    if (upgradeSelect) {
      const event = new CustomEvent('lens-upgrade:availability-changed')
      upgradeSelect.dispatchEvent(event)
    }
  }

  function updateLensUpgradePricing() {
    if (window.pdp.currentProduct?.product_type !== 'Prescription' && window.pdp.currentProduct?.product_type !== 'Ophthalmic') return

    const lensType = window.pdp.rx['lens-type']
    const lensColor = window.pdp.rx['lens-color']
    
    // Get the upgrade options
    const highIndexOption = document.querySelector('.dropdown-option[data-value="high-index"]')
    const impactResistantOption = document.querySelector('.dropdown-option[data-value="impact-resistant"]')
    
    if (!highIndexOption || !impactResistantOption) return
    
    const highIndexText = highIndexOption.querySelector('.dropdown-text-main')
    const impactResistantText = impactResistantOption.querySelector('.dropdown-text-main')
    
    if (!highIndexText || !impactResistantText) return
    
    // Define pricing based on lens type and color
    let highIndexPrice = ''
    let impactResistantPrice = ''
    
    const standardLensColors = ['clear', 'black', 'brown', 'yellow', 'photochromic-gray', 'photochromic-brown']
    const tintedLensColorsPricing = ['coastal-blue', 'rose-pink', 'silver', 'green-vibrant', 'purple-pastel']
    if (lensType === 'single-vision') {
      if (standardLensColors.includes(lensColor) || window.pdp.currentProduct?.product_type === 'Ophthalmic') {
        highIndexPrice = ' +$135'
        impactResistantPrice = ' +$35'
      } else if (tintedLensColorsPricing.includes(lensColor)) {
        highIndexPrice = ' +$135'
        impactResistantPrice = ' FREE'
      }
    } else if (lensType === 'progressive') {
      // Rx High Index is +$135 on every lens type; Ophthalmic progressive is still +$55
      const progressiveHighIndexPrice = window.pdp.currentProduct?.product_type === 'Ophthalmic' ? ' +$55' : ' +$135'
      if (standardLensColors.includes(lensColor) || window.pdp.currentProduct?.product_type === 'Ophthalmic') {
        highIndexPrice = progressiveHighIndexPrice
        impactResistantPrice = ' +$35'
      } else if (tintedLensColorsPricing.includes(lensColor)) {
        highIndexPrice = progressiveHighIndexPrice
        impactResistantPrice = ' FREE'
      }
    }
    
    // Update the text content
    if (highIndexPrice && highIndexText) {
      const baseText = highIndexText.textContent.replace(/\s*\+\$\d+\s*$/, '').replace(/\s*FREE\s*$/, '')
      highIndexText.textContent = baseText + highIndexPrice
    }
    
    if (impactResistantPrice && impactResistantText) {
      const baseText = impactResistantText.textContent.replace(/\s*\+\$\d+\s*$/, '').replace(/\s*FREE\s*$/, '')
      impactResistantText.textContent = baseText + impactResistantPrice
    }
  }
  
  function updateLensTypeAvailability() {
    if (window.pdp.currentProduct?.product_type !== 'Ophthalmic') return

    const ophType = window.pdp.rx['oph-type']

    const lensTypeOptions = document.querySelectorAll('#lens-type-panel .dropdown-option[data-value]')
    if (ophType === 'prescription') {
      lensTypeOptions.forEach(option => {
        if (option) {
          if (['single-vision', 'progressive'].includes(option.getAttribute('data-value'))) option.classList.remove('hidden')
          if (['+1.5', '+2.0', '+2.5'].includes(option.getAttribute('data-value'))) option.classList.add('hidden')
        }
      })
      const lensTypeDropdown = document.querySelector('.dropdown.lens-type')
      if (lensTypeDropdown) {
        lensTypeDropdown.classList.remove('hidden')
      }
      const singleVisionOption = document.querySelector('.dropdown-option[data-value="single-vision"]')
      if (singleVisionOption) {
        singleVisionOption.click()
      }
      const lensUpgradeDropdown = document.querySelector('.dropdown.lens-upgrade')
      if (lensUpgradeDropdown) {
        lensUpgradeDropdown.classList.remove('hidden')
      }
    } else if (ophType === 'readers') {
      lensTypeOptions.forEach(option => {
        if (option) {
          if (['+1.5', '+2.0', '+2.5'].includes(option.getAttribute('data-value'))) option.classList.remove('hidden')
          if (['single-vision', 'progressive'].includes(option.getAttribute('data-value'))) option.classList.add('hidden')
        }
      })
      const lensTypeDropdown = document.querySelector('.dropdown.lens-type')
      if (lensTypeDropdown) {
        lensTypeDropdown.classList.remove('hidden')
      }
      const readersOption = document.querySelector('.dropdown-option[data-value="+1.5"]')
      if (readersOption) {
        readersOption.click()
      }
      const lensUpgradeDropdown = document.querySelector('.dropdown.lens-upgrade')
      if (lensUpgradeDropdown) {
        lensUpgradeDropdown.classList.remove('hidden')
      }
    } else {
      lensTypeOptions.forEach(option => {
        if (option) {
          option.classList.add('hidden')
        }
      })
      const lensTypeDropdown = document.querySelector('.dropdown.lens-type')
      if (lensTypeDropdown) {
        lensTypeDropdown.classList.add('hidden')
      }
      const lensUpgradeDropdown = document.querySelector('.dropdown.lens-upgrade')
      if (lensUpgradeDropdown) {
        lensUpgradeDropdown.classList.add('hidden')
      }
      const singleVisionOption = document.querySelector('.dropdown-option[data-value="single-vision"]')
      if (singleVisionOption) {
        singleVisionOption.click()
      }
    }

    // Update the dropdown display to reflect current selections
    const upgradeSelect = document.querySelector('[data-dropdown="lens-upgrade"]')
    if (upgradeSelect) {
      const event = new CustomEvent('lens-upgrade:availability-changed')
      upgradeSelect.dispatchEvent(event)
    }
  }

  function normalizeRxOptionHandle(value) {
    if (value == null || value === '') return ''
    return String(value)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/_/g, '-')
      .replace(/[\u2010-\u2015\u2212\uFE58\uFE63\uFF0D]/g, '-')
  }

  function normalizeSafetyOption(value) {
    return normalizeRxOptionHandle(value)
  }

  /**
   * Safety media filenames encode the lens as an underscore-delimited token, e.g.
   * MATTEX-XL-Z87_Stormy_02_Green_NPAF_SS. Matching must be token-exact because PAF is a
   * substring of NPAF. The map lives in custom.js so collection cards filter identically.
   */
  const SAFETY_LENS_IMAGE_CODES = window.SAFETY_LENS_IMAGE_CODES || {}

  function getSafetyLensImageCode(value) {
    return SAFETY_LENS_IMAGE_CODES[normalizeSafetyOption(value)] || ''
  }

  function srcMatchesSafetyLensCode(src, code) {
    if (!src || !code) return false
    const file = String(src).split(/[?#]/)[0].split('/').pop()
    return file.toUpperCase().split(/[_.]/).includes(code)
  }

  function writeSafetyVariantToUrl(variant) {
    if (!variant?.id) return
    try {
      const url = new URL(window.location.href)
      url.searchParams.set('variant', String(variant.id))
      url.searchParams.delete('safety-lens')
      window.history.replaceState({}, '', url)
    } catch (e) {}
  }

  /**
   * Collection -> PDP handoff. `?variant=` (preferred) or `?safety-lens=` seeds the lens
   * once per page load so price, gallery and modal resolve to it; later colour switches keep it.
   */
  function applySafetyLensFromUrlIfApplicable(product) {
    if (window.pdp._safetyLensFromUrlApplied) return
    const p = product || window.pdp.currentProduct
    if (p?.product_type !== 'Safety') return

    let variantId = ''
    let raw = ''
    try {
      const params = new URL(window.location.href).searchParams
      variantId = params.get('variant') || ''
      raw = params.get('safety-lens') || ''
    } catch (e) {}
    if (!variantId && !raw) return

    window.pdp._safetyLensFromUrlApplied = true
    if (variantId) {
      const byId = (p.variants || []).find((v) => String(v.id) === String(variantId))
      if (byId?.option1) {
        window.pdp.safetyLensType = byId.option1
        return
      }
    }
    if (!raw) return
    const wanted = normalizeSafetyOption(raw)
    const match = (p.variants || []).find((v) => normalizeSafetyOption(v.option1) === wanted)
    if (match?.option1) window.pdp.safetyLensType = match.option1
  }

  function findSafetyLensTypeVariant(product) {
    const variants = product?.variants || []
    if (!variants.length) return null
    const wanted = window.pdp._safetyLensWanted || window.pdp.safetyLensType
    let match = null
    if (wanted) {
      match = variants.find((v) => v.option1 === wanted)
      if (!match) {
        const wantedNorm = normalizeSafetyOption(wanted)
        match = variants.find((v) => normalizeSafetyOption(v.option1) === wantedNorm)
      }
      if (!match && isSmokeSafetyLensOption(wanted)) {
        match = variants.find((v) => isSmokeSafetyLensOption(v.option1))
      }
    }
    if (!match) {
      try {
        const urlVid = new URL(window.location.href).searchParams.get('variant')
        if (urlVid) match = variants.find((v) => String(v.id) === String(urlVid)) || null
      } catch (e) {}
    }
    // Do not stamp first-available over a lens the shopper already picked.
    if (!match && !wanted) match = variants.find((v) => v.available) || variants[0]
    if (match?.option1) window.pdp.safetyLensType = match.option1
    return match
  }

  function getVisibleSafetyLensTypeSelector() {
    const visibleContainer = document.querySelector('.other-products-container:not(.hidden)')
    return visibleContainer?.querySelector('[data-lens-type-selector]') ||
      document.querySelector('[data-lens-type-selector]')
  }

  function syncSafetyLensTypeButtons(variant) {
    const selector = getVisibleSafetyLensTypeSelector()
    if (!selector) return
    const variantId = variant?.id != null ? String(variant.id) : ''
    const option = variant?.option1 || ''

    selector.querySelectorAll('.nvz-lens__row').forEach((btn) => {
      const on = variantId && btn.dataset.variantId === variantId
      btn.classList.toggle('is-on', on)
      btn.setAttribute('aria-pressed', on ? 'true' : 'false')
    })
    selector.querySelectorAll('.pdp-lens-type-selector__btn').forEach((btn) => {
      const on = variantId && btn.dataset.variantId === variantId
      btn.classList.toggle('on', on)
      btn.setAttribute('aria-pressed', on ? 'true' : 'false')
    })
    const label = selector.querySelector('[data-lens-type-label]')
    if (label && option) label.textContent = safetyLensUiLabel(option, window.pdp.currentProduct)

    syncSafetyLensHelperCopy(variant)
    paintSafetyLensNotify()
  }

  /* ---------- Safety lens: sold-out rows open the back-in-stock modal ---------- */
  // Sold out takes the blame and answers the only question that follows it — is it coming back.
  // A function, not a const: syncSafetyLensTypeButtons can run before this line executes.
  function safetyLensSoldOutSub() {
    return 'Sold out &mdash; we suck. <b>More On The Way.</b>'
  }

  function paintSafetyLensNotify() {
    const selector = getVisibleSafetyLensTypeSelector()
    if (!selector) return
    selector.querySelectorAll('[data-lens-item]').forEach((item) => {
      const row = item.querySelector('.nvz-lens__row')
      if (!row) return
      const out = row.dataset.available === 'false'
      item.classList.toggle('is-out', out)
      const note = row.querySelector('[data-lens-note]')
      if (note) note.textContent = 'Notify me'
      const sub = row.querySelector('[data-lens-sub]')
      if (sub && out) sub.innerHTML = safetyLensSoldOutSub()
    })
  }

  /** After colourway / size handle swap, remint variant ids + prices on the inline rows. */
  function refreshSafetyLensInlineFromProduct(product) {
    const p = product || window.pdp.currentProduct
    if (p?.product_type !== 'Safety') return
    syncSmokeLensChipOverwrite(p)
    const selector = getVisibleSafetyLensTypeSelector()
    if (!selector) return
    const FACE_SUB = {
      'clear-anti-fog': 'Shop, warehouse, night work',
      clear: 'Shop, warehouse, night work',
      'non-polarized-anti-fog': 'Bright sun — screens stay readable',
      smoke: 'Bright sun — screens stay readable',
      'polarized-anti-fog': 'Kills glare off asphalt, water, metal',
      polarized: 'Kills glare off asphalt, water, metal',
      photochromic: 'Darkens outside, clears indoors'
    }
    selector.querySelectorAll('.nvz-lens__row').forEach((btn) => {
      const opt = btn.dataset.option || ''
      const match = (p.variants || []).find(
        (v) => normalizeSafetyOption(v.option1) === normalizeSafetyOption(opt)
      )
      if (!match) return
      btn.dataset.variantId = String(match.id)
      // Liquid already used inventory_quantity. Storefront payloads often omit qty and
      // report availableForSale=false on draft Safety SKUs — don't clobber in-stock UI.
      const qty = Number(match.inventory_quantity)
      const hasQty = Number.isFinite(qty)
      if (hasQty) {
        const inStock = qty > 0 || match.available === true
        btn.dataset.available = inStock ? 'true' : 'false'
        btn.classList.toggle('is-sold-out', !inStock)
        const sub = btn.querySelector('[data-lens-sub]')
        if (sub) {
          if (inStock) sub.textContent = FACE_SUB[normalizeSafetyOption(opt)] || sub.textContent
          else sub.innerHTML = safetyLensSoldOutSub()
        }
      } else if (match.available === true) {
        btn.dataset.available = 'true'
        btn.classList.remove('is-sold-out')
        const sub = btn.querySelector('[data-lens-sub]')
        if (sub) sub.textContent = FACE_SUB[normalizeSafetyOption(opt)] || sub.textContent
      }
      btn.disabled = false
      btn.removeAttribute('aria-disabled')
      const amt = btn.querySelector('.nvz-lens__amt')
      if (amt) {
        const dollars = coerceVariantPriceDollars(match.price)
        if (!isNaN(dollars)) {
          const disc = formatSepDesignOfferMoney(dollars * 0.7)
          const full = formatSepDesignOfferMoney(dollars)
          if (disc) amt.innerHTML = full ? disc + '<s>' + full + '</s>' : disc
        }
      }
    })
    syncSafetyLensTypeButtons(findSafetyLensTypeVariant(p) || window.pdp.selectedVariant)
    syncSmokeLensChipOverwrite(p)
  }

  function smokeLensOverwriteFromTags(tags) {
    const list = coerceProductTags(tags)
    for (let i = 0; i < list.length; i++) {
      const t = String(list[i] || '')
      if (t.indexOf('_smoke_lens_overwrite:') !== 0) continue
      return t
        .slice('_smoke_lens_overwrite:'.length)
        .trim()
        .toLowerCase()
        .replace(/-/g, '_')
    }
    return ''
  }

  function isSmokeSafetyLensOption(option) {
    const key = normalizeSafetyOption(option)
    return key === 'smoke' || key === 'non-polarized-anti-fog' || key === 'non-polarized'
  }

  function smokeLensDisplayName(overwrite) {
    return overwrite === 'emerald_green' ? 'Emerald Green' : 'Smoke'
  }

  /** Face label only. Cart / variant / safetyLensType stay the Shopify option value. */
  function safetyLensUiLabel(option, product) {
    if (isSmokeSafetyLensOption(option)) {
      return smokeLensDisplayName(smokeLensOverwriteFromTags(product?.tags))
    }
    return option == null ? '' : String(option)
  }

  function syncSmokeLensChipOverwrite(product) {
    const overwrite = smokeLensOverwriteFromTags(product?.tags)
    const emerald = overwrite === 'emerald_green'
    const face = smokeLensDisplayName(overwrite)

    const CHIP_KINDS = ['clear', 'smoke', 'green', 'polarized', 'polarized-green', 'photochromic', 'photochromic-green']
    document.querySelectorAll('.nvz-chip[data-chip]').forEach((chip) => {
      const kind = chip.getAttribute('data-chip') || ''
      let faceClass = 'nvz-chip--' + kind
      if (emerald) {
        if (kind === 'smoke') faceClass = 'nvz-chip--green'
        else if (kind === 'polarized') faceClass = 'nvz-chip--polarized-green'
        else if (kind === 'photochromic') faceClass = 'nvz-chip--photochromic-green'
      }
      CHIP_KINDS.forEach((k) => chip.classList.remove('nvz-chip--' + k))
      chip.classList.remove('nvz-chip--emerald-green')
      chip.classList.add(faceClass)
      if (kind !== 'smoke') return
      const row = chip.closest('.nvz-lens__row')
      if (row) {
        row.setAttribute('data-face', face)
        const title = row.querySelector('.nvz-lens__tx > b')
        if (title) {
          const em = title.querySelector('em')
          title.innerHTML = face + (em ? em.outerHTML : '')
        }
      }
      const step = chip.closest('.nvz-modal__step')
      if (step) {
        const heading = step.querySelector('b')
        if (heading) heading.innerHTML = heading.innerHTML.replace(/^(Smoke|Emerald Green)/, face)
      }
    })

    document.querySelectorAll('[data-smoke-alt-name]').forEach((el) => {
      el.textContent = face
    })
  }

  function syncSafetyLensHelperCopy(variant) {
    const antifog = (() => {
      const row = document.querySelector('.nvz-lens__row.is-on')
      if (row) return row.getAttribute('data-antifog') !== 'false'
      const opt = variant?.option1 || window.pdp.safetyLensType || ''
      const key = normalizeSafetyOption(opt)
      return key !== 'photochromic'
    })()
    document.querySelectorAll('[data-safety-lens-copy]').forEach((el) => {
      el.textContent = antifog
        ? el.getAttribute('data-nvz-antifog') || el.textContent
        : el.getAttribute('data-nvz-no-antifog') || el.textContent
    })
  }

  function updateSafetyTrioBadge(variant) {
    if (window.pdp.currentProduct?.product_type !== 'Safety') return
    const badge = document.querySelector('[data-safety-trio-badge]')
    if (!badge) return
    const price = variant?.price ?? window.pdp.selectedVariant?.price
    const dollars = coerceVariantPriceDollars(price)
    if (isNaN(dollars)) return
    const formatted = formatSepDesignOfferMoney(dollars)
    if (formatted) badge.textContent = '3 for ' + formatted
  }

  /* ---------- Safety shields + which-lens modal ---------- */
  function getSafetyShieldCfg() {
    const root =
      document.querySelector('.other-products-container:not(.hidden)') ||
      document.querySelector('.product__information_block.other-products')
    const el =
      root?.querySelector('[data-safety-shields-json]') ||
      document.querySelector('[data-safety-shields-json]')
    if (!el) return { shieldPrice: 1000, shields: [] }
    try {
      return JSON.parse(el.textContent || '{}')
    } catch (err) {
      return { shieldPrice: 1000, shields: [] }
    }
  }

  function safetyShieldCount() {
    if (!window.pdp.safetyShields) return 0
    return Object.keys(window.pdp.safetyShields).reduce(
      (n, k) => n + (window.pdp.safetyShields[k] || 0),
      0
    )
  }

  function moneyFromCents(cents) {
    return formatSepDesignOfferMoney((Number(cents) || 0) / 100)
  }

  function renderSafetyShields() {
    const root =
      document.querySelector('.other-products-container:not(.hidden)') ||
      document.querySelector('.product__information_block.other-products')
    const list =
      root?.querySelector('[data-safety-shield-list]') ||
      document.querySelector('[data-safety-shield-list]')
    if (!list) return
    if (!window.pdp.safetyShields) window.pdp.safetyShields = {}
    const cfg = getSafetyShieldCfg()
    list.innerHTML = ''
    ;(cfg.shields || []).forEach((c) => {
      const qty = window.pdp.safetyShields[c.id] || 0
      const maxQty = Math.max(0, Number(c.qty) || 0)
      // Linked shield products are often still Draft — trust qty from Liquid JSON.
      const inStock = maxQty > 0 || c.available === true
      const row = document.createElement('div')
      row.className = 'nvz-shrow' + (inStock ? '' : ' is-out')

      const sw = document.createElement('span')
      sw.className = 'nvz-shsw'
      sw.style.background = c.swatch || '#9aa0a6'

      const tx = document.createElement('span')
      tx.className = 'nvz-shtx'
      const nm = document.createElement('b')
      nm.textContent = c.title
      const st = document.createElement('span')
      st.textContent = !inStock
        ? 'Sold out'
        : maxQty > 0 && maxQty < 5
          ? 'Only ' + maxQty + ' left'
          : 'In stock'
      tx.appendChild(nm)
      tx.appendChild(st)
      row.appendChild(sw)
      row.appendChild(tx)

      if (inStock) {
        if (qty > 0) {
          const step = document.createElement('span')
          step.className = 'nvz-shstep'
          const minus = document.createElement('button')
          minus.type = 'button'
          minus.setAttribute('aria-label', 'Remove one ' + c.title)
          minus.textContent = '−'
          const n = document.createElement('i')
          n.textContent = String(qty)
          const plus = document.createElement('button')
          plus.type = 'button'
          plus.setAttribute('aria-label', 'Add one ' + c.title)
          plus.textContent = '+'
          minus.addEventListener('click', () => setSafetyShield(c, qty - 1))
          plus.addEventListener('click', () => setSafetyShield(c, qty + 1))
          step.appendChild(minus)
          step.appendChild(n)
          step.appendChild(plus)
          row.appendChild(step)
        } else {
          const add = document.createElement('button')
          add.type = 'button'
          add.className = 'nvz-shadd'
          add.textContent = 'Add'
          add.addEventListener('click', () => setSafetyShield(c, 1))
          row.appendChild(add)
        }
      }
      list.appendChild(row)
    })
  }

  function setSafetyShield(c, qty) {
    if (!window.pdp.safetyShields) window.pdp.safetyShields = {}
    const max = Math.max(1, Number(c.qty) || 1)
    qty = Math.max(0, Math.min(max, qty))
    if (qty === 0) delete window.pdp.safetyShields[c.id]
    else window.pdp.safetyShields[c.id] = qty
    renderSafetyShields()
    paintSafetyShieldSummary()
    paintSafetyAtcTotal()
  }

  function paintSafetyShieldSummary() {
    const root =
      document.querySelector('.other-products-container:not(.hidden)') ||
      document.querySelector('.product__information_block.other-products')
    const cfg = getSafetyShieldCfg()
    const n = safetyShieldCount()
    const amt =
      root?.querySelector('[data-safety-shield-amt]') ||
      document.querySelector('[data-safety-shield-amt]')
    const sub =
      root?.querySelector('[data-safety-shield-sub]') ||
      document.querySelector('[data-safety-shield-sub]')
    if (amt) amt.textContent = n ? '+' + moneyFromCents(n * (cfg.shieldPrice || 0)) : ''
    if (sub) {
      sub.textContent = n
        ? (cfg.shields || [])
            .filter((c) => window.pdp.safetyShields[c.id])
            .map((c) => window.pdp.safetyShields[c.id] + ' × ' + c.title)
            .join(', ')
        : sub.getAttribute('data-nvz-default') || ''
    }
  }

  function paintSafetyAtcTotal() {
    document.querySelectorAll('[data-safety-atc-amt]').forEach((el) => {
      const n = safetyShieldCount()
      if (!n) {
        el.textContent = ''
        return
      }
      const cfg = getSafetyShieldCfg()
      const price = parseFloat(window.pdp.selectedVariant?.price)
      if (isNaN(price)) {
        el.textContent = ''
        return
      }
      const pairCents = Math.round(price * 0.7 * 100)
      const total = pairCents + n * (cfg.shieldPrice || 0)
      el.textContent = moneyFromCents(total)
    })
  }

  function resetSafetyShieldsStaging() {
    window.pdp.safetyShields = {}
    renderSafetyShields()
    paintSafetyShieldSummary()
    paintSafetyAtcTotal()
    document.querySelectorAll('[data-safety-shield-wrap]').forEach((wrap) => {
      wrap.setAttribute('hidden', '')
    })
    document.querySelectorAll('[data-safety-shield-toggle]').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false')
    })
  }

  function buildSafetyCartItems(baseItem) {
    const items = [baseItem]
    if (!window.pdp.safetyShields) return items
    Object.keys(window.pdp.safetyShields).forEach((id) => {
      const qty = window.pdp.safetyShields[id]
      if (qty > 0) items.push({ id: Number(id) || id, quantity: qty })
    })
    return items
  }

  let safetyModalLastFocus = null
  function openSafetyModal(id) {
    const m = document.getElementById(id)
    if (!m) return
    safetyModalLastFocus = document.activeElement
    m.hidden = false
    m.classList.add('is-open')
    document.body.classList.add('nvz-locked')
    const x = m.querySelector('.nvz-modal__x')
    if (x) x.focus()
  }
  function closeSafetyModals() {
    document.querySelectorAll('.nvz-modal.is-open').forEach((m) => {
      m.classList.remove('is-open')
      m.hidden = true
    })
    restoreNotifyMeForm()
    document.body.classList.remove('nvz-locked')
    if (safetyModalLastFocus) safetyModalLastFocus.focus()
  }
  document.addEventListener('keydown', (ev) => {
    if (ev.key !== 'Escape') return
    if (!document.querySelector('.nvz-modal.is-open')) return
    closeSafetyModals()
  })

  // Z87 / Safety: a sold-out lens turns the ATC into "Notify me when available". It, and the
  // sold-out lens row's own Notify me, open the page's back-in-stock form in #pdp-notify-modal.
  // (No module-level const/let: updateATCText can run before this line executes.)
  function usesNotifyMeModal() {
    return window.pdp.currentProduct?.product_type === 'Safety' && !!document.getElementById('pdp-notify-modal')
  }

  function visibleSafetyLensRows() {
    const seen = new Set()
    return Array.from(document.querySelectorAll('.nvz-lens__row[data-variant-id]')).filter((row) => {
      const id = row.getAttribute('data-variant-id')
      if (seen.has(id) || row.closest('.hidden, [hidden]')) return false
      seen.add(id)
      return true
    })
  }

  function paintNotifyMeModal(modal) {
    const variant = window.pdp.selectedVariant
    const rows = visibleSafetyLensRows()
    const row = rows.find((r) => String(r.getAttribute('data-variant-id')) === String(variant?.id))
    const face = row?.getAttribute('data-face') || variant?.option1 || window.pdp.currentProduct?.title || ''
    const sizeKey = getSizeKeyFromHandle(window.pdp.currentProduct?.handle || '')
    const size = sizeKey === 'xxl' ? 'XXL' : sizeKey === 'xl' ? 'XL' : 'Standard'
    const nameEl = modal.querySelector('[data-notify-variant]')
    if (nameEl) nameEl.textContent = face + ' · ' + size

    const alts = rows.filter((r) => r !== row && !r.classList.contains('is-sold-out'))
    const altsWrap = modal.querySelector('[data-notify-alts]')
    const altsList = modal.querySelector('[data-notify-alts-list]')
    if (!altsWrap || !altsList) return
    altsList.innerHTML = ''
    alts.forEach((r) => {
      const btn = document.createElement('button')
      btn.type = 'button'
      btn.className = 'nvz-notify__alt'
      btn.setAttribute('data-notify-alt', r.getAttribute('data-variant-id'))
      btn.textContent = r.getAttribute('data-face') || ''
      altsList.appendChild(btn)
    })
    altsWrap.hidden = alts.length === 0
  }

  function openNotifyMeModal() {
    const modal = document.getElementById('pdp-notify-modal')
    const slot = modal?.querySelector('[data-notify-form-slot]')
    const form = document.querySelector('.product__information_block.bis')
    if (!modal || !slot || !form) return
    if (!slot.contains(form)) {
      window.pdp._notifyFormHome = document.createComment('bis-form-home')
      form.parentNode.insertBefore(window.pdp._notifyFormHome, form)
      slot.appendChild(form)
    }
    form.classList.remove('hidden')
    paintNotifyMeModal(modal)
    openSafetyModal('pdp-notify-modal')
  }

  function restoreNotifyMeForm() {
    const home = window.pdp._notifyFormHome
    const form = document.querySelector('#pdp-notify-modal .product__information_block.bis')
    if (!form || !home?.parentNode) return
    home.parentNode.insertBefore(form, home)
    home.remove()
    window.pdp._notifyFormHome = null
    // Inline form stays hidden on Safety; the modal is the only entry point.
    form.classList.add('hidden')
  }

  // Init shields UI when JSON/list present (Safety OPTIONS card)
  function initSafetyShieldsUi() {
    if (!document.querySelector('[data-safety-shields-json]')) return
    if (!window.pdp.safetyShields) window.pdp.safetyShields = {}
    renderSafetyShields()
    paintSafetyShieldSummary()
    paintSafetyAtcTotal()
  }
  initSafetyShieldsUi()
  rememberZ87FromDom()
  syncSafetyPdpCssScope(window.pdp.currentProduct)
  if (window.pdp.currentProduct?.product_type === 'Safety') {
    rememberZ87Handle(window.pdp.currentProduct.handle)
    window.pdp._safetySunPair = {
      safety: window.pdp.currentProduct.handle,
      regular: toRegularHandle(window.pdp.currentProduct.handle)
    }
    // Options come from Liquid inside other-products (type → items).
    syncPdpOptions(window.pdp.currentProduct)
    syncSafetyLensHelperCopy(window.pdp.selectedVariant)
    paintSafetyAtcTotal()
    nvzOptLog('init:safety', {
      liveType: getVisiblePdpOptions()?.getAttribute('data-pdp-options-type') || null
    })
  } else if (window.pdp.currentProduct?.product_type === 'Sunglasses') {
    ensureSafetyPdpCss()
    syncPdpOptions(window.pdp.currentProduct)
  } else if (window.pdp.currentProduct?.product_type === 'Prescription') {
    // Prefetch Z87 styles — Rx → sun → xl → z87 never full-reloads the section CSS.
    ensureSafetyPdpCss()
    syncPdpOptions(window.pdp.currentProduct)
  } else if (window.pdp.currentProduct?.product_type === 'Ophthalmic') {
    ensureSafetyPdpCss()
  }


  function getSafetyLensTypePanel() {
    return document.querySelector('[data-safety-lens-type-panel]')
  }

  function safetyHasLensTypeChoice(product) {
    const p = product || window.pdp.currentProduct
    return p?.product_type === 'Safety' && (p?.variants || []).length > 1
  }

  /**
   * Safety products carry their Lens Type as a native variant option, and the color swiper can
   * swap to a different Safety product without a reload, so the modal panel is rebuilt from the
   * live product JSON rather than rendered once in Liquid.
   */
  function renderSafetyLensTypeModalOptions(product) {
    const panel = getSafetyLensTypePanel()
    if (!panel) return
    const p = product || window.pdp.currentProduct
    panel.innerHTML = ''
    if (!safetyHasLensTypeChoice(p)) return

    const uncheckedSrc = panel.dataset.radioUnchecked || ''
    const checkedSrc = panel.dataset.radioChecked || ''

    p.variants.forEach((variant) => {
      const value = variant.option1 == null ? '' : String(variant.option1)
      if (!value) return

      const option = document.createElement('div')
      option.className = 'dropdown-option'
      option.setAttribute('data-value', normalizeSafetyOption(value))
      option.setAttribute('data-badge', value)
      option.setAttribute('data-variant-id', String(variant.id))
      if (!variant.available) option.setAttribute('data-unavailable', 'true')

      const radio = document.createElement('span')
      radio.className = 'dropdown-radio'
      radio.innerHTML =
        '<img src="' + uncheckedSrc + '" alt="radio-unchecked" class="unchecked" width="15" height="15">' +
        '<img src="' + checkedSrc + '" alt="radio-checked" class="checked" width="15" height="15">'

      const text = document.createElement('span')
      text.className = 'dropdown-text'
      const main = document.createElement('span')
      main.className = 'dropdown-text-main'
      main.textContent = safetyLensUiLabel(value, p)
      text.appendChild(main)

      if (variant.available) {
        const sub = document.createElement('span')
        sub.className = 'dropdown-text-sub'
        sub.textContent = formatSepDesignOfferMoney(parseFloat(variant.price)) || ''
        if (sub.textContent) text.appendChild(sub)
      } else {
        option.classList.add('is-sold-out')
        const flag = document.createElement('span')
        flag.className = 'safety-lens-flag'
        flag.textContent = 'Sold out'
        text.appendChild(flag)
      }

      option.appendChild(radio)
      option.appendChild(text)
      panel.appendChild(option)
    })

    syncSafetyModalLensTypeSelection(window.pdp.selectedVariant)
  }
  window.renderSafetyLensTypeModalOptions = renderSafetyLensTypeModalOptions

  function syncSafetyModalLensTypeSelection(variant) {
    const panel = getSafetyLensTypePanel()
    if (!panel) return
    const variantId = variant?.id != null ? String(variant.id) : ''
    let selectedLabel = ''
    panel.querySelectorAll('.dropdown-option').forEach((option) => {
      const on = !!variantId && option.getAttribute('data-variant-id') === variantId
      option.classList.toggle('selected', on)
      if (on) selectedLabel = option.getAttribute('data-badge') || ''
    })
    const badge = panel.parentElement?.querySelector('.dropdown-badge')
    if (badge) badge.textContent = selectedLabel
  }

  function variantFromUrlOnCurrentProduct() {
    try {
      const raw = new URL(window.location.href).searchParams.get('variant')
      if (!raw) return null
      return (window.pdp.currentProduct?.variants || []).find(
        (v) => String(v.id) === String(raw)
      ) || null
    } catch (e) {
      return null
    }
  }

  function shopifyImageStem(url) {
    if (!url) return ''
    const file = String(url).split('?')[0].split('#')[0].split('/').pop() || ''
    return file.replace(/_\d+x(\d+)?(?=\.[^.]+$)/i, '').toLowerCase()
  }

  function variantFeaturedImageSrc(variant) {
    if (!variant) return ''
    const feat = variant.featured_image
    if (typeof feat === 'string') return feat
    if (feat && feat.src) return feat.src
    if (variant.image && variant.image.src) return variant.image.src
    if (typeof variant.image === 'string') return variant.image
    return ''
  }

  function findGallerySlideIndexForVariant(swiperEl, variant) {
    if (!swiperEl || !variant) return -1
    const slides = [...swiperEl.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide')]
    const mediaId = variant.featured_media?.id || variant.featured_image?.id
    if (mediaId) {
      const byId = slides.findIndex((slide) => String(slide.getAttribute('data-media-id')) === String(mediaId))
      if (byId >= 0) return byId
    }
    const stem = shopifyImageStem(variantFeaturedImageSrc(variant))
    if (!stem) return -1
    return slides.findIndex((slide) => {
      const img = slide.querySelector('img')
      const hay =
        (img && (img.currentSrc || img.src || img.getAttribute('src'))) ||
        slide.querySelector('[data-src]')?.getAttribute('data-src') ||
        ''
      return shopifyImageStem(hay) === stem
    })
  }

  function markGallerySlideActive(swiperInstance, index) {
    if (!swiperInstance?.el || index == null || index < 0) return
    const slides = swiperInstance.el.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide')
    slides.forEach((slide, i) => {
      slide.classList.toggle('swiper-slide-custom-active', i === index)
    })
  }

  function syncGalleryToSelectedVariant(variant) {
    if (!document.querySelector('.sep-design-pdp.is-side-shield-pdp')) return
    const v = variant || window.pdp.selectedVariant
    const handle = window.pdp.currentProduct?.handle
    const s = handle && window.pdp.swipers && window.pdp.swipers[handle]
    if (!s || !s.swiper) return
    const idx = findGallerySlideIndexForVariant(s.swiper.el, v)
    if (idx < 0) return
    forceSwiperSlideTo(s.swiper, idx)
    if (s.thumbSwiper) forceSwiperSlideTo(s.thumbSwiper, idx)
    markGallerySlideActive(s.swiper, idx)
    markGallerySlideActive(s.thumbSwiper, idx)
    if (typeof s.syncPagination === 'function') s.syncPagination()
  }

  function findSelectedVariant() {
    if (!window.pdp?.currentProduct) return null
    console.log('[findSelectedVariant] Product type:', window.pdp.currentProduct.product_type)
    let selectedVariant = null
    const selectedUpgrades = Object.keys(window.pdp.rx['lens-upgrade'] || {}).filter(k => window.pdp.rx['lens-upgrade'][k])
    const withDefaultStandard = (option3) => {
      let opt3 = option3 == null ? '' : String(option3)
      const lower = opt3.toLowerCase()
      if (!(lower.includes('standard') || lower.includes('impact resistant') || lower.includes('high index'))) {
        opt3 = opt3 ? (opt3 + ' + Standard') : 'Standard'
      }
      return opt3
    }
    const urlVariant = variantFromUrlOnCurrentProduct()
    if (window.pdp.currentProduct.product_type === 'Prescription') {
      selectedVariant = window.pdp.currentProduct.variants?.find(v => {
        if (!v?.option1 || v.option2 == null) return false
        const opt3 = withDefaultStandard(v.option3)
        return v.option1.toLowerCase().split(' ').join('-') === window.pdp.rx['lens-type'] &&
          normalizeRxOptionHandle(v.option2) === window.pdp.rx['lens-color'] &&
          haveSameElements(opt3.split(' + ').map(o => o.toLowerCase().split(' ').join('-')), selectedUpgrades)
      })
    } else if (window.pdp.currentProduct.product_type === 'Ophthalmic') {
      selectedVariant = window.pdp.currentProduct.variants?.find(v => {
        if (!v?.option1 || v.option2 == null) return false
        const opt3 = withDefaultStandard(v.option3)
        return v.option1.toLowerCase().split(' ').join('-') === window.pdp.rx['oph-type'] &&
          v.option2.toLowerCase().split(' ').join('-') === window.pdp.rx['lens-type'] &&
          haveSameElements(opt3.split(' + ').map(o => o.toLowerCase().split(' ').join('-')), selectedUpgrades)
      })
    } else if (urlVariant) {
      selectedVariant = urlVariant
      if (window.pdp.currentProduct.product_type === 'Safety' && selectedVariant.option1) {
        window.pdp.safetyLensType = selectedVariant.option1
      }
    } else if (window.pdp.currentProduct.product_type === 'Safety') {
      selectedVariant = findSafetyLensTypeVariant(window.pdp.currentProduct)
      if (selectedVariant?.option1) window.pdp.safetyLensType = selectedVariant.option1
    } else {
      selectedVariant = window.pdp.currentProduct.variants?.[0] || null
    }
    selectedVariant = selectedVariant?.price !== '0.00' ? selectedVariant : null
    setState['selectedVariant'](selectedVariant)
    if (window.pdp.currentProduct.product_type === 'Safety') {
      syncSafetyLensTypeButtons(selectedVariant)
      syncSafetyModalLensTypeSelection(selectedVariant)
    }
    syncGalleryToSelectedVariant(selectedVariant)
    return selectedVariant
  }

  window.pdpFindSelectedVariant = findSelectedVariant

  function getProductVariantWithAvailability() {
    return fetch(`/products/${window.pdp.currentProduct.handle}?view=final_selected_variant`)
      .then(res => res.text())
      .then(data => {
        const t = document.createElement('div')
        t.innerHTML = data;
        const options = t.querySelectorAll('option')
        const availabilityUpdates = []
        // Rx stock is the frame (first variant). The view lists at most 250 variants, so XXL
        // frames' photochromic variants (past 250) are missing; apply the first row to all.
        if (window.pdp.currentProduct.product_type === 'Prescription' && options.length) {
          const firstAvailable = options[0].getAttribute('data-available') === 'true'
          window.pdp.currentProduct.variants.forEach(v => {
            v.available = firstAvailable
          })
          return
        }
        if (options) {
          options.forEach(e => {
            const id = e.getAttribute('data-id')
            const dataAvailable = e.getAttribute('data-available')
            if (id) {
              window.pdp.currentProduct.variants.forEach(v => {
                if (v.id === +id) {
                  const wasAvailable = v.available
                  v.available = dataAvailable === 'true'
                  availabilityUpdates.push({ id: v.id, wasAvailable, nowAvailable: v.available, dataAvailable })
                }
              })
            }
          })
        }
      })
  }

  function productJsonIncludesLensColorImageAsset(product, lensColorDisplayToken) {
    if (!product || !lensColorDisplayToken) return false
    const needle = String(lensColorDisplayToken).toLowerCase()
    const images = product.images
    if (Array.isArray(images)) {
      for (let i = 0; i < images.length; i++) {
        const im = images[i]
        const src = im && typeof im.src === 'string' ? im.src : (typeof im === 'string' ? im : '')
        if (src && src.toLowerCase().indexOf(needle) !== -1) return true
      }
    }
    const variants = product.variants
    if (Array.isArray(variants)) {
      for (let j = 0; j < variants.length; j++) {
        const src = variants[j] && variants[j].featured_image && variants[j].featured_image.src
        if (src && String(src).toLowerCase().indexOf(needle) !== -1) return true
      }
    }
    return false
  }

  /**
   * Image src from a collection product JSON whose filename is shot `slot` ('01'/'02') with exactly
   * lens color `lensHandle` after `_Rx_` (so "brown" does not match "photochromic-brown"). Allows a
   * suffix after the color (e.g. a Shopify upload uuid). Shopify renames uploaded videos, so a video
   * is matched on its alt text instead (e.g. `HUDSON_Nightfall_02_Rx_Photochromic-Gray`) and
   * resolves to its preview image. Images win over videos. Returns '' when the product has none.
   */
  function findRxSlideImageSrc(product, slot, lensHandle) {
    if (!product || !lensHandle) return ''
    const colors = Array.from(new Set([lensHandle, lensHandle.replaceAll('-', '')]))
    const entries = []
    const add = (src, name) => {
      if (src) entries.push({ src, file: String(name).split('?')[0].split('/').pop().toLowerCase() })
    }
    ;(product.images || []).forEach(im => {
      const src = typeof im === 'string' ? im : im && im.src
      add(src, src)
    })
    ;(product.variants || []).forEach(v => {
      const src = v && v.featured_image && v.featured_image.src
      add(src, src)
    })
    ;(product.media || []).forEach(m => {
      if (m && m.media_type === 'video' && m.alt) add(m.src, m.alt)
    })
    const hit = entries.find(({ file }) => {
      const parts = file.split('_' + slot + '_rx_')
      if (parts.length < 2) return false
      const after = parts.pop()
      return colors.some(c => after === c || after.startsWith(c + '_') || after.startsWith(c + '.'))
    })
    return hit ? hit.src : ''
  }

  function replaceSrcWithColor(element) {
    const slides = element.querySelectorAll('.swiper-slide')
    slides.forEach(s => {
      const handle = s.getAttribute('data-product-handle')
      const catalogImg = (u) => (typeof window.resolveShopifyCdnMediaFromCatalog === 'function'
        ? window.resolveShopifyCdnMediaFromCatalog(u, handle)
        : u)
      const image01 = s.querySelector('img.other-products-image-01')
      const image02 = s.querySelector('img.other-products-image-02')
      if (window.pdp.currentProduct.product_type === 'Prescription') {
        // Replace lens color in image URL if lens color is selected
        const lensColor = window.pdp.rx?.['lens-color']
        if (lensColor) {
          // Pattern: STYLE-NAME_frame-name_2digitnumber(_Rx_ or _BlueLight_ or empty)(_Clear_ or _Brown_ or _Black_ etc.)(some letters or empty).jpg(some other string)
          // Replace any existing lens color with current lens color
          const colorMapping = {
            'clear': 'Clear',
            'black': 'Black',
            'brown': 'Brown',
            'coastal-blue': 'Coastal-Blue', 
            'rose-pink': 'Rose-Pink',
            'silver': 'Silver',
            'yellow': 'Yellow',
            'green-vibrant': 'Green-Vibrant',
            'purple-pastel': 'Purple-Pastel',
            'photochromic-gray': 'Photochromic-Gray',
            'photochromic-brown': 'Photochromic-Brown',
          }
          const newColor = colorMapping[lensColor]

          function replaceImageColorToken(url, targetColor) {
            if (!url || !targetColor) return url
            const withColor = url.replace(
              /(Photochromic-Gray|Photochromic-Brown|Coastal-Blue|Rose-Pink|Green-Vibrant|Purple-Pastel|Clear|Black|Brown|Silver|Yellow)/gi,
              targetColor
            )
            return catalogImg(withColor)
          }

          // Guessed URLs may not exist (e.g. GIF uploads with a unique suffix), so only swap
          // once the guessed image has actually loaded; otherwise keep the current image.
          function swapWhenLoaded(img, url) {
            if (!img || !url || url === img.src) return
            const probe = new Image()
            probe.onload = () => { img.src = url }
            probe.src = url
          }

          function applyTokenReplaceFallback() {
            if (!newColor || !image02?.src || !image01?.src) return
            swapWhenLoaded(image02, replaceImageColorToken(image02.src, newColor))
            swapWhenLoaded(image01, replaceImageColorToken(image01.src, newColor))
          }
          
          // Wait for mainCollectionProducts to be available
          var attempts1 = 0
          var intervalId1 = setInterval(() => {
            attempts1++
            const productsReady = window.pdp.mainCollectionProducts && window.pdp.mainCollectionProducts.length > 0
            if (!productsReady && attempts1 < 50) return

            if (!productsReady) {
              applyTokenReplaceFallback()
              clearInterval(intervalId1)
              return
            }

            const product = window.pdp.mainCollectionProducts.find(p => p.handle === handle)
            // After a size switch the slider is rebuilt before mainCollectionProducts is
            // replaced with the new size's collection, so keep waiting for this handle
            if (!product && attempts1 < 50) return
            if (!product) {
              applyTokenReplaceFallback()
              clearInterval(intervalId1)
              return
            }

            const lensHandle = normalizeRxOptionHandle(lensColor)
            const variant = product.variants && product.variants.find(v =>
              normalizeRxOptionHandle(v.option2) === lensHandle
            )
            if (image02 && image01) {
              // Pick real catalog files: uploads can carry a unique suffix
              // (_Rx_Photochromic-brown_<uuid>.gif), so guessing _02_ -> _01_ or a color token 404s.
              // A frame without images for this lens color shows its Clear images instead.
              let src02 = findRxSlideImageSrc(product, '02', lensHandle) || variant?.featured_image?.src
              let src01 = findRxSlideImageSrc(product, '01', lensHandle)
              if (!src02) {
                src02 = findRxSlideImageSrc(product, '02', 'clear')
                src01 = findRxSlideImageSrc(product, '01', 'clear')
              }
              if (src02) {
                image02.src = catalogImg(src02)
                image01.src = catalogImg(src01 || src02)
              }
            }
            clearInterval(intervalId1)
          }, 100)
        }
      } else if (window.pdp.currentProduct.product_type === 'Ophthalmic') {
        // Replace lens color in image URL if lens color is selected
        const ophType = window.pdp.rx?.['oph-type']
        if (ophType) {
          const typeMapping = {
            'prescription': 'Prescription',
            'readers': 'Readers',
            'blue-light': 'Blue Light',
            'plain': 'Plain', 
          }
          const newType = typeMapping[ophType]

          // Wait for mainCollectionProducts to be available
          var intervalId2 = setInterval(() => {
            if (window.pdp.mainCollectionProducts && window.pdp.mainCollectionProducts.length > 0) {
              const product = window.pdp.mainCollectionProducts.find(p => p.handle === handle)
              if (!product) {
                return
              }
              if (product) {
                const variant = product.variants.find(v => v.option1 === newType)
                if (!variant) {
                  return
                }
                if (variant && variant.featured_image && image02 && image01) {
                  image02.src = catalogImg(variant.featured_image.src)
                  image01.src = catalogImg(variant.featured_image.src.replace('_02.', '_01.').replace('_02_', '_01_'))
                  clearInterval(intervalId2)
                }
              }
            }
          }, 100)
        }
      }
    })
    return element
  }

  /** Lifestyle / on-model shots are not named like Rx color or OPH type tokens; keep them visible whenever filtering slides. */
  function isSepDesignLifestyleSlide(slide, img) {
    if (!img || !img.src) return false
    const src = String(img.src).toLowerCase()
    const alt = String(img.getAttribute('alt') || '').toLowerCase()
    const cap = String(slide?.querySelector('.image-wrapper')?.getAttribute('data-caption') || '').toLowerCase()
    return (
      src.includes('lifestyle') ||
      alt.includes('lifestyle') ||
      cap.includes('lifestyle') ||
      alt.includes('life style') ||
      cap.includes('life style') ||
      alt.includes('life-style') ||
      cap.includes('life-style')
    )
  }

  /**
   * After visibility toggles: first two *visible* non-lifestyle slides, then lifestyle(s), then other
   * visible product slides, slim-hard-case, then hidden slides last (so swipe/pagination never
   * lands activeIndex on a display:none slide between the last product shot and the case).
   */
  function reorderLifestyleSlidesToThird(swiperRootEl) {
    if (!swiperRootEl) return
    const swiperWrapper = swiperRootEl.querySelector('.swiper-wrapper')
    if (!swiperWrapper) return
    const all = [...swiperWrapper.querySelectorAll(':scope > .swiper-slide')]
    if (all.length < 2) return

    const caseSlide = all.find((el) => el.getAttribute('data-special-slide') === 'slim-hard-case')
    const productSlides = all.filter((el) => el !== caseSlide)
    const isHidden = (el) => el.classList.contains('hidden')
    const visibleSlides = productSlides.filter((el) => !isHidden(el))
    const hiddenSlides = productSlides.filter(isHidden)

    const visibleRegular = []
    const visibleLif = []
    visibleSlides.forEach((slide) => {
      const img = slide.querySelector('img')
      if (isSepDesignLifestyleSlide(slide, img)) visibleLif.push(slide)
      else visibleRegular.push(slide)
    })
    // Nothing to promote, but hidden slides must still be pushed to the tail. A display:none
    // slide sitting between visible ones gives Swiper duplicate slidesGrid entries, and its
    // updateActiveIndex loop cannot resolve those — activeIndex pins to the last slide, so the
    // main gallery jumps to the end and isEnd jams navigation. Safety has no case slide, so this
    // used to bail out and leave the hidden slides interleaved.
    if (visibleLif.length === 0) {
      visibleSlides.forEach((slide) => swiperWrapper.appendChild(slide))
      if (caseSlide) swiperWrapper.appendChild(caseSlide)
      hiddenSlides.forEach((slide) => swiperWrapper.appendChild(slide))
      return
    }

    const ordered = []
    ordered.push(...visibleRegular.slice(0, 2))
    ordered.push(...visibleLif)
    ordered.push(...visibleRegular.slice(2))
    ordered.forEach((slide) => swiperWrapper.appendChild(slide))
    if (caseSlide) swiperWrapper.appendChild(caseSlide)
    hiddenSlides.forEach((slide) => swiperWrapper.appendChild(slide))
  }

  /**
   * Swiper no-ops slideTo when it already believes it is on that index, and after a visibility
   * change that belief is often wrong. Bump to a neighbour first to force a real move.
   */
  function forceSwiperSlideTo(swiperInstance, index) {
    if (!swiperInstance || index == null || index < 0) return
    swiperInstance.update()
    const maxIndex = Math.max(0, swiperInstance.slides.length - 1)
    const targetIndex = Math.min(index, maxIndex)
    if (swiperInstance.activeIndex === targetIndex) {
      const bump = targetIndex + 1 <= maxIndex ? targetIndex + 1 : Math.max(0, targetIndex - 1)
      swiperInstance.slideTo(bump, 0, false)
    }
    swiperInstance.slideTo(targetIndex, 0, false)
  }

  function syncSwiperToFirstVisibleSlide(swiperInstance) {
    if (!swiperInstance?.el) return
    // Read from live DOM after reorder; prefer custom-active product shot, never open on case first
    const slides = [...swiperInstance.el.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide')]
    let idx = slides.findIndex(
      (slide) =>
        slide.classList.contains('swiper-slide-custom-active') &&
        !slide.classList.contains('hidden')
    )
    if (idx < 0) {
      idx = slides.findIndex(
        (slide) =>
          !slide.classList.contains('hidden') &&
          slide.getAttribute('data-special-slide') !== 'slim-hard-case' &&
          !isSepDesignLifestyleSlide(slide, slide.querySelector('img'))
      )
    }
    if (idx < 0) {
      idx = slides.findIndex((slide) => !slide.classList.contains('hidden'))
    }
    if (idx < 0) return
    forceSwiperSlideTo(swiperInstance, idx)
  }

  function srcMatchesRxLensColor(src, newColor) {
    if (!src || !newColor) return false
    const parts = String(src).split('_Rx_')
    if (parts.length < 2) return false
    const after = parts.pop().split(/[?#]/)[0].toLowerCase()
    const color = String(newColor).toLowerCase()
    // Exact token after _Rx_ (avoids "brown" matching "photochromic-brown")
    return after === color || after.startsWith(color + '_') || after.startsWith(color + '.')
  }

  /**
   * What an Rx slide's lens color is read from: its image src, or for a video whose alt carries an
   * `_Rx_` lens token (e.g. `HUDSON_Nightfall_02_Rx_Photochromic-Gray`) that alt, since Shopify
   * renames uploaded videos and their src never carries the original filename.
   */
  function rxSlideMediaName(slide, img) {
    const alt = isSafetyVideoSlide(slide) ? slide.getAttribute('data-media-alt') || '' : ''
    if (alt.indexOf('_Rx_') !== -1) return alt
    return img ? img.src : ''
  }

  function isSafetyVideoSlide(slide) {
    return (
      slide.getAttribute('data-media-type') === 'video' ||
      !!slide.querySelector('[data-html5-video]')
    )
  }

  function safetyLensCodeFromImageSlide(slide) {
    if (!slide || isSafetyVideoSlide(slide)) return ''
    const src = slide.querySelector('img')?.src
    return Object.values(SAFETY_LENS_IMAGE_CODES).find((code) => srcMatchesSafetyLensCode(src, code)) || ''
  }

  /**
   * Shopify renames uploaded videos (preview_images/<hash>.jpg, videos/<hash>.mp4) and neither Liquid
   * nor the Storefront API exposes the original filename (e.g. MATTEX-XL_Doom-XL-Z87-NPAF_360_01.mp4),
   * so a video's lens comes from its alt text when that carries a lens code, otherwise from the
   * lens group it sits in: the nearest image before it in media order (after it, if it leads).
   * Stamped once as data-safety-lens-code while slides are still in media order — later
   * toggles run after reorderLifestyleSlidesToThird has moved hidden slides to the end.
   */
  function stampSafetyVideoLensCodes(slides) {
    const codes = Object.values(SAFETY_LENS_IMAGE_CODES)
    slides.forEach((slide, i) => {
      if (!isSafetyVideoSlide(slide) || slide.hasAttribute('data-safety-lens-code')) return
      const altTokens = String(slide.getAttribute('data-media-alt') || '')
        .toUpperCase()
        .split(/[^A-Z0-9]+/)
      let code = codes.find((c) => altTokens.includes(c)) || ''
      for (let j = i - 1; !code && j >= 0; j--) code = safetyLensCodeFromImageSlide(slides[j])
      for (let j = i + 1; !code && j < slides.length; j++) code = safetyLensCodeFromImageSlide(slides[j])
      slide.setAttribute('data-safety-lens-code', code)
    })
  }

  function safetySlideMatchesLensCode(slide, code) {
    if (isSafetyVideoSlide(slide)) {
      const videoCode = slide.getAttribute('data-safety-lens-code')
      // A video with no inferable lens applies to every lens
      return !videoCode || videoCode === code
    }
    return srcMatchesSafetyLensCode(slide.querySelector('img')?.src, code)
  }

  function toggleSafetyLensSlides(element, opts) {
    if (!element) return
    const triggerNavigation = !opts || opts.triggerNavigation !== false
    const code = getSafetyLensImageCode(window.pdp.safetyLensType)
    const slides = [...element.querySelectorAll('.swiper-slide')]
    if (!slides.length) return
    stampSafetyVideoLensCodes(slides)

    // Unknown lens name, or media that does not follow the convention: leave the gallery intact
    const hasMatch =
      !!code &&
      slides.some((slide) => srcMatchesSafetyLensCode(slide.querySelector('img')?.src, code))
    if (!hasMatch) {
      slides.forEach((slide) => slide.classList.remove('hidden'))
      return
    }

    let customActiveSlideSet = false
    slides.forEach((slide) => {
      const img = slide.querySelector('img')
      const isCase = slide.getAttribute('data-special-slide') === 'slim-hard-case'
      const isLifestyle = isSepDesignLifestyleSlide(slide, img)
      slide.classList.remove('swiper-slide-custom-active')
      if (isCase || isLifestyle) {
        slide.classList.remove('hidden')
        return
      }
      if (safetySlideMatchesLensCode(slide, code)) {
        slide.classList.remove('hidden')
        if (!customActiveSlideSet) {
          slide.classList.add('swiper-slide-custom-active')
          if (triggerNavigation) slide.click()
          customActiveSlideSet = true
        }
      } else {
        slide.classList.add('hidden')
        slide.querySelectorAll('video').forEach((video) => video.pause())
      }
    })
  }

  function toggleSlidersWithColor(element, opts) {
    const triggerNavigation = !opts || opts.triggerNavigation !== false
    const slides = element.querySelectorAll('.swiper-slide')
    let customActiveSlideSet = false
    slides.forEach(slide => {
      const img = slide.querySelector('img')
      if (window.pdp.currentProduct.product_type === 'Prescription') {
        const lensColor = window.pdp.rx?.['lens-color'] ? window.pdp.rx?.['lens-color'] : 'clear'
        const mediaName = rxSlideMediaName(slide, img)
        if (mediaName && lensColor) {
          const colorMapping = {
            'clear': 'Clear',
            'black': 'Black',
            'brown': 'Brown',
            'coastal-blue': 'Coastal-Blue',
            'rose-pink': 'Rose-Pink',
            'silver': 'Silver',
            'yellow': 'Yellow',
            'green-vibrant': 'Green-Vibrant',
            'purple-pastel': 'Purple-Pastel',
            'photochromic-gray': 'Photochromic-Gray',
            'photochromic-brown': 'Photochromic-Brown',
          }
          const newColor = colorMapping[lensColor]
          const isCase = slide.getAttribute('data-special-slide') === 'slim-hard-case'
          const isLifestyle = isSepDesignLifestyleSlide(slide, img)
          if (slide) {
            if (!isCase && !isLifestyle) slide.classList.add('hidden')
            slide.classList.remove('swiper-slide-custom-active')
            const matchesLensColor = srcMatchesRxLensColor(mediaName, newColor)
            if (isLifestyle) {
              slide.classList.remove('hidden')
            } else if (matchesLensColor) {
              slide.classList.remove('hidden')
              if (!customActiveSlideSet) {
                slide.classList.add('swiper-slide-custom-active')
                if (triggerNavigation) slide.click()
                customActiveSlideSet = true
              }
            }
            if (slide.classList.contains('hidden')) slide.querySelectorAll('video').forEach(video => video.pause())
          }
        }
      } else if (window.pdp.currentProduct.product_type === 'Ophthalmic') {
        const ophType = window.pdp.rx?.['oph-type']
        if (img && ophType) {
          const typeMapping = {
            'prescription': 'Clear',
            'readers': 'Clear',
            'blue-light': 'BlueLight',
            'plain': 'Clear', 
          }
          const newType = typeMapping[ophType]
          const isCase = slide.getAttribute('data-special-slide') === 'slim-hard-case'
          const isLifestyle = isSepDesignLifestyleSlide(slide, img)
          if (slide) {
            if (!isCase && !isLifestyle) slide.classList.add('hidden')
            else if (isCase) {
              if (ophType === 'blue-light') slide.classList.add('hidden')
              else slide.classList.remove('hidden')
            }
            slide.classList.remove('swiper-slide-custom-active')
            const matchesOphType = img && img.src && img.src.split(/_\d{2}_/).pop().toLowerCase().includes(newType.toLowerCase())
            if (isLifestyle) {
              slide.classList.remove('hidden')
            } else if (matchesOphType) {
              slide.classList.remove('hidden')
              if (!customActiveSlideSet) {
                slide.classList.add('swiper-slide-custom-active')
                if (triggerNavigation) slide.click()
                customActiveSlideSet = true
              }
            }
          }
        }
      }
    })
  }

  /** Dots are built before slides are filtered, so CSS keeps them hidden until the first filter pass. */
  function revealMainSliderPagination(handle) {
    const s = handle && window.pdp.swipers?.[handle]
    const pagination = s?.swiper?.el?.closest('.mainslider-wrapper')?.querySelector('.sep-main-pagination')
    if (pagination) pagination.classList.add('is-ready')
  }

  function changeSliderImages() {
    const curHandle = window.pdp.currentProduct?.handle
    const otherRoot = document.querySelector('.product__information_block.other-products')
    // Only consider "other products" slides — main gallery slides do not use data-product-handle
    if (otherRoot && curHandle && !otherRoot.querySelector(`.swiper-slide[data-product-handle="${curHandle}"].swiper-slide-custom-active`)) {
      document.querySelectorAll('.swiper-slide-custom-active').forEach(s => {
        s.classList.remove('swiper-slide-custom-active')
      })
      const currentSlide = otherRoot.querySelector('.swiper-slide[data-product-handle="' + curHandle + '"]')
      if (currentSlide) {
        const swiperWrapper = currentSlide.closest('.swiper-wrapper')
        if (swiperWrapper) {
          swiperWrapper.querySelectorAll('.swiper-slide').forEach((s, i) => {
            if (s && s.getAttribute('data-product-handle') === curHandle) {
              s.classList.add('swiper-slide-custom-active')
              if (window.pdp.mainCollection && window.pdp.swipers[window.pdp.mainCollection]?.swiper) {
                window.pdp.swipers[window.pdp.mainCollection].swiper.slideTo(i)
              }
            }
          })
        }
      }
    }

    if (window.pdp.currentProduct.product_type === 'Prescription' || window.pdp.currentProduct.product_type === 'Ophthalmic') {
      Object.values(window.pdp.swipers).forEach(s => {
        if (s.swiper && !s.thumbSwiper) {
          const element = s.swiper.el
          if (element && (s.swiper.el.getAttribute('data-product-type') === 'ophthalmic' || s.swiper.el.getAttribute('data-product-type') === 'prescription')) {
            replaceSrcWithColor(element)
          }
        }
      })
      const s = curHandle && window.pdp.swipers[curHandle]
      if (s && s.swiper && s.thumbSwiper && s.thumbSwiper.el) {
        const pt = s.thumbSwiper.el.getAttribute('data-product-type')
        if (pt === 'ophthalmic' || pt === 'prescription') {
          // Do not click thumbs here — that slideTo(visibleNth) races before main is filtered and can land on case
          toggleSlidersWithColor(s.thumbSwiper.el, { triggerNavigation: false })
          toggleSlidersWithColor(s.swiper.el, { triggerNavigation: false })
          reorderLifestyleSlidesToThird(s.thumbSwiper.el)
          reorderLifestyleSlidesToThird(s.swiper.el)
          s.thumbSwiper.update()
          s.swiper.update()
          s.thumbSwiper.updateSize()
          s.swiper.updateSize()
          syncSwiperToFirstVisibleSlide(s.thumbSwiper)
          syncSwiperToFirstVisibleSlide(s.swiper)
          if (typeof s.syncPagination === 'function') s.syncPagination()
        }
      }
    } else if (window.pdp.currentProduct.product_type === 'Safety') {
      const s = curHandle && window.pdp.swipers[curHandle]
      if (s && s.swiper && s.thumbSwiper && s.thumbSwiper.el) {
        toggleSafetyLensSlides(s.thumbSwiper.el, { triggerNavigation: false })
        toggleSafetyLensSlides(s.swiper.el, { triggerNavigation: false })
        ;[s.thumbSwiper.el, s.swiper.el].forEach((el) => {
          if (!el) return
          const slides = el.querySelectorAll('.swiper-slide')
          if (slides.length && !el.querySelector('.swiper-slide:not(.hidden)')) {
            slides.forEach((slide) => slide.classList.remove('hidden'))
          }
        })
        reorderLifestyleSlidesToThird(s.thumbSwiper.el)
        reorderLifestyleSlidesToThird(s.swiper.el)
        s.thumbSwiper.update()
        s.swiper.update()
        s.thumbSwiper.updateSize()
        s.swiper.updateSize()
        syncSwiperToFirstVisibleSlide(s.thumbSwiper)
        syncSwiperToFirstVisibleSlide(s.swiper)
        if (typeof s.syncPagination === 'function') s.syncPagination()
      }
    } else if (window.pdp.swipers[curHandle]) {
      window.pdp.swipers[curHandle].thumbSwiper.el.querySelectorAll('.swiper-slide').forEach(slide => {
        slide.classList.remove('swiper-slide-custom-active')
        if (slide.classList.contains('swiper-slide-active')) slide.classList.add('swiper-slide-custom-active')
      })
      if (typeof window.pdp.swipers[curHandle].syncPagination === 'function') {
        window.pdp.swipers[curHandle].syncPagination()
      }
      syncGalleryToSelectedVariant(window.pdp.selectedVariant)
    }
    revealMainSliderPagination(curHandle)
  }

  function checkEditMode() {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    if (searchParams.has('edit')) {
      window.pdp.editMode = true
      window.pdp.editVariant = {
        id: searchParams.get('edit'),
        qty: searchParams.get('qty')
      }
    } else {
      window.pdp.editMode = false
    }
    updateATCText()
  }

  function readFromVariantParam() {
    window.pdp.lock.variantParam = true
    const url = new URL(window.location)
    const variantId = url.searchParams.get('variant')

    if (variantId && (window.pdp.currentProduct.product_type === 'Prescription' || window.pdp.currentProduct.product_type === 'Ophthalmic')) {
      setState['variant-id'](variantId)
      const selectedVariant = window.pdp.currentProduct.variants.find(v => v.id === +variantId)
      if (selectedVariant) {
        // update rx information
        document.querySelector(`.dropdown-option[data-value="${selectedVariant.option1.toLowerCase().split(' ').join('-')}"]`)?.click()
        document.querySelector(`.dropdown-option[data-value="${normalizeRxOptionHandle(selectedVariant.option2)}"]`)?.click()
        // lens upgrades
        const lensUpgrades = selectedVariant.option3.toLowerCase().split(' + ').map(o => o.toLowerCase().split(' ').join('-'))
        if (!lensUpgrades.includes('impact-resistant') && !lensUpgrades.includes('high-index')) {
          lensUpgrades.push('standard')
        }
        lensUpgrades.forEach(upgrade => {
          document.querySelector(`#lens-upgrade-panel .dropdown-option[data-value="${upgrade}"]`)?.click()
        })
      }
    } else {
      document.querySelector('.dropdown-option[data-value="standard"]')?.click()
    }
    if (window.pdp.currentProduct?.product_type === 'Prescription') {
      applyRxLensColorFromUrlIfApplicable()
    }
    window.pdp.lock.variantParam = false
  }

  function runAllScripts(target, options) {
    const forceReexecute = !!(options && options.forceReexecute)
    const scripts = target.querySelectorAll('script')
    scripts.forEach(script => {
      const newScript = document.createElement('script')
      if (script.src) {
        // Module scripts run once per URL per document, so a unique query is
        // needed when re-mounting a widget that already booted on first paint
        newScript.src =
          forceReexecute && script.type === 'module'
            ? script.src + (script.src.includes('?') ? '&' : '?') + '_pdp=' + Date.now()
            : script.src
      } else {
        newScript.textContent = script.textContent
      }
      if (script.type) {
        newScript.type = script.type
      }
      if (script.async) {
        newScript.async = script.async
      }
      if (script.defer) {
        newScript.defer = script.defer
      }
      document.head.appendChild(newScript)
      document.head.removeChild(newScript)
    })
  }

  function getCompareSection() {
    // compare section rendering
    if (!window.pdp.currentProduct.handle) return
    fetchSectionHtml(`/products/${window.pdp.currentProduct.handle}?section_id=compare-section`).then(res => {
      const parsed = document.createElement('div')
      parsed.innerHTML = res
      const compareSection = document.querySelector('.shopify-section.compare-section .product-compare')
      if (compareSection) {
        const parsedCompare = parsed.querySelector('.product-compare')
        if (parsedCompare) {
          compareSection.innerHTML = parsedCompare.innerHTML
          const missing = 3 - compareSection.querySelectorAll('.product-item').length
          if (missing > 0) {
            const dest = compareSection.querySelector('.product-items')
            if (dest) {
              fetchSectionHtml(`/recommendations/products?product_id=${window.pdp.currentProduct.id}&section_id=compare-section-recommended&limit=${missing}`).then(res => {
                const elem = document.createElement('div')
                elem.innerHTML = res
                const target = elem.querySelectorAll('div.product-item')
                for (let i = 0; i < target.length; i++) {
                  const targetElem = target[i];
                  if (targetElem) {
                    dest.appendChild(targetElem)
                  }
                }
              })
            }
          }
        }
      }
    })
    // compare section rendering: END
  }

  /** Glasson VTO expects `len-color-id` (underscore form), same as assets/rx-product.js */
  function syncGlassonTryOnLenColorIdFromRxState() {
    const el = document.querySelector('glasson-try-on')
    if (!el) return
    const raw = window.pdp?.rx?.['lens-color']
    const handle = normalizeRxOptionHandle(raw || '')
    if (!handle) {
      el.removeAttribute('len-color-id')
      return
    }
    el.setAttribute('len-color-id', handle.replace(/-/g, '_'))
  }

  function getGlassOnAppBlock(productId, userId, groupId, vtoEnabled) {
    console.log('----------------------')
    console.log('productId', productId)
    console.log('userId', userId)
    console.log('groupId', groupId)
    console.log('vtoEnabled', vtoEnabled)
    console.log('----------------------')

    const target = document.querySelector('.atc_app_blocks.handle-' + window.pdp.currentProduct.handle)

    if (!target) return

    if (!productId || !userId || !groupId || !vtoEnabled) {
      target.innerHTML = ''
      return
    }

    const glassOnBlockHTML = '<div id="shopify-block-AYitjV1ZnTTdLQUtaQ__glasson_app_block_both_UXwFF9" class="shopify-block shopify-app-block"> <link href="//cdn.shopify.com/extensions/c62fcfee-4211-441b-94c6-c36f4b59972c/glasson-79/assets/app.css" rel="stylesheet" type="text/css" media="all"> <div class="glasson-wrap" style="justify-content: center;"> <button class="glasson-btn glasson-btn-live" style="color: #1f2937; border-color: #1f2937; background-color: ;" onclick="window.openTryOn(event, \'live\')"> <!-- BEGIN app snippet: icon-tryon --> <svg width="26" height="17" viewBox="0 0 26 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg"> <path d="M25.99 10.957v-.13l-.593-7.974C25.27 1.169 24.023 0 22.343 0h-2.047c-.158 0-.316.02-.435.11a.532.532 0 0 0-.238.415.46.46 0 0 0 .178.436c.129.1.306.139.495.149h2.056c.544 0 1.008.178 1.345.475.336.307.554.752.593 1.297.178 2.12.316 4.23.484 6.35.02.258.03.525.049.783.02.209.03.406.039.624h-.238c-.167-1.11-.534-2.061-1.146-2.833-.622-.803-1.483-1.397-2.6-1.734-1.335-.406-2.54-.376-3.618.05-1.038.425-1.928 1.199-2.679 2.278-1.058-.565-2.115-.555-3.144.01-.692-1-1.503-1.734-2.452-2.17-.979-.456-2.096-.565-3.332-.298-1.265.278-2.243.842-2.955 1.675-.682.793-1.117 1.822-1.325 3.032h-.218c0-.1-.01-.178 0-.258.039-.575.09-1.159.128-1.733.04-.575.09-1.16.129-1.734.109-1.387.187-2.764.326-4.141.09-.99.87-1.665 1.868-1.665H5.72a.81.81 0 0 0 .425-.1c.138-.089.218-.237.237-.435a.473.473 0 0 0-.187-.426C6.077.057 5.9.018 5.712.018H3.568C2.048.03.782 1.148.654 2.675.515 4.15.426 5.646.307 7.123L.16 9.114c-.049.664-.1 1.317-.158 1.981-.01.188.02.358.129.486.109.14.267.188.464.188h.01c.257.01.534 0 .781 0 .02.12.05.219.059.317.405 2.665 2.856 4.687 5.516 4.548 2.254-.11 4.123-1.506 4.874-3.438v-.01a5.66 5.66 0 0 0 .247-3.14v-.01a4.998 4.998 0 0 1-.168-.574c.277-.219.653-.337 1.038-.358.415-.03.82.07 1.117.268 0 0 .02.02.03.05.009.009.009.019.009.029v.02h.01l-.09.316c0 .01-.01.02-.01.02-.01.01-.01.02-.01.029-.009.01-.019.02-.019.04-.01.029-.03.07-.039.118-.03.11-.07.258-.1.446a4.56 4.56 0 0 0 0 1.426v.04c.317 2.586 2.432 4.527 5.131 4.706 2.462.168 4.835-1.565 5.467-4.013.059-.277.109-.555.168-.842h.73c.198 0 .387-.03.505-.158.129-.13.149-.317.149-.526 0-.039 0-.08-.01-.119l.001.003Zm-6.811 4.557c-2.382-.039-4.29-1.98-4.261-4.349.03-2.387 1.986-4.32 4.35-4.29 2.41.04 4.29 1.991 4.27 4.449-.01 2.298-2.027 4.23-4.36 4.19Zm-8.076-4.28c-.02 2.358-1.967 4.3-4.33 4.29-2.51-.02-4.379-2.14-4.3-4.478.058-2.239 2.016-4.17 4.33-4.16 2.382.009 4.31 1.96 4.3 4.348Z" fill="currentColor"></path> </svg> <!-- END app snippet --> <span class="pl-2" style="color: #1f2937"> Try on virtually</span> </button> <button class="glasson-btn glasson-btn-360" style="color: #1f2937; border-color: #1f2937; background-color: ;" onclick="window.openTryOn(event, \'360\')"> <!-- BEGIN app snippet: icon-view360 --> <svg width="32" height="18" viewBox="0 0 32 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.823 3.475c-1.71 0-3.116 1.42-3.116 3.199 0 1.778 1.406 3.198 3.116 3.198 1.71 0 3.117-1.42 3.117-3.198s-1.406-3.199-3.117-3.199ZM5.607 6.674c0-2.363 1.876-4.299 4.216-4.299 2.34 0 4.217 1.936 4.217 4.299 0 2.362-1.876 4.298-4.217 4.298-2.34 0-4.216-1.936-4.216-4.298Z" fill="currentColor"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="m13.786 2.155-4.853 1.45a.55.55 0 0 1-.315-1.054l4.865-1.453a2.264 2.264 0 0 1 2.788 1.701l.148.608a.55.55 0 1 1-1.068.261l-.152-.621a1.164 1.164 0 0 0-1.413-.892Zm6.77 1.449c-1.71 0-3.117 1.42-3.117 3.199 0 1.778 1.407 3.198 3.117 3.198s3.117-1.42 3.117-3.198-1.407-3.199-3.117-3.199Zm-4.217 3.199c0-2.363 1.877-4.299 4.217-4.299s4.217 1.936 4.217 4.299c0 2.362-1.877 4.298-4.217 4.298s-4.217-1.936-4.217-4.298Z" fill="currentColor"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M25.181 2.263c.649-.073 1.284.348 1.408.941l.13.617a.55.55 0 1 0 1.076-.226l-.13-.616c-.26-1.248-1.516-1.958-2.662-1.802a.55.55 0 0 0-.066.013l-4.91 1.29a.55.55 0 1 0 .28 1.064l4.874-1.281ZM4.465 6.181a.55.55 0 0 1-.182.757c-1.595.978-2.35 2.004-2.35 2.954 0 1.123.993 2.32 3.06 3.337 2.024.994 4.89 1.712 8.192 1.96a.55.55 0 0 1-.082 1.096c-3.397-.254-6.41-.996-8.594-2.069C2.37 13.166.832 11.692.832 9.892.832 8.338 2.036 7.026 3.708 6a.55.55 0 0 1 .757.181Zm23.245.073a.55.55 0 0 1 .761-.163c1.57 1.013 2.784 2.242 2.784 3.801 0 .957-.451 1.828-1.176 2.577-.723.747-1.744 1.404-2.967 1.954-2.45 1.1-5.811 1.82-9.539 1.947a.55.55 0 0 1-.037-1.1c3.623-.123 6.837-.822 9.125-1.85 1.145-.515 2.033-1.101 2.627-1.716.593-.612.867-1.223.867-1.812 0-.945-.746-1.887-2.28-2.877a.55.55 0 0 1-.164-.76Z" fill="currentColor"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M12.333 14.205a.55.55 0 0 1 .768.126l.898 1.252a.55.55 0 0 1-.117.761l-1.225.918a.55.55 0 0 1-.66-.88l.794-.595-.584-.815a.55.55 0 0 1 .126-.767Zm1.5-6.973a.55.55 0 0 1-.822-.73l.411.365a50.7 50.7 0 0 1-.41-.366v-.002l.003-.002.007-.008a1.786 1.786 0 0 1 .096-.098 3.74 3.74 0 0 1 1.222-.79 2.524 2.524 0 0 1 1.453-.115c.548.124 1.089.445 1.596 1.015a.55.55 0 1 1-.822.731c-.382-.43-.73-.608-1.015-.673a1.426 1.426 0 0 0-.826.073 2.62 2.62 0 0 0-.885.592l-.008.009Zm0 0v.001h-.001c0 .001 0 0 0 0Z" fill="currentColor"></path> </svg> <!-- END app snippet --> <span class="pl-2" style="color: #1f2937"> 360 VIEW</span> </button> </div> </div>'
    target.innerHTML = glassOnBlockHTML

    const requestUrl = `https://glasson.sk-global.biz/shopify/check-product-duplicated?shopId=48794468508&productId=${productId}`;
    fetch(requestUrl).then((response) => {
      return response.json();
    }).then((data) => {
      if (data.duplicated) {
        const glassonWrap = document.querySelector('.glasson-wrap')
        if (glassonWrap) {
          glassonWrap.style.display = 'none'
        }
      }
    }).catch((err) => {
      console.error('Error:', err);
    });
    // Create and append a script element for the virtual try-on UI
    var script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://media.glasses4u.io/build/try-on-ui-v5.esm.js';
    document.body.appendChild(script);
    // Create and append a custom element for the virtual try-on
    let glassonTryOn = document.querySelector('glasson-try-on')

    if (!glassonTryOn) {
      glassonTryOn = document.createElement('glasson-try-on');
      document.body.appendChild(glassonTryOn);
    }

    glassonTryOn.setAttribute('user-id', userId); // Set user ID
    glassonTryOn.setAttribute('group-id', groupId); // Set group ID from the metafield
    console.log('glasson product type', window.pdp.currentProduct.product_type)
    if (
      window.pdp.currentProduct.product_type === 'Prescription' ||
      window.pdp.currentProduct.product_type === 'Ophthalmic'
    ) glassonTryOn.setAttribute('screen', 'neven');
    else glassonTryOn.removeAttribute('screen');
    if (window.pdp.currentProduct.product_type === 'Prescription') {
      glassonTryOn.setAttribute('lens-source', 'shopify');
    } else {
      glassonTryOn.removeAttribute('lens-source');
    }
    syncGlassonTryOnLenColorIdFromRxState()
    // Don't remove this line, it's used for versioning
    console.log('GLASSON INSTALLED: v3.0.0');
    window.openTryOn = function (e, mode = 'live') {
      e.preventDefault();
      e.stopPropagation();
      const glassonComponent = document.querySelector('glasson-try-on');
      syncGlassonTryOnLenColorIdFromRxState()
      glassonComponent.setAttribute('mode', mode);
      glassonComponent.setAttribute('open', true);
    }
  }

  function getStaticSection(topWrapperSelector, sectionType) {
    console.log("function running with ", sectionType)
    if (!window.pdp.currentProduct.handle) return
    const target = document.querySelector(topWrapperSelector)
    if (!target) return
    const targetId = target.getAttribute('id')
    const sectionId = targetId.split('-section-').pop()
    fetchSectionHtml(`/products/${window.pdp.currentProduct.handle}?section_id=${sectionId}`).then(res => {
        const parsed = document.createElement('div')
        parsed.innerHTML = res
        const elem = parsed.querySelector(`#${targetId}`)
        if (elem) target.innerHTML = elem.innerHTML
        else target.innerHTML = ''
        switch (sectionType) {
            case 'recommended':
                // window.PXUTheme.jsRecommendedProducts?.init($(target))
                runAllScripts(target)
                break;
            case 'faq':
                window.PXUTheme.jsFAQ?.init()
                break;
            default:
                break;
        }
    })
  }
  
  function judgeMeWidgetsMounted(root) {
    if (!root) return false
    if (root.querySelector('.jdgm-widget.jdgm--done-setup')) return true
    if (root.querySelector('.jdgm-widget-actions-wrapper')) return true
    if (root.querySelector('.jdgm-sort-dropdown, .jdgm-rev-widg__sort-wrapper select')) return true
    const writeLink = root.querySelector('.jdgm-write-rev-link')
    return !!(writeLink && writeLink.style.display !== 'none')
  }

  // Judge.me app-block section: Section Rendering returns correct product markup
  // but unmounted. jdgm.initializeWidgets only works once its lazily loaded review
  // form chunk is present, otherwise it throws _renderAndSetupReviewForm errors.
  function remountJudgeMeWidgets(root) {
    if (judgeMeWidgetsMounted(root)) return true

    if (root) {
      root.querySelectorAll('.jdgm-temp-hiding-style').forEach((style) => style.remove())
      root.querySelectorAll('.jdgm-rev-widg[style*="display: none"], .jdgm-rev-widg[style*="display:none"]').forEach((el) => {
        el.style.removeProperty('display')
      })
    }

    const jm = window.jdgm
    const chunkReady = !!(jm && typeof jm._renderAndSetupReviewForm === 'function')

    // At most twice per root: repeated calls on a half-mounted widget can double-render
    const initCalls = root ? root._jdgmInitCalls || 0 : 0
    if (chunkReady && typeof jm.initializeWidgets === 'function' && initCalls < 2) {
      if (root) root._jdgmInitCalls = initCalls + 1
      try {
        jm.initializeWidgets()
        return judgeMeWidgetsMounted(root) || !root
      } catch (err) {
        console.warn('jdgm.initializeWidgets failed', err)
      }
    }
    if (chunkReady) return false

    // Pull the missing widget chunks once; loader.js initializes on its own
    if (!window.pdp._jdgmLoaderPending) {
      window.pdp._jdgmLoaderPending = true
      const host = (jm && jm.CDN_HOST) || 'https://cdn.judge.me/'
      const done = () => {
        window.pdp._jdgmLoaderPending = false
      }
      try {
        if (jm && typeof jm.loadJS === 'function') {
          jm.loadJS(host + 'loader.js', done)
        } else {
          const script = document.createElement('script')
          script.src = host + 'loader.js'
          script.onload = done
          script.onerror = done
          document.head.appendChild(script)
        }
      } catch (err) {
        console.warn('judgeme loader fetch failed', err)
        done()
      }
    }

    return false
  }

  // Keep retrying until Judge.me has actually rendered into `root` (loader.js
  // chunks land async; a mid-mount swap can leave the section blank). One
  // watcher per section; a newer call replaces the older one.
  // Waits until 2.5s after window load before stepping in, so Judge.me's own
  // first-paint loader gets to mount the widget untouched.
  function ensureJudgeMeWidgetsMounted(root) {
    if (!root) return
    if (root._jdgmMountTimer) clearInterval(root._jdgmMountTimer)
    if (root._jdgmMountDelay) clearTimeout(root._jdgmMountDelay)
    root._jdgmMountTimer = null
    root._jdgmMountDelay = null
    if (judgeMeWidgetsMounted(root)) return

    if (document.readyState !== 'complete') {
      window.addEventListener('load', () => ensureJudgeMeWidgetsMounted(root), { once: true })
      return
    }
    const nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null
    const wait = (nav && nav.loadEventEnd ? nav.loadEventEnd : 0) + 2500 - performance.now()
    if (wait > 0) {
      root._jdgmMountDelay = setTimeout(() => ensureJudgeMeWidgetsMounted(root), wait)
      return
    }

    if (remountJudgeMeWidgets(root)) return
    let tries = 0
    root._jdgmMountTimer = setInterval(() => {
      tries += 1
      // Second initializeWidgets attempt only after ~5s of waiting on the first
      if (tries === 10) root._jdgmInitCalls = Math.min(root._jdgmInitCalls || 0, 1)
      if (!root.isConnected || remountJudgeMeWidgets(root) || tries >= 30) {
        clearInterval(root._jdgmMountTimer)
        root._jdgmMountTimer = null
      }
    }, 500)
  }

  // Badge click handler (product__sep-design__judgemeBadge) remounts before scrolling
  window.remountSepJudgeMeWidgets = ensureJudgeMeWidgetsMounted

  function getJudgemeReviewsSectionEl(doc) {
    const el =
      doc.querySelector('#judgeme_product_reviews') ||
      doc.querySelector('.jdgm-review-widget') ||
      doc.querySelector('.reviews-wrapper-area')
    return el ? el.closest('.shopify-section') : null
  }

  function getJudgemeReviewsSection(handle) {
    if (!handle) return
    const target = getJudgemeReviewsSectionEl(document)
    const targetId = target && target.getAttribute('id')
    if (!targetId) return
    const sectionId = targetId.replace('shopify-section-', '')

    if (!window.pdp.judgemeReviewsHtmls) window.pdp.judgemeReviewsHtmls = {}

    const widgetProductId = (root) => {
      const w =
        root.querySelector('#judgeme_product_reviews') ||
        root.querySelector('.jdgm-review-widget') ||
        root.querySelector('.jdgm-rev-widg')
      return w ? String(w.getAttribute('data-id') || w.getAttribute('data-product-id') || '') : ''
    }

    // Already showing this product (first paint, or back to where we started):
    // never swap the markup out from under Judge.me, which is what blanked the
    // section when our fetch landed while loader.js was still mounting it.
    const currentId = window.pdp.currentProduct?.id ? String(window.pdp.currentProduct.id) : ''
    const liveProductId = widgetProductId(target)
    if (currentId && liveProductId && currentId === liveProductId) {
      ensureJudgeMeWidgetsMounted(target)
      return
    }

    const apply = (html) => {
      if (window.pdp.currentProduct?.handle && window.pdp.currentProduct.handle !== handle) return
      const live = getJudgemeReviewsSectionEl(document)
      if (!live) return
      const parsed = document.createElement('div')
      parsed.innerHTML = html
      const source =
        parsed.querySelector(`#${CSS.escape(targetId)}`) ||
        getJudgemeReviewsSectionEl(parsed) ||
        parsed
      // Bail on empty/error bodies rather than wiping the live widget
      if (!source.querySelector('#judgeme_product_reviews, .jdgm-widget, .jdgm-rev-widg, .jdgm-review-widget')) {
        return
      }

      const nextProductId = widgetProductId(source)
      if (nextProductId && nextProductId === widgetProductId(live) && judgeMeWidgetsMounted(live)) {
        return
      }

      live.innerHTML = source.innerHTML
      ensureJudgeMeWidgetsMounted(live)
    }

    const cached = window.pdp.judgemeReviewsHtmls[handle]
    if (cached) {
      apply(cached)
      return
    }

    // The section id is scoped to this page's JSON template. Products on another
    // template (sunglasses <-> Rx, safety, oph...) 404 on it, which left the old
    // product's reviews up. `view=` renders the target product with this page's
    // template so the id resolves; the default template has no view name, so fall
    // back to the full product page and pull the reviews section out of it.
    const templateSuffix = document.body?.dataset.templateSuffix || ''
    const sectionUrl =
      `/products/${handle}?section_id=${encodeURIComponent(sectionId)}` +
      (templateSuffix ? `&view=${encodeURIComponent(templateSuffix)}` : '')

    const load = (url) =>
      fetch(url).then((res) => (res.ok ? res.text() : Promise.reject(new Error(`reviews section ${res.status}`))))

    load(sectionUrl)
      .catch(() => load(`/products/${handle}`))
      .then((html) => {
        if (!html || !html.trim()) throw new Error('reviews section empty')
        window.pdp.judgemeReviewsHtmls[handle] = html
        apply(html)
      })
      .catch((err) => {
        console.warn('judgeme reviews section update failed', err)
      })
  }

  function attachJudgeMeEvents() {
    window.jdgm = window.jdgm || {};
    jdgm.CDN_HOST = "https://cdn.judge.me/";

    jdgm.docReady = function (callback) {
      if (
        document.attachEvent
          ? document.readyState === "complete"
          : document.readyState !== "loading"
      ) {
        setTimeout(callback, 0);
      } else {
        document.addEventListener("DOMContentLoaded", callback);
      }
    };

    jdgm.loadJS = function (url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          Function(xhr.response)();
          if (callback) callback(xhr.response);
        }
      };
      xhr.open("GET", url);
      xhr.send();
    };

    jdgm.docReady(function () {
      if (
        window.jdgmLoadCSS ||
        document.querySelectorAll(".jdgm-widget, .jdgm-all-reviews-page").length >
        0
      ) {
        jdgm.loadJS(jdgm.CDN_HOST + "loader.js");
      }
    });
  }

  function renderAdditionalSections() {
    const handle =
      window.pdp.currentProduct?.handle ||
      window.location.pathname.split('/products/').pop()?.split('?')[0] ||
      ''
    if (!handle) return

    // Reviews section doesn't depend on pdata; don't let a slow/failed pdata skip it
    getJudgemeReviewsSection(handle)

    const reqId = (window.pdp._pdataReqId = (window.pdp._pdataReqId || 0) + 1)

    fetch(`/products/${handle}?view=pdata`).then(res => res.text()).then(data => {
      if (reqId !== window.pdp._pdataReqId) return
      if (window.pdp.currentProduct?.handle && window.pdp.currentProduct.handle !== handle) return

      // GLASSON HANDLER
      const t = document.createElement('div')
      window.pdp.pdata = t;
      t.innerHTML = data;
      try {
        const glassonUserIdEl = t.querySelector('.glass-on-user-id')
        const glassonProductIdEl = t.querySelector('.glass-on-product-id')
        const glassonVtoEnabledEl = t.querySelector('.glass-on-vto-enabled')
        const selectedProductIdEl = t.querySelector('.product-id')
        if (glassonUserIdEl && glassonProductIdEl && glassonVtoEnabledEl && selectedProductIdEl) {
          getGlassOnAppBlock(
            selectedProductIdEl.innerHTML,
            glassonUserIdEl.innerHTML,
            glassonProductIdEl.innerHTML,
            glassonVtoEnabledEl.innerHTML
          )
        }
      } catch (err) {
        console.warn('Glasson pdata hydrate failed', err)
      }
      // GLASSON HANDLER: END
  
      getCompareSection();
      // getting FAQ
      getStaticSection('.shopify-section.sep-pdp-faq', 'faq')
      // getting global recommendation
      getStaticSection('.shopify-section.sep-pdp-recommendation', 'recommended')
      // getting mattex recommendation
      // getStaticSection('.shopify-section.related.recommended-products-section', 'recommended')
  
      // calculateDate()

      // Prefer pdata badge (always product-scoped) over stale cache from prior visits
      const badgeSource = t.querySelector('.judgeme-preview-badge')
      if (badgeSource) {
        if (!window.pdp.judgemeHtmls) window.pdp.judgemeHtmls = {}
        window.pdp.judgemeHtmls[handle] = badgeSource.innerHTML
        applyJudgemeBadgeForHandle(handle)
      }
  
      // update judgeme product featured review
      if (document.querySelector('.product__information_block.featured-review')) {
        const target = document.querySelector('.product__information_block.featured-review')
        if (window.pdp.featuredReviewSwiper) {
          try {
            window.pdp.featuredReviewSwiper.destroy(true, true)
          } catch (e) {}
          window.pdp.featuredReviewSwiper = null
        }
        const reviewNodes = t.querySelectorAll(
          '.judgeme-preview-reviews .jdgm-rev-widg__body .jdgm-rev-widg__reviews .jdgm-rev'
        )
        const length = reviewNodes.length
        if (length > 1) {
          const innerSliderTiles = Array.from(reviewNodes)
          .reduce((acc, e, i) => {
            const rating = e.querySelector('.jdgm-rev__rating')
            const titleEl = e.querySelector('.jdgm-rev__title')
            const bodyEl = e.querySelector('.jdgm-rev__body')
            const authorEl = e.querySelector('.jdgm-rev__author')
            const tsEl = e.querySelector('.jdgm-rev__timestamp')
            if (!rating || !titleEl || !bodyEl || !authorEl || !tsEl) return acc
            const date = (tsEl.getAttribute('data-content') || '').split(' ')[0].replaceAll('-', '/')
            if (i > 2) return acc
            return acc + `
              <div class="swiper-slide">
                <div class="stars">${rating.outerHTML}</div>
                <div class="title">${titleEl.innerHTML}</div>
                <div class="content">${bodyEl.innerHTML}</div>
                <div class="name-date">
                  <div class="name">${authorEl.innerHTML}</div>
                  <div class="date">${date}</div>
                </div>
              </div>
            `
          }, '')

          const swiperHtml = `
            <div class="review-swiper-container swiper">
              <div class="swiper-wrapper">
                ${innerSliderTiles}
              </div>
              <div class="swiper-pagination"></div>
            </div>
          `

          if (target && innerSliderTiles) {
            target.classList.remove('hidden')
            target.innerHTML = swiperHtml
            window.pdp.featuredReviewSwiper = new Swiper(target.querySelector('.review-swiper-container'), {
              slidesPerView: 1,
              loop: true,
              pagination: {
                el: target.querySelector('.swiper-pagination'),
                type: 'bullets',
                clickable: true,
              },
              autoplay: {
                delay: 15000
              }
            })
          }
        } else {
          if (target) {
            target.innerHTML = ''
            target.classList.add('hidden')
          }
        }
      }

      const additionalInformation = document.querySelector('.product__information_block.additional-information')
      const addInfoSource = t.querySelector('.product__information_block.additional-information')
      if (additionalInformation && addInfoSource) {
        const isSideShieldPdp = !!document.querySelector('.sep-design-pdp.is-side-shield-pdp')
        const prevFit = additionalInformation.querySelector('.additional-block.frame-details')
        const prevFitHtml = prevFit ? prevFit.outerHTML : ''
        additionalInformation.innerHTML = addInfoSource.innerHTML
        if (isSideShieldPdp) {
          additionalInformation.querySelectorAll('.additional-block.frame-details').forEach((el) => el.remove())
        } else {
          const hasFit =
            additionalInformation.querySelector('#frame-details-fit-guide') ||
            additionalInformation.querySelector('.additional-block.frame-details')
          if (prevFitHtml && !hasFit) {
            additionalInformation.insertAdjacentHTML('beforeend', prevFitHtml)
          }
        }
        if (typeof retargetPdpSizeFitLinks === 'function') retargetPdpSizeFitLinks()
      }
    }).catch((err) => {
      console.warn('pdata hydrate failed', err)
    })

    // Size selector (Standard / XL) below other-products slider
    updatePdpSizeSelector()

    fetch(`https://api.neveneyewear.com/api/product-meta/${window.pdp.currentProduct.handle}/purchases_in_24`)
      .then(res => res.json())
      .then(res => {
        const purchaseHistorySpan = document.querySelector('.product__information_block .purchase-history-banner-text span')
        if (purchaseHistorySpan) {
          purchaseHistorySpan.innerHTML = res.data || '0'
        }
      })
      .catch(() => {
        const purchaseHistorySpan = document.querySelector('.product__information_block .purchase-history-banner-text span')
        if (purchaseHistorySpan) {
          purchaseHistorySpan.innerHTML = '0'
        }
      })

    fetchSectionHtml(`/products/${window.pdp.currentProduct.handle}?section_id=sep-pdp-happyfaces&section_lazy_loading=true`)
      .then(data => {
        const div = new DOMParser().parseFromString(data, 'text/html')
        const happyfaces = div.querySelector('#shopify-section-sep-pdp-happyfaces .happy-faces-container')?.innerHTML
        if (happyfaces && document.querySelector('.happy-faces-container')) {
          document.querySelector('.happy-faces-container').innerHTML = happyfaces
        }
      })
  }

  function syncPdpMobileBottomMenuOffset() {
    const menu = document.querySelector('nav.nvn-mobile-bottom-menu')
    const height = menu && window.getComputedStyle(menu).display !== 'none'
      ? Math.ceil(menu.getBoundingClientRect().height)
      : 0
    document.documentElement.style.setProperty('--nvn-mobile-bottom-menu-height', `${height || 73}px`)
  }

  function syncPdpMobileStickyAtc() {
    const bar = document.getElementById('pdp-sticky-atc')
    const stickyBtn = bar?.querySelector('.atc-button')
    const mainBtn = getMainAtcButton()
    if (!bar || !stickyBtn || !mainBtn) return

    const productId = window.pdp.currentProduct?.id
    if (productId) bar.setAttribute('product_id', String(productId))
    bar.classList.add('atc')

    const modal = document.getElementById('rx-config-modal')
    const modalOpen = modal && !modal.hidden
    // The button carries the label only (no price). Leave it alone mid-add and while it says "Added".
    const busy = stickyBtn.querySelector('.spinning_circle') || stickyBtn.classList.contains('is-added')
    if (!busy) {
      const label = (mainBtn.querySelector('.atc-button__label') || mainBtn).textContent.trim()
      stickyBtn.textContent = label || 'ADD TO CART'
      stickyBtn.classList.toggle('disabled', mainBtn.classList.contains('disabled'))
    }
    stickyBtn.classList.toggle('atc-button--notify', mainBtn.classList.contains('atc-button--notify'))
    syncPdpStickyAtcSummary(bar)
    const show = !modalOpen && isPdpMainAtcScrolledAway() && !isPdpFooterLegalInView()
    // Fade in/out instead of snapping: drop the server-rendered `hidden` and let CSS transition .is-visible
    bar.hidden = false
    bar.classList.toggle('is-visible', show)
    bar.inert = !show
    // Desktop: the dock floats centred, so lift the Richpanel bubble (footer-neven.css reads the
    // variable) only when the dock reaches the bubble's corner on narrower windows
    const sideGap = (window.innerWidth - bar.offsetWidth) / 2
    const lift =
      show && window.innerWidth > 798 && sideGap < 96
        ? Math.ceil(bar.offsetHeight + (parseFloat(window.getComputedStyle(bar).bottom) || 0))
        : 0
    document.documentElement.style.setProperty('--pdp-sticky-atc-lift', `${lift}px`)
  }

  // Bottom edge of everything pinned at the top: the fixed header, plus the sticky price row on mobile
  function getPdpStickyTopOffset() {
    let top = 0
    const header = document.getElementById('header-group')
    if (header) top = Math.max(top, header.getBoundingClientRect().bottom)
    const priceRow = document.querySelector('.product__information .product__information_block.price-block')
    if (priceRow && window.getComputedStyle(priceRow).position === 'sticky') {
      top = Math.max(top, priceRow.getBoundingClientRect().bottom)
    }
    return top
  }

  // The bar shows once the buy box ATC has scrolled up out of view, not while it is still below the fold
  function isPdpMainAtcScrolledAway() {
    const block = getMainAtcBlock()
    const rect = block?.getBoundingClientRect()
    if (!rect || rect.height === 0) return window.scrollY > 535
    return rect.bottom < getPdpStickyTopOffset()
  }

  // Desktop: step aside once the footer's legal row scrolls in, so the bar never covers the policy links.
  // Mobile pads the legal row instead (footer-neven.css).
  function isPdpFooterLegalInView() {
    if (window.innerWidth <= 798) return false
    const legal = document.querySelector('.nv-legal')
    return !!legal && legal.getBoundingClientRect().top < window.innerHeight
  }

  // Default image of the gallery on screen, so the thumbnail follows the selected colour.
  // Rx pages show the colour's gallery, not the Rx product's own featured image.
  function getPdpGalleryDefaultImageSrc() {
    const wrapper = [...document.querySelectorAll('.sep-design-pdp .mainslider-wrapper')].find(
      (w) => w.getClientRects().length && !w.closest('.hidden')
    )
    if (!wrapper) return ''
    const slides = '.swiper-slide:not([data-special-slide]):not(.swiper-slide-duplicate)'
    const img =
      wrapper.querySelector(`${slides} img[fetchpriority="high"]`) ||
      wrapper.querySelector(`${slides} img`)
    return img?.currentSrc || img?.getAttribute('src') || ''
  }

  function syncPdpStickyAtcSummary(bar) {
    const product = window.pdp.currentProduct
    if (!product) return
    const titleEl = bar.querySelector('[data-sticky-atc-title]')
    if (titleEl && product.title) titleEl.textContent = product.title

    const thumbEl = bar.querySelector('[data-sticky-atc-thumb]')
    const variant = window.pdp.selectedVariant
    const src =
      getPdpGalleryDefaultImageSrc() ||
      variantFeaturedImageSrc(variant) ||
      product.image?.src ||
      product.images?.[0]?.src ||
      ''
    if (thumbEl && src && thumbEl.getAttribute('src') !== src) thumbEl.setAttribute('src', src)
  }

  function initPdpMobileStickyAtc() {
    const bar = document.getElementById('pdp-sticky-atc')
    if (!bar || bar.dataset.inited === '1') return
    bar.dataset.inited = '1'
    bar.classList.add('atc')

    const refresh = () => {
      syncPdpMobileBottomMenuOffset()
      syncPdpMobileStickyAtc()
    }

    refresh()
    window.addEventListener('resize', refresh)
    window.addEventListener('scroll', refresh, { passive: true })
    window.syncPdpMobileStickyAtc = syncPdpMobileStickyAtc
    window.reobservePdpMobileStickyAtc = refresh

    const menu = document.querySelector('nav.nvn-mobile-bottom-menu')
    if (menu && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(() => syncPdpMobileBottomMenuOffset()).observe(menu)
    }
    syncPdpMobileBottomMenuOffset()
  }

  function updateATCText(_value) {
    let value
    if (_value) value = _value
    else value = window.pdp.selectedVariant
    
    // Always sync availability from currentProduct.variants array (which is updated by getProductVariantWithAvailability)
    if (value && value.id && window.pdp.currentProduct && window.pdp.currentProduct.variants) {
      const currentVariant = window.pdp.currentProduct.variants.find(v => v.id === value.id)
      if (currentVariant && currentVariant.hasOwnProperty('available')) {
        value.available = currentVariant.available
      }
    }

    let productId
    if (value && value.product_id) {
      productId = value.product_id
    } else if (window.pdp.currentProduct && window.pdp.currentProduct.id) {
      productId = window.pdp.currentProduct.id
    } else {
      productId = null
    }

    const mainAtcButton = getMainAtcButton()
    const stickyAtcButton = getRxConfigStickyAtcButton()
    const atcButton = stickyAtcButton || mainAtcButton
    const bisBlock = document.querySelector('.product__information_block.bis')
    if (mainAtcButton) mainAtcButton.classList.remove('atc-button--notify')

    const badgesBlock = document.querySelector('.product__information_block.badges')
    
    const url = new URL(window.location)
    let variantId
    if (value && value.id) {
      variantId = value.id
    } else {
      variantId = url.searchParams.get('variant')
    }

    if (!window.pdp.currentProduct) {
      return
    }

    let showAddToCart = true

    if (window.pdp.currentProduct.product_type === 'Prescription' || window.pdp.currentProduct.product_type === 'Ophthalmic') {
      if (!variantId) {
        showAddToCart = false
      }
    }

    const selectedLensColor = normalizeRxOptionHandle(window.pdp.rx?.['lens-color'] || '')
    const shouldUseFirstVariantAvailability =
      window.pdp.currentProduct.product_type === 'Prescription' &&
      RX_LENS_TAG_GATED_LENS_COLORS.includes(selectedLensColor)
    const firstVariantUnavailable =
      shouldUseFirstVariantAvailability &&
      window.pdp.currentProduct?.variants?.[0] &&
      window.pdp.currentProduct.variants[0].available === false
    const effectiveAvailable = shouldUseFirstVariantAvailability
      ? !firstVariantUnavailable
      : (value ? value.available : undefined)

    const applySoldOutUi = (soldOut) => {
      if (bisBlock && !bisBlock.closest('#pdp-notify-modal')) {
        bisBlock.classList.toggle('hidden', !soldOut || usesNotifyMeModal())
      }
      if (badgesBlock) {
        if (soldOut) {
          badgesBlock.innerHTML = '<div class="badge_item">SOLD OUT</div>'
        } else if (window.pdp.currentProduct?.product_type === 'Safety') {
          badgesBlock.innerHTML =
            '<span class="badge_item badge_item--new">NEW</span>' +
            '<span class="badge_item badge_item--z87">ANSI Z87+ · HIGH IMPACT</span>'
        } else {
          badgesBlock.innerHTML = ''
        }
      }
      const info = document.querySelector('.product__information')
      if (info) info.classList.toggle('sold_out', !!soldOut)
    }

    // Main PDP ATC: for Rx/Oph opens configurator — no price on button
    if (usesRxConfigModal() && mainAtcButton) {
      if (firstVariantUnavailable || (value && value.id && effectiveAvailable === false)) {
        mainAtcButton.innerHTML = 'SOLD OUT'
        mainAtcButton.classList.add('disabled')
        applySoldOutUi(true)
      } else {
        const priceVariant = (value && value.id) ? value : window.pdp.currentProduct?.variants?.[0]
        mainAtcButton.innerHTML = getAddToCartButtonText(priceVariant, { hidePrice: true })
        mainAtcButton.classList.remove('disabled')
        applySoldOutUi(false)
      }
    }

    const configAtcButton = stickyAtcButton
    if (usesRxConfigModal() && configAtcButton) {
      if (value && value.id && showAddToCart) {
        if (effectiveAvailable || effectiveAvailable === undefined) {
          configAtcButton.innerHTML = getAddToCartButtonText(value, { applyRxDiscount: true })
          configAtcButton.classList.remove('disabled')
        } else {
          configAtcButton.innerHTML = 'SOLD OUT'
          configAtcButton.classList.add('disabled')
        }
      } else {
        let buttonText = 'SELECT OPTIONS'
        configAtcButton.innerHTML = buttonText
        configAtcButton.classList.add('disabled')
        if (window.pdp.currentProduct.product_type === 'Prescription') {
          if (!window.pdp.rx['lens-type'] || !document.querySelector('#lens-type-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR LENS TYPE'
            configAtcButton.innerHTML = buttonText
          }
          if (!window.pdp.rx['lens-color'] || !document.querySelector('#lens-color-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR LENS COLOR'
            configAtcButton.innerHTML = buttonText
          }
        } else if (window.pdp.currentProduct.product_type === 'Ophthalmic') {
          if (!window.pdp.rx['lens-type'] || !document.querySelector('#lens-type-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR LENS TYPE'
            configAtcButton.innerHTML = buttonText
          }
          if (!window.pdp.rx['oph-type'] || !document.querySelector('#oph-type-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR TYPE'
            configAtcButton.innerHTML = buttonText
          }
        }
      }
      syncRxConfigModalGallery()
    }

    if (usesRxConfigModal()) {
      if (typeof window.syncPdpMobileStickyAtc === 'function') window.syncPdpMobileStickyAtc()
      else syncPdpMobileStickyAtc()
      return
    }

    if (value && value.id && showAddToCart) {
      if (effectiveAvailable || effectiveAvailable === undefined) {
        if (mainAtcButton) {
          mainAtcButton.innerHTML = getAddToCartButtonText(value)
          mainAtcButton.classList.remove('disabled')
        }
        applySoldOutUi(false)
      } else {
        if (mainAtcButton && usesNotifyMeModal()) {
          mainAtcButton.innerHTML = 'NOTIFY ME WHEN AVAILABLE'
          mainAtcButton.classList.remove('disabled')
          mainAtcButton.classList.add('atc-button--notify')
        } else if (mainAtcButton) {
          mainAtcButton.innerHTML = 'SOLD OUT'
          mainAtcButton.classList.add('disabled')
        }
        applySoldOutUi(true)
      }
    } else {
      if (mainAtcButton) {
        let buttonText = "SELECT OPTIONS"
        mainAtcButton.innerHTML = buttonText
        mainAtcButton.classList.add('disabled')
        
        if (window.pdp.currentProduct.product_type === 'Prescription') {
          
          if (!window.pdp.rx['lens-type'] || !document.querySelector('#lens-type-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR LENS TYPE'
            mainAtcButton.innerHTML = buttonText
          }
          if (!window.pdp.rx['lens-color'] || !document.querySelector('#lens-color-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR LENS COLOR'
            mainAtcButton.innerHTML = buttonText
          }
        } else if (window.pdp.currentProduct.product_type === 'Ophthalmic') {
          
          if (!window.pdp.rx['lens-type'] || !document.querySelector('#lens-type-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR LENS TYPE'
            mainAtcButton.innerHTML = buttonText
          }
          if (!window.pdp.rx['oph-type'] || !document.querySelector('#oph-type-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR TYPE'
            mainAtcButton.innerHTML = buttonText
          }
        }
      }
      applySoldOutUi(!!firstVariantUnavailable)
    }
    if (typeof window.syncPdpMobileStickyAtc === 'function') window.syncPdpMobileStickyAtc()
    else syncPdpMobileStickyAtc()
  }

  function addBisListeners() {
    const urlParams = new URLSearchParams(window.location.search);
    const lv_vid = urlParams.get('variant')
    const first_vid = window.pdp.currentProduct.variants[0].id;  

    function createNotify() {
      if (typeof BIS != 'undefined') {
        if ($('[name=method]:checked').length) {
          var method = $('[name=method]:checked').data('tab')
          var variantId = window.pdp.selectedVariant?.id || lv_vid || first_vid ;
          var payload = {
            email: null,
            pId: window.pdp.currentProduct.id,
            vId: variantId,
            optIn: false,
            phone: null
          };
          switch (method) {
            case 'phone-number':
              var phone = window.toUSE164($('#phone-number input').first().val());

              if (!phone){
                handleBISError({errors: { 0: 'Invalid phone number.' }});
                return false;
              }
              payload.phone = phone;
              BIS.create(null, payload.vId, payload.pId, { phone_number: payload.phone }).then(function(resp) {
                if (resp.status == 'OK') {
                  handleBISSuccess(resp);
                } else {
                  handleBISError(resp);
                }
              });
              break;
            case 'email-address':
              payload.email = $('#email-address input').first().val();
              payload.optIn = $('#customer_accepts_marketing').is(':checked')
              BIS.create(payload.email, payload.vId, payload.pId, { accepts_marketing: payload.optIn }).then(function(resp) {
                if (resp.status == 'OK'){
                  handleBISSuccess(resp)
                }else{
                  handleBISError(resp);
                }
              });
            break;
          }
        }
      } else {
        console.error("BIS object undefined!");
      }
      return
    }

    var clearBISResponse = function() {
      $('#BIS_form .BIS_response').text('');
    };

    var handleBISSuccess = function(resp) {
      var msgWrapOpen = '<p style="background-color: #aaffaa">';
      var msgWrapClose = '</p>';
      var message = resp.message;

      $('.BIS_response').html(msgWrapOpen+message+msgWrapClose);
    };

    var handleBISError = function(resp) {
      var msgWrapOpen = '<p style="background-color: #ffaaaa">';
      var msgWrapClose = '</p>';
      var message = '';
      for (var x in resp.errors)
      {
        message += msgWrapOpen + resp.errors[x] + msgWrapClose;
      }

      $('.BIS_response').html(message);
    }

    $(function() {
      $('#BIS_form input').on('focus change', clearBISResponse);
      $('[name=method]').on('change', (e)=>{
        $('[name=method]').parent().removeClass('active')
        $('[name=method]:checked').parent().addClass('active')
        if ($('[name=method]:checked').data('tab') == 'email-address'){
          $('#phone-number').hide()
          $('#email-address').show()
        } else {
          $('#email-address').hide()
          $('#phone-number').show()
        }
      });

      // hide the Notify me form if the variant options combination does not exist
      var _origSelectCallback = window.selectCallback;
      window.selectCallback = function(variant, selector) {
        _origSelectCallback.apply(window, arguments);
        if (variant == null) {
          $('#notify-form').stop().hide();
        }
      }

      $('.submit-notifyme').click(function(e) {
        e.preventDefault()
        // clearBISResponse();
        createNotify()
      });
    });

    window.toUSE164 = function(num) {
      if (num) {
        let e164 = num.trim().replace(/-/g, '').replace(/ /g, '');
        console.log('toE164: ', e164);
        e164 = e164.match(/[2-9][0-9]{9}/g);
        if (e164 === null) {
          return '';
        }
        e164 = e164.join('');
        e164 = '+1' + e164;
        e164 = e164.substring(0, 12);
        return e164;
      }
    };
  }

  document.addEventListener('state:change:currentProductHandle', (event) => {
    const handle = event.detail.value
    fetchProductJsonMerged(`/products/${handle}.json`)
      .then(data => {
        if (!data?.product?.handle) {
          if (window.pdp.currentProduct?.handle === handle) return
          endPdpProductSwitch(null, handle, true)
          navigateToPdpHandle(handle)
          return
        }
        setState['currentProduct'](data.product)
      })
      .catch(() => {
        if (window.pdp.currentProduct?.handle === handle) return
        endPdpProductSwitch(null, handle, true)
        navigateToPdpHandle(handle)
      })

    if (sepStorefrontEnabled()) {
      populateVariantPricesFromStorefront(handle).then(() => {
        const p = window.pdp.currentProduct
        if (!p || p.handle !== handle) return
        const v = window.pdp.selectedVariant || findSafetyLensTypeVariant(p)
        if (v) applyPriceBlockForVariant(v)
        refreshSafetyLensInlineFromProduct(p)
      })
    } else {
      fetchSectionHtml(`/products/${handle}?section_id=sep-pdp-varprices`)
        .then(data => {
          const div = new DOMParser().parseFromString(data, 'text/html')
          const variantPrice = div.querySelector('#shopify-section-sep-pdp-varprices')
          if (variantPrice) {
            variantPrice.querySelectorAll('.variant-price').forEach(variantPriceElement => {
              const variantId = variantPriceElement.getAttribute('data-variant-id')
              if (variantId) {
                window.pdp.variantPriceHtmls[variantId] = variantPriceElement.innerHTML
              }
            })
          }
          const p = window.pdp.currentProduct
          if (!p || p.handle !== handle) return
          const v = window.pdp.selectedVariant || findSafetyLensTypeVariant(p)
          if (v) applyPriceBlockForVariant(v)
          refreshSafetyLensInlineFromProduct(p)
        })
    }

    // Change main swiper to the new product
    const afterGalleryMount = () => {
      if (window.pdp.currentProduct?.handle === handle && typeof changeSliderImages === 'function') {
        changeSliderImages()
      }
    }

    if (
      handle &&
      (window.pdp.swipers[handle] ||
        window.pdp.swiperHtmls[handle] ||
        getMainSliderRootForHandle(handle))
    ) {
      mountMainSwiperForHandle(handle)
      afterGalleryMount()
    } else if (handle) {
      ensureSepDesignProductAssets(handle).then(() => {
        if (window.pdp.currentProductHandle === handle) {
          mountMainSwiperForHandle(handle)
          afterGalleryMount()
        }
      })
    }
  })

  document.addEventListener('state:change:currentProductType', (event) => {
    const value = event.detail.value
    if (value === 'sunglasses') ensureSafetyPdpCss()
    const bisBlock = document.querySelector('.product__information_block.bis')
    const currentHandle = window.pdp.currentProduct.handle
    let productHandle = ''
    let mainCollection = ''
    if (value === 'sunglasses') {
      if (currentHandle && currentHandle.endsWith('-rx')) {
        productHandle = currentHandle.replace(/-rx$/, '')
      } else if (window.pdp.linkedProductHandle) {
        productHandle = window.pdp.linkedProductHandle
      }
      mainCollection = window.pdp.mainCollection ? window.pdp.mainCollection.replace(/^prescription-/, '') : ''
      const beforeVsAfter = document.querySelector('.before_vs_after')
      if (beforeVsAfter) {
        beforeVsAfter.classList.remove('hidden')
      }
    } else {
      if (
        currentHandle &&
        !currentHandle.includes('-rx') &&
        (window.pdp._rxAvailable?.[toRxHandle(currentHandle)] ||
          window.pdp.counterPartCollectionProducts.find(product => product.handle === `${currentHandle}-rx`))
      ) {
        productHandle = `${currentHandle}-rx`
      } else if (window.pdp.linkedProductHandle) {
        productHandle = window.pdp.linkedProductHandle
      }
      mainCollection = window.pdp.mainCollection ? `prescription-${window.pdp.mainCollection.replace(/^prescription-/, '')}` : ''
      const beforeVsAfter = document.querySelector('.before_vs_after')
      if (beforeVsAfter) {
        beforeVsAfter.classList.add('hidden')
      }
    }
    if (productHandle && productHandle !== currentHandle) {
      window.pdp.linkedProductHandle = currentHandle
      setState['currentProductHandle'](productHandle)
      if (mainCollection) {
        setState['mainCollection'](mainCollection)
      }
    } else {
      updateRxToggleUI(value === 'prescription')
      placeRxToggleForProductType(value === 'prescription' ? 'Prescription' : 'Sunglasses')
      endPdpProductSwitch('rx', value, true)
    }
  })

  document.addEventListener('state:change:currentProduct', (event) => {
    const value = event.detail.value
    if (!value) return

    try {
      paintPdpProductChrome(value)
    } catch (e) {
      console.warn('paintPdpProductChrome', e)
    }

    try {
      applySafetyLensFromUrlIfApplicable(value)
      if (isSafetyPdpProduct(value)) {
        rememberZ87Handle(value.handle)
        window.pdp._safetySunPair = {
          safety: value.handle,
          regular: toRegularHandle(value.handle)
        }
        if (window.pdp._safetyLensWanted) window.pdp.safetyLensType = window.pdp._safetyLensWanted
        refreshSafetyLensInlineFromProduct(value)
        const picked = findSafetyLensTypeVariant(value)
        updateSafetyTrioBadge(picked)
        paintSafetyAtcTotal()
      } else {
        window.pdp.safetyShields = {}
        window.pdp._safetyShieldSnap = null
        window.pdp._safetyLensWanted = null
      }

      nvzOptLog('product:change', {
        handle: value.handle,
        type: value.product_type,
        isSun: isSunglassesPdpProduct(value),
        liveOpts: getVisiblePdpOptions()?.getAttribute('data-pdp-options-type') || null
      })
      syncSafetyPdpCssScope(value)
      if (!document.querySelector('.sep-design-pdp.is-side-shield-pdp')) {
        syncPdpOptions(value)
        placeRxToggleForProductType(value.product_type)
      }
      if (isSafetyPdpProduct(value) && window.pdp._safetyShieldSnap) {
        restoreSafetyShieldsByTitle(window.pdp._safetyShieldSnap)
      }
    } catch (e) {
      console.warn('state:change:currentProduct:options', e)
    }

    resolvePdpProductSwitchFromProduct(value)

    if (isSafetyPdpProduct(value)) {
      applySafetySelectionToProduct(value)
      if (window.pdp._safetyShieldSnap) {
        restoreSafetyShieldsByTitle(window.pdp._safetyShieldSnap)
        window.pdp._safetyShieldSnap = null
      }
    }

    if (value?.product_type === 'Prescription' && window.pdp._scrollTopAfterRxLoad) {
      window.pdp._scrollTopAfterRxLoad = false
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    }

    if (value?.product_type === 'Prescription') {
      syncPrescriptionRxLensTagVisibilityFromProduct(value)
      initLensStyleForPrescription()
    }

    // get variant with availability
    getProductVariantWithAvailability().then(() => {
      applyRxLensColorFromUrlIfApplicable()
      // change selected variant
      findSelectedVariant()
      // Update ATC text after availability is fetched and variant is selected
      updateATCText()
      if (window.pdp.currentProduct?.id === value.id && isSafetyPdpProduct(value)) {
        updateSafetyTrioBadge(window.pdp.selectedVariant)
        paintSafetyAtcTotal()
      }
      if (!window.pdp.selectedVariant || Object.keys(window.pdp.selectedVariant).length === 0) {
        const url = new URL(window.location)
        let ophType = url.searchParams.get('oph-type')
        if (ophType) {
          if (ophType === 'bluelight') ophType = 'blue-light'
          setState['oph-type'](ophType)
          document.querySelector('.dropdown-option[data-value="' + ophType + '"]').click()
        }
      }
      syncGlassonTryOnLenColorIdFromRxState()
    })

    renderWishlistButton()

    // hide rx information on main column (options live in config modal)
    const rxInformation = document.querySelector('.product__information_block.rx-information')
    if (rxInformation) {
      mountRxConfigModal()
      syncRxConfigModalProductId()
    }

    if (window.pdp._openRxConfigAfterProductLoad && usesRxConfigModal()) {
      window.pdp._openRxConfigAfterProductLoad = false
      openRxConfigModal()
    } else if (!usesRxConfigModal()) {
      closeRxConfigModal()
    }

    // sunglasses feats/ship3 vs default freeshipping
    try {
      updateSepPerkFeatures(value)
    } catch (e) {
      console.error('updateSepPerkFeatures', e)
    }

    requestAnimationFrame(updatePdpSizeSelector)

    // Change judgeme badge (retry via dedicated fetch if not cached yet)
    if (!applyJudgemeBadgeForHandle(value.handle)) {
      ensureJudgemeHtmlForHandle(value.handle).then(() => {
        if (window.pdp.currentProduct?.handle === value.handle) {
          applyJudgemeBadgeForHandle(value.handle)
        }
      })
    }

    // change slider images
    changeSliderImages()

    // render glasson, recommendation, FAQ, etc.
    renderAdditionalSections()

    // Change subtitle
    if (typeof window.pdp.subtitleHtmls[value.handle] === 'string') {
      const subtitleElement = document.querySelector('.product__information_block.subtitle')
      if (subtitleElement) {
        subtitleElement.innerHTML = window.pdp.subtitleHtmls[value.handle]
        subtitleElement.classList.remove('hidden')
      }
    } else if (sepStorefrontEnabled()) {
      applySubtitleFromStorefront(value.handle)
    } else {
      fetchSectionHtml(`/products/${value.handle}?section_id=sep-pdp-subtitle`)
        .then(data => {
          const div = new DOMParser().parseFromString(data, 'text/html')
          const subtitle = div.querySelector('#shopify-section-sep-pdp-subtitle').innerHTML
          window.pdp.subtitleHtmls[value.handle] = subtitle
          const subtitleElement = document.querySelector('.product__information_block.subtitle')
          if (subtitleElement) {
            if (subtitle) {
              subtitleElement.innerHTML = window.pdp.subtitleHtmls[value.handle]
              subtitleElement.classList.remove('hidden')
            } else {
              subtitleElement.innerHTML = ''
              subtitleElement.classList.add('hidden')
            }
          }
        })
    }

    const body = document.querySelector('body')
    if (body) {
      if (value.product_type === 'Ophthalmic') {
        body.setAttribute('data-selected-product-type', 'ophthalmic')
      } else if (value.product_type === 'Prescription') {
        body.setAttribute('data-selected-product-type', 'rx')
      } else {
        body.removeAttribute('data-selected-product-type')
      }
    }

    // lens upgrade options visibility
    if (value.product_type === 'Prescription' || value.product_type === 'Ophthalmic') {
      console.log('state:change:currentProduct: window.pdp.selectedVariant', window.pdp.selectedVariant)
      if (usesRxConfigModal()) {
        keepRxConfigOptionPanelsOpen()
      } else if (!window.pdp.selectedVariant || Object.keys(window.pdp.selectedVariant).length === 0 || window.pdp.selectedVariant.product_id !== value.id) {
        const lensTypeDropdown = document.querySelector(`.dropdown.lens-type`)
        if (lensTypeDropdown) {
          lensTypeDropdown.querySelector('.dropdown-panel').classList.add('disabled')
        }
        const lensUpgradeDropdown = document.querySelector(`.dropdown.lens-upgrade`)
        if (lensUpgradeDropdown) {
          lensUpgradeDropdown.querySelector('.dropdown-panel').classList.add('disabled')
        }
      }
    }

    // b1g2f message change — selected lens, not variants[0]
    const offerVariant = isSafetyPdpProduct(value)
      ? (findSafetyLensTypeVariant(value) || window.pdp.selectedVariant || value.variants?.[0])
      : (window.pdp.selectedVariant || value.variants?.[0])
    setSepDesignB1g2fContent(value.product_type, offerVariant?.price)
    if (isSafetyPdpProduct(value)) updateSafetyTrioBadge(offerVariant)

    // add attribute to other products selector
    const otherProductsWrapper = document.querySelector('.product__information_block.other-products')
    if (otherProductsWrapper && value.product_type) {
      otherProductsWrapper.setAttribute('data-selected-product-type', value.product_type.toLowerCase())
    }

    setTimeout(() => {
      changeSliderImages()
    }, 1000)

    if (!window.pdp.mainSliderPosition.isEventListenerAdded) {
      window.addEventListener('resize', handleMainSliderPosition)
      window.addEventListener('resize', adjustSliderWidth)
      window.addEventListener('resize', updatePriceBlockStickyTop)
      window.addEventListener('load', handleMainSliderPosition)
      window.addEventListener('load', adjustSliderWidth)
      window.addEventListener('load', updatePriceBlockStickyTop)
      window.addEventListener('scroll', updateStickyBorder, { passive: true })
      handleMainSliderPosition()
      adjustSliderWidth()
      updatePriceBlockStickyTop()
      window.pdp.mainSliderPosition.isEventListenerAdded = true
    } else {
      handleMainSliderPosition(value.handle)
      adjustSliderWidth()
      updatePriceBlockStickyTop()
    }

    updateATCText()
  })

  document.addEventListener('state:change:initialized', (event) => {
    const value = event.detail.value
    console.log('initialized', value)
    // pdpBackgroundTask()
    onUserInteraction(pdpBackgroundTask)
    
    if (window.SEP_DESIGN_PDP.enableRxInit) {
      readFromVariantParam()
      checkEditMode()
      updateLensUpgradeAvailability()
      updateLensUpgradePricing()
      if (window.pdp.currentProduct?.product_type === 'Prescription' || window.pdp.currentProduct?.product_type === 'Ophthalmic') {
        changeSliderImages()
      }
      mountRxConfigModal()
      if (window.pdp.editMode && usesRxConfigModal()) {
        const tryOpenEditModal = () => {
          if (document.getElementById('rx-config-modal')) {
            openRxConfigModal()
          } else {
            requestAnimationFrame(tryOpenEditModal)
          }
        }
        tryOpenEditModal()
      }
    
    }
    if (window.pdp.currentProduct?.product_type === 'Safety') {
      window.pdp.lock.variantParam = false
      writeSafetyVariantToUrl(
        window.pdp.selectedVariant?.id
          ? window.pdp.selectedVariant
          : findSafetyLensTypeVariant(window.pdp.currentProduct)
      )
    }
    initLensStyleForPrescription()
    updatePhotochromicLensColorLabels()
    syncGlassonTryOnLenColorIdFromRxState()
    requestAnimationFrame(updatePdpSizeSelector)

    const addUnprocessedUpsellProduct = (node) => {
      const nextUpsellItem = node.querySelector('.cart_drawer_upsell.no-display')
      if (nextUpsellItem) {
        const recommendedProducts = document.querySelector('.product__information_block.recommended-products')
        if (recommendedProducts) {
          recommendedProducts.classList.remove('hidden')
          recommendedProducts.innerHTML = nextUpsellItem.outerHTML
          const _nextUpsellItem = recommendedProducts.querySelector('.cart_drawer_upsell')
          if (_nextUpsellItem) {
            _nextUpsellItem.classList.remove('no-display')
            const addButton = _nextUpsellItem.querySelector('.cart_drawer_upsell_add')
            if (addButton) {
              addButton.innerHTML = 'ADD TO CART'
            }
            const img = _nextUpsellItem.querySelector('img')
            if (img) {
              const src = img.src
              img.src = src.replace('100x', '200x')
            }
          }
        }
      }
    }

    // attach observer for drawer cart, to change recommended products
    const drawerCart = document.querySelector('#shopify-section-cart-drawer')
    if (drawerCart) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          console.log('mutation', mutation)
          const addedNodes = Array.from(mutation.addedNodes)
          if (addedNodes.length > 0) {
            addedNodes.forEach((node) => {
              if (node?.classList?.contains('cart_drawer_main_container')) {
                addUnprocessedUpsellProduct(node)
              }
            })
          }
        })
      })
      // observer.observe(drawerCart, { childList: true, subtree: true })

      // addUnprocessedUpsellProduct(drawerCart)
    }

    addBisListeners()
    updateATCText()
  })

  document.addEventListener('state:change:mainCollection', (event) => {
    const value = event.detail.value
    if (window.pdp.swipers[value]) {
      $(document).find('.product__information_block.other-products .other-products-container').addClass('hidden')
      $(window.pdp.swipers[value].swiper.el).closest('.other-products-container').removeClass('hidden')
      requestAnimationFrame(() => {
        updatePdpSizeSelector()
        syncPdpOptions(window.pdp.currentProduct, { force: true })
      })
    } else {
      refreshOtherProductsForHandle(window.pdp.currentProductHandle)
    }

    fetchCollectionProductsStorefrontFirst(value).then(products => {
      window.pdp.mainCollectionProducts = products
    })
  })

  const RX_LENS_TAG_GATED_LENS_COLORS = ['yellow', 'green-vibrant', 'purple-pastel', 'photochromic-gray', 'photochromic-brown']
  const RX_LENS_COLOR_TRY_ORDER = ['clear', 'black', 'brown', 'yellow', 'coastal-blue', 'purple-pastel', 'green-vibrant', 'rose-pink', 'silver', 'photochromic-gray', 'photochromic-brown']

  function getRxLensColorHandleFromLensQueryParam() {
    try {
      const raw = new URL(window.location.href).searchParams.get('lens')
      if (!raw || typeof raw !== 'string') return ''
      const stripped = raw.replace(/^rx-lens-color-/i, '').trim()
      return normalizeRxOptionHandle(stripped)
    } catch (e) {
      return ''
    }
  }

  function clearRxLensQueryParamFromUrl() {
    try {
      const url = new URL(window.location.href)
      if (!url.searchParams.has('lens')) return
      url.searchParams.delete('lens')
      window.history.replaceState({}, '', url)
    } catch (e) {}
  }

  function resolveInitialLensStyleForPrescription() {
    const url = new URL(window.location)
    const variantId = url.searchParams.get('variant')
    const urlLensColor = getRxLensColorHandleFromLensQueryParam()
    if (variantId) {
      return normalizeLensStyleToAvailable(deriveLensStyleFromColor(window.pdp.rx['lens-color']))
    }
    if (urlLensColor) {
      return normalizeLensStyleToAvailable(deriveLensStyleFromColor(urlLensColor))
    }
    return normalizeLensStyleToAvailable('basic')
  }

  function applyRxLensColorFromUrlIfApplicable() {
    if (window.pdp.currentProduct?.product_type !== 'Prescription') return
    const lensColor = getRxLensColorHandleFromLensQueryParam()
    if (!lensColor) return

    const style = normalizeLensStyleToAvailable(deriveLensStyleFromColor(lensColor))
    window.pdp._applyingLensFromUrl = true
    if (window.pdp.rx['lens-style'] !== style) {
      setState['lens-style'](style)
      syncLensStyleSelectionUi(style)
      updateLensStyleInfoMessage(style)
      applyLensStyleColorVisibility(style)
    }

    const lcOpt = document.querySelector('#lens-color-panel .dropdown-option[data-value="' + lensColor + '"]')
    if (lcOpt && !lcOpt.classList.contains('hidden') && !lcOpt.classList.contains('lens-style-hidden')) {
      if (normalizeRxOptionHandle(window.pdp.rx['lens-color'] || '') !== lensColor) {
        setState['lens-color'](lensColor)
        lcOpt.click()
      }
    }
    window.pdp._applyingLensFromUrl = false
  }

  function normalizeProductTagsToArray(tags) {
    if (tags == null) return []
    if (Array.isArray(tags)) return tags.map(function (t) { return String(t).trim() }).filter(Boolean)
    if (typeof tags === 'string') {
      return tags.split(',').map(function (t) { return t.trim() }).filter(Boolean)
    }
    return []
  }

  // Catalog tags use short photochromic names (e.g. `_rx_lens_color:photo_black`);
  // map them to the Lens Color option handles the dropdown renders.
  const RX_LENS_COLOR_TAG_ALIASES = {
    'photo-black': 'photochromic-gray',
    'photo-gray': 'photochromic-gray',
    'photo-grey': 'photochromic-gray',
    'photochromic-black': 'photochromic-gray',
    'photochromic-grey': 'photochromic-gray',
    'photo-brown': 'photochromic-brown'
  }

  function parseRxLensColorTagHandlesFromProduct(product) {
    const set = new Set()
    const tags = normalizeProductTagsToArray(product?.tags)
    for (let i = 0; i < tags.length; i++) {
      const tag = tags[i]
      if (typeof tag !== 'string' || tag.indexOf('_rx_lens_color:') === -1) continue
      const raw = tag.split('_rx_lens_color:').pop()
      const h = normalizeRxOptionHandle(raw)
      if (h) set.add(RX_LENS_COLOR_TAG_ALIASES[h] || h)
    }
    return set
  }

  function syncPrescriptionRxLensTagVisibilityFromProduct(product) {
    if (!product || product.product_type !== 'Prescription') return
    const handles = parseRxLensColorTagHandlesFromProduct(product)
    const colorPanel = document.getElementById('lens-color-panel')
    if (colorPanel) {
      RX_LENS_TAG_GATED_LENS_COLORS.forEach(function (handle) {
        const el = colorPanel.querySelector('.dropdown-option[data-value="' + handle + '"]')
        if (!el) return
        if (handles.has(handle)) el.classList.remove('hidden')
        else el.classList.add('hidden')
      })
    }
    const showPhotoStyle = handles.has('photochromic-gray') || handles.has('photochromic-brown')
    const photoStyleEl = document.querySelector('#lens-style-panel .dropdown-option[data-value="photochromic"]')
    if (photoStyleEl) {
      if (showPhotoStyle) photoStyleEl.classList.remove('hidden')
      else photoStyleEl.classList.add('hidden')
    }
    if (!showPhotoStyle && window.pdp.rx['lens-style'] === 'photochromic') {
      setState['lens-style']('basic')
    }
    const urlLens = getRxLensColorHandleFromLensQueryParam()
    const cur = normalizeRxOptionHandle(urlLens || window.pdp.rx['lens-color'] || '')
    const curOpt = document.querySelector('#lens-color-panel .dropdown-option[data-value="' + cur + '"]')
    const curBad = !curOpt || curOpt.classList.contains('hidden')
    if (curBad) {
      for (let i = 0; i < RX_LENS_COLOR_TRY_ORDER.length; i++) {
        const h = RX_LENS_COLOR_TRY_ORDER[i]
        const opt = document.querySelector('#lens-color-panel .dropdown-option[data-value="' + h + '"]')
        if (opt && !opt.classList.contains('hidden')) {
          opt.click()
          break
        }
      }
    }
    applyRxLensColorFromUrlIfApplicable()
  }

  const RX_LENS_STYLE_COLOR_GROUPS = {
    basic: ['clear', 'black', 'brown', 'yellow'],
    mirrored: ['coastal-blue', 'purple-pastel', 'green-vibrant', 'rose-pink', 'silver'],
    photochromic: ['photochromic-gray', 'photochromic-brown']
  }

  function deriveLensStyleFromColor(color) {
    const normalizedColor = normalizeRxOptionHandle(color || '')
    if (RX_LENS_STYLE_COLOR_GROUPS.basic.includes(normalizedColor)) return 'basic'
    if (RX_LENS_STYLE_COLOR_GROUPS.mirrored.includes(normalizedColor)) return 'mirrored'
    if (RX_LENS_STYLE_COLOR_GROUPS.photochromic.includes(normalizedColor)) return 'photochromic'
    return 'basic'
  }

  function getAvailableLensStylesFromDom() {
    return Array.from(document.querySelectorAll('#lens-style-panel .dropdown-option[data-value]'))
      .filter(el => !el.classList.contains('hidden'))
      .map(el => el.getAttribute('data-value'))
      .filter(Boolean)
  }

  function normalizeLensStyleToAvailable(style) {
    const available = getAvailableLensStylesFromDom()
    if (!available.length) return style || 'basic'
    const s = style || 'basic'
    if (available.includes(s)) return s
    if (available.includes('basic')) return 'basic'
    return available[0]
  }

  function syncLensStyleSelectionUi(style) {
    const options = document.querySelectorAll('#lens-style-panel .dropdown-option[data-value]')
    let selectedOption = null
    options.forEach(option => {
      const isSelected = option.getAttribute('data-value') === style
      option.classList.toggle('selected', isSelected)
      if (isSelected) selectedOption = option
    })

    const lensStyleDropdown = document.querySelector('.dropdown.lens-style')
    const lensStyleBadge = lensStyleDropdown ? lensStyleDropdown.querySelector('.dropdown-badge') : null
    if (lensStyleBadge && selectedOption) {
      lensStyleBadge.textContent = selectedOption.getAttribute('data-badge') || ''
    }
  }

  function applyLensStyleColorVisibility(style) {
    // Config modal shows every available color in one flat image grid
    if (usesRxConfigModal()) {
      document.querySelectorAll('#lens-color-panel .dropdown-option[data-value]').forEach(option => {
        option.classList.remove('lens-style-hidden')
      })
      if (typeof window.syncRxLensColorProductImages === 'function') {
        window.syncRxLensColorProductImages()
      }
      return [].concat(
        RX_LENS_STYLE_COLOR_GROUPS.basic,
        RX_LENS_STYLE_COLOR_GROUPS.mirrored,
        RX_LENS_STYLE_COLOR_GROUPS.photochromic
      )
    }
    const allowed = RX_LENS_STYLE_COLOR_GROUPS[style] || RX_LENS_STYLE_COLOR_GROUPS.basic
    const options = document.querySelectorAll('#lens-color-panel .dropdown-option[data-value]')
    options.forEach(option => {
      option.classList.toggle('lens-style-hidden', !allowed.includes(option.getAttribute('data-value')))
    })
    return allowed
  }

  function enforceValidLensColorForStyle(style) {
    const allowed = applyLensStyleColorVisibility(style)
    const selectedColor = normalizeRxOptionHandle(window.pdp.rx['lens-color'] || '')
    const selectedOpt = selectedColor
      ? document.querySelector('#lens-color-panel .dropdown-option[data-value="' + selectedColor + '"]')
      : null
    const ok = allowed.includes(selectedColor) && selectedOpt && !selectedOpt.classList.contains('hidden')
    if (ok) return
    for (let i = 0; i < allowed.length; i++) {
      const h = allowed[i]
      const opt = document.querySelector('#lens-color-panel .dropdown-option[data-value="' + h + '"]')
      if (opt && !opt.classList.contains('hidden')) {
        opt.click()
        return
      }
    }
  }

  function updateLensStyleInfoMessage(style) {
    const color = window.pdp?.rx?.['lens-color']
    const lensStyle = style || (color ? deriveLensStyleFromColor(color) : 'basic')
    let copy = 'Evenly tinted lenses for a classic, solid color look.'
    if (lensStyle === 'mirrored') {
      copy = 'Reflective coating layered over a brown base.'
    } else if (lensStyle === 'photochromic') {
      copy = 'Clear indoors, darkens in sunlight to adapt to changing light conditions.'
    }
    const styleMessage = document.getElementById('lens-style-info-message')
    if (styleMessage) styleMessage.textContent = copy

    const modalEl = document.getElementById('rx-config-modal')
    const noteEl = document.getElementById('rx-config-preview-color-note')
    if (noteEl) {
      const onColorStep = modalEl && modalEl.getAttribute('data-step') === 'lens-color'
      if (onColorStep && color) {
        noteEl.textContent = copy
        noteEl.hidden = false
      } else {
        noteEl.hidden = true
      }
    }
  }
  window.updateLensStyleInfoMessage = updateLensStyleInfoMessage

  function initLensStyleForPrescription() {
    if (window.pdp.currentProduct?.product_type !== 'Prescription') return
    const urlLensColor = getRxLensColorHandleFromLensQueryParam()
    const style = resolveInitialLensStyleForPrescription()
    window.pdp.rx['lens-style'] = style
    syncLensStyleSelectionUi(style)
    updateLensStyleInfoMessage(style)
    applyLensStyleColorVisibility(style)
    if (urlLensColor) {
      applyRxLensColorFromUrlIfApplicable()
    } else {
      enforceValidLensColorForStyle(style)
    }
  }

  document.addEventListener('state:change:lens-color', (event) => {
    if (
      !window.pdp._applyingLensFromUrl &&
      window.pdp.currentProduct?.product_type === 'Prescription'
    ) {
      clearRxLensQueryParamFromUrl()
    }
    syncGlassonTryOnLenColorIdFromRxState()
    updateLensUpgradeAvailability()
    updateLensUpgradePricing()
    updatePhotochromicLensColorLabels()
    findSelectedVariant()
    changeSliderImages()
    syncRxConfigModalGallery()
    if (typeof window.syncRxLensColorProductImages === 'function') {
      window.syncRxLensColorProductImages()
    }
    updateATCText()
    if (event.detail.value) {
      if (usesRxConfigModal()) {
        keepRxConfigOptionPanelsOpen()
      } else {
        const lensTypeDropdown = document.querySelector(`.dropdown.lens-type`)
        if (lensTypeDropdown) {
          lensTypeDropdown.querySelector('.dropdown-panel').classList.remove('disabled')
        }
      }
      if (window.pdp.currentProduct?.product_type === 'Prescription') {
        const style = normalizeLensStyleToAvailable(deriveLensStyleFromColor(event.detail.value))
        if (window.pdp.rx['lens-style'] !== style) {
          window.pdp.rx['lens-style'] = style
          syncLensStyleSelectionUi(style)
          applyLensStyleColorVisibility(style)
        }
        updateLensStyleInfoMessage(style)
      }
    } else if (window.pdp.currentProduct?.product_type === 'Prescription') {
      updateLensStyleInfoMessage()
    }
  })

  document.addEventListener('state:change:lens-style', (event) => {
    if (window.pdp.currentProduct?.product_type !== 'Prescription') return
    const style = event.detail.value || 'basic'
    syncLensStyleSelectionUi(style)
    updateLensStyleInfoMessage(style)
    if (!window.pdp._applyingLensFromUrl) {
      enforceValidLensColorForStyle(style)
    }
    if (usesRxConfigModal()) {
      keepRxConfigOptionPanelsOpen()
    } else {
      const lensColorDropdown = document.querySelector(`.dropdown.lens-color`)
      if (lensColorDropdown) {
        lensColorDropdown.querySelector('.dropdown-panel').classList.remove('disabled')
      }
    }
  })

  document.addEventListener('state:change:lens-type', (event) => {
    updateLensUpgradeAvailability()
    updateLensUpgradePricing()
    updatePhotochromicLensColorLabels()
    findSelectedVariant()
    updateATCText()
    if (event.detail.value) {
      if (usesRxConfigModal()) {
        keepRxConfigOptionPanelsOpen()
      } else {
        const lensUpgradeDropdown = document.querySelector(`.dropdown.lens-upgrade`)
        if (lensUpgradeDropdown) {
          lensUpgradeDropdown.querySelector('.dropdown-panel').classList.remove('disabled')
        }
        const lensTypeDropdown = document.querySelector(`.dropdown.lens-type`)
        if (lensTypeDropdown) {
          lensTypeDropdown.querySelector('.dropdown-panel').classList.add('disabled')
        }
        const lensColorDropdown = document.querySelector(`.dropdown.lens-color`)
        if (lensColorDropdown) {
          lensColorDropdown.querySelector('.dropdown-panel').classList.add('disabled')
        }
        const lensStyleDropdown = document.querySelector(`.dropdown.lens-style`)
        if (lensStyleDropdown) {
          lensStyleDropdown.querySelector('.dropdown-panel').classList.add('disabled')
        }
        const ophTypeDropdown = document.querySelector(`.dropdown.oph-type`)
        if (ophTypeDropdown) {
          ophTypeDropdown.querySelector('.dropdown-panel').classList.add('disabled')
        }
      }
      // Keep frame / other-products selector open while configuring lenses in the modal
      const otherProductsContainer = document.querySelector(`.product__information_block.other-products`)
      if (otherProductsContainer) {
        otherProductsContainer.classList.remove('disabled')
        otherProductsContainer.querySelectorAll('.other-products-container').forEach(container => {
          container.classList.remove('disabled')
        })
      }
    }
  })

  document.addEventListener('state:change:oph-type', (event) => {
    changeSliderImages()
    updateLensTypeAvailability()
    updateLensUpgradeAvailability()
    updateLensUpgradePricing()
    findSelectedVariant()
    updateATCText()

    // hide prescription submit note for readers
    const summaryNote = document.querySelector('.rx-config-modal__summary-board-note')
    if (summaryNote) {
      summaryNote.classList.toggle('hidden', event.detail.value === 'readers')
    }

    // update b1g2f wrapper text — plain/blue-light are B1G2F; Rx types stay 30% off
    if (event.detail.value === 'blue-light' || event.detail.value === 'plain') {
      setSepDesignB1g2fContent('Sunglasses')
    } else {
      setSepDesignB1g2fContent('Prescription')
    }

    // update dropdowns
    if (event.detail.value) {
      if (usesRxConfigModal()) {
        keepRxConfigOptionPanelsOpen()
      } else {
        const lensTypeDropdown = document.querySelector(`.dropdown.lens-type`)
        if (lensTypeDropdown) {
          lensTypeDropdown.querySelector('.dropdown-panel').classList.remove('disabled')
        }
        const ophTypeDropdown = document.querySelector(`.dropdown.oph-type`)
        if (ophTypeDropdown) {
          ophTypeDropdown.querySelector('.dropdown-panel').classList.add('disabled')
        }
      }
    }
  })

  document.addEventListener('state:change:lens-upgrade', (event) => {
    updatePhotochromicLensColorLabels()
    findSelectedVariant()
    updateATCText()
    setTimeout(() => {
      updateATCText()
    }, 1000)
  })

  function getCachedVariantPriceHtml(variantId) {
    const c = window.pdp.variantPriceHtmls
    if (!c || variantId == null) return null
    return c[variantId] != null ? c[variantId] : c[String(variantId)]
  }

  function buildSepDesignRxPriceBlockHtml(variant, productType) {
    if (!variant) return null
    const pt = productType || window.pdp.currentProduct?.product_type
    const price = coerceVariantPriceDollars(variant.price)
    if (isNaN(price)) return null
    const cents = Math.round(price * 100)
    const moneyFormat = document.body.getAttribute('data-money-format') || (typeof Shopify !== 'undefined' && Shopify.money_format) || (window.SEP_DESIGN_PDP.moneyFormat || '')
    function fmtCents(c) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoneyOrigin === 'function') {
        return Shopify.formatMoneyOrigin(String(Math.round(c)), moneyFormat)
      }
      return '$' + (c / 100).toFixed(2)
    }
    if (isSepOfferProductType(pt)) {
      const discCents = Math.round(price * 0.7 * 100)
      return (
        '<div class="price-block price">' + fmtCents(discCents) + '</div>' +
        '<div class="price-block compare-at-price">' + fmtCents(cents) + '</div>' +
        '<div class="price-block discount-badge">SAVE 30%</div>'
      )
    }
    const compareAt = coerceVariantPriceDollars(variant.compare_at_price)
    let html = '<div class="price-block price">' + fmtCents(cents) + '</div>'
    if (!isNaN(compareAt) && compareAt > price) {
      html += '<div class="price-block compare-at-price">' + fmtCents(Math.round(compareAt * 100)) + '</div>'
    }
    return html
  }

  function applyPriceBlockForVariant(variant) {
    if (!variant) return
    const pt = window.pdp.currentProduct?.product_type
    let html = isSepOfferProductType(pt)
      ? buildSepDesignRxPriceBlockHtml(variant, pt)
      : getCachedVariantPriceHtml(variant.id)
    if (!html) html = buildSepDesignRxPriceBlockHtml(variant, pt)
    if (html) {
      if (!window.pdp.variantPriceHtmls) window.pdp.variantPriceHtmls = {}
      window.pdp.variantPriceHtmls[variant.id] = html
      const priceBlock = document.querySelector('.product__information > .pdp-lead .product__information_block.price-block')
        || document.querySelector('.product__information .product__information_block.price-block')
      if (priceBlock) priceBlock.innerHTML = html
    }
  }

  // Price of the Rx variant for a lens type, color and upgrade set (same matching as findSelectedVariant).
  function rxVariantPriceDollars(lensType, lensColor, upgrades) {
    const variant = (window.pdp.currentProduct?.variants || []).find(v => {
      if (!v?.option1 || v.option2 == null) return false
      let opt3 = v.option3 == null ? '' : String(v.option3)
      const lower = opt3.toLowerCase()
      if (!(lower.includes('standard') || lower.includes('impact resistant') || lower.includes('high index'))) {
        opt3 = opt3 ? (opt3 + ' + Standard') : 'Standard'
      }
      return v.option1.toLowerCase().split(' ').join('-') === lensType &&
        normalizeRxOptionHandle(v.option2) === lensColor &&
        haveSameElements(opt3.split(' + ').map(o => o.toLowerCase().split(' ').join('-')), upgrades)
    })
    if (!variant) return NaN
    const price = coerceVariantPriceDollars(variant.price)
    return price > 0 ? price : NaN
  }

  // Photochromic upcharge over clear for the shopper's lens type and upgrades, from variant prices.
  // Falls back to the Standard lens, then to the list prices if the variants aren't loaded.
  function photochromicUpchargeLabel(handle) {
    const lt = window.pdp.rx['lens-type']
    const upgrades = Object.keys(window.pdp.rx['lens-upgrade'] || {}).filter(k => window.pdp.rx['lens-upgrade'][k])
    const sets = [upgrades, ['standard']]
    for (let i = 0; i < sets.length; i++) {
      const diff = rxVariantPriceDollars(lt, handle, sets[i]) - rxVariantPriceDollars(lt, 'clear', sets[i])
      if (!isNaN(diff)) return diff > 0 ? '+$' + Math.round(diff) : 'FREE'
    }
    return '+$75'
  }

  function updatePhotochromicLensColorLabels() {
    if (window.pdp.currentProduct?.product_type !== 'Prescription') return
    ;['photochromic-gray', 'photochromic-brown'].forEach(function (handle) {
      const el = document.querySelector('#lens-color-panel .dropdown-option[data-value="' + handle + '"] .dropdown-text')
      if (!el) return
      // The Rx modal splits the text into name + price spans; only replace the price
      const priceEl = el.querySelector('.rxc-lens-color-price')
      if (priceEl) priceEl.textContent = photochromicUpchargeLabel(handle)
      else el.textContent = photochromicUpchargeLabel(handle)
    })
  }

  document.addEventListener('state:change:selectedVariant', (event) => {
    // change variant price
    const value = event.detail.value
    const bisBlock = document.querySelector('.product__information_block.bis')
    if (value) {
      const variantPrice = getCachedVariantPriceHtml(value.id)
      if (!variantPrice) {
        const handle = window.pdp.currentProduct?.handle || location.pathname.split('/').pop()
        if (sepStorefrontEnabled()) {
          populateVariantPricesFromStorefront(handle).then(() => {
            applyPriceBlockForVariant(value)
          })
        } else {
          fetchSectionHtml(`/products/${handle}?section_id=sep-pdp-varprices`)
            .then(data => {
              const div = new DOMParser().parseFromString(data, 'text/html')
              const variantPriceSection = div.querySelector('#shopify-section-sep-pdp-varprices')
              if (variantPriceSection) {
                variantPriceSection.querySelectorAll('.variant-price').forEach(variantPriceElement => {
                  const variantId = variantPriceElement.getAttribute('data-variant-id')
                  if (variantId) {
                    window.pdp.variantPriceHtmls[variantId] = variantPriceElement.innerHTML
                  }
                })
              }
              applyPriceBlockForVariant(value)
            })
        }
      }
      applyPriceBlockForVariant(value)
    } else {
    }

    // change atc button text
    updateATCText(value)

    if (window.pdp.currentProduct?.product_type === 'Safety') {
      syncSafetyLensTypeButtons(value)
      updateSafetyTrioBadge(value)
      paintSafetyAtcTotal()
    }

    syncGalleryToSelectedVariant(value)

    // change url param
    if (window.pdp.lock.variantParam) {
      return
    }
    if (value) {
      const url = new URL(window.location)
      url.searchParams.set('variant', value.id)
      if (window.pdp.currentProduct?.product_type === 'Safety') {
        url.searchParams.delete('safety-lens')
      }
      window.history.replaceState({}, '', url)
    } else {
      const url = new URL(window.location)
      url.searchParams.delete('variant')
      window.history.replaceState({}, '', url)
    }
  })

  document.addEventListener('state:change:variant-id', (event) => {
    const value = event.detail.value
    if (value) {
      const variant = window.pdp.currentProduct.variants.find(v => v.id === +value) || null
      if (variant) {
        setState['selectedVariant'](variant)
      } else {
        setState['selectedVariant'](null)
      }
    }
  })

  function toTitleCase(str) {
    return str.split(' ').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ');
  }

  function renderWishlistButton() {
    const atcs = document.querySelectorAll('.product__information_block.atc')
    atcs.forEach((atc) => {
      const productId = atc.getAttribute('product_id')
      atc.setAttribute('data-product-id', productId)

      // Monitor to check if WishlistKing is available
      const wishlistCheckInterval = setInterval(() => {
        if (typeof WishlistKing !== 'undefined' && WishlistKing.observe) {
          clearInterval(wishlistCheckInterval);
          
          WishlistKing.observe(
            {
              selector: `.product__information_block.atc[data-product-id]`,
            },
            (target) => {
              target.container.querySelector('.to-be-removed')?.remove()
              target.append(
                WishlistKing.createComponent("wishlist-button-floating-pdp", {
                  id: target.container.getAttribute("data-product-id"),
                })
              );
            }
          );

          window.pdp.wishlistButtonInited = true
        }
      }, 100);

      // Stop checking after 10 seconds
      setTimeout(() => {
        clearInterval(wishlistCheckInterval);
      }, 10000);
    })
  }

  function visibleFitGuideZoomLink() {
    const root = document.getElementById('frame-details-fit-guide')
    if (!root) return null
    return Array.from(root.querySelectorAll('a.fit-guide-zoom')).find((a) => {
      const cs = window.getComputedStyle(a)
      return cs.display !== 'none' && cs.visibility !== 'hidden'
    }) || null
  }

  function retargetPdpSizeFitLinks() {
    document.querySelectorAll('.pdp-size-selector__help a').forEach((a) => {
      a.removeAttribute('data-safety-open')
      a.removeAttribute('data-pdp-open-fit-guide')
      a.setAttribute('data-pdp-open-fit-modal', '')
      a.setAttribute('href', '#pdp-fit-modal')
    })
  }

  function openPdpFitModal(event) {
    if (event) event.preventDefault()
    if (typeof closeSafetyModals === 'function') closeSafetyModals()
    if (window.pdp.fitFamilyPainted) paintPdpFitModal()
    openSafetyModal('pdp-fit-modal')
    return true
  }

  retargetPdpSizeFitLinks()
  hoistNestedMainSliders()

  // adding event listeners to additional blocks
  document.body.addEventListener('click', (event) => {
    const target = event.target
    // product additional information block headers
    if (target.closest('.additional-block-header')) {
      const additionalBlock = target.closest('.additional-block')
      if (additionalBlock) {
        additionalBlock.classList.toggle('active')
      }
    }

    const fitLink = target.closest('.pdp-size-selector__help a, [data-pdp-open-fit-modal]')
    if (fitLink) {
      openPdpFitModal(event)
      return
    }

    // rx toggles
    if (target.closest('.rx-toggle-lab-link')) return
    if (target.closest('[data-pdp-switch-handle]')) {
      const el = target.closest('[data-pdp-switch-handle]')
      const handle = el.getAttribute('data-pdp-switch-handle')
      if (el.tagName === 'A' && el.getAttribute('href')) return
      if (handle) {
        event.preventDefault()
        switchPdpSafetySunProduct(handle)
      }
      return
    }
    if (target.closest('.rx-toggle-action')) {
      const rxToggle = target.closest('.rx-toggle')
      if (!rxToggle || rxToggle.classList.contains('is-busy') || isPdpProductSwitchBusy()) return
      if (rxToggle.classList.contains('rx')) {
        if (!beginPdpProductSwitch('rx', 'sunglasses')) return
        updateRxToggleUI(false)
        setState['currentProductType']('sunglasses')
        placeRxToggleForProductType('Sunglasses')
        closeRxConfigModal()
      } else {
        if (!beginPdpProductSwitch('rx', 'prescription')) return
        updateRxToggleUI(true)
        window.pdp._scrollTopAfterRxLoad = true
        setState['currentProductType']('prescription')
        placeRxToggleForProductType('Prescription')
      }
    }

    // atc buttons
    if (target.closest('.atc')) {
      if (target.classList.contains('wk-button') || target.closest('.wk-button')) {
        return
      }

      const atcRoot = target.closest('.atc')
      const isConfigStickyAtc = atcRoot.classList.contains('rx-config-modal__atc')

      // Sold-out Z87 lens: main or mobile sticky ATC opens the notify modal
      if (!isConfigStickyAtc && getMainAtcButton()?.classList.contains('atc-button--notify')) {
        // After a colour-slider switch the reused rows only learn "in stock" (Storefront omits qty
        // and draft SKUs report unavailable), so the selected row can still look in stock while
        // the ATC already says sold out. Let the row catch up so it shows Notify me too.
        const soldRow = visibleSafetyLensRows().find(
          (r) => r.getAttribute('data-variant-id') === String(window.pdp.selectedVariant?.id)
        )
        if (soldRow && soldRow.dataset.available !== 'false') {
          soldRow.dataset.available = 'false'
          soldRow.classList.add('is-sold-out')
          const sub = soldRow.querySelector('[data-lens-sub]')
          if (sub) sub.innerHTML = safetyLensSoldOutSub()
          paintSafetyLensNotify()
        }
        openNotifyMeModal()
        return
      }

      // Main PDP ATC on Prescription / Ophthalmic only opens configurator
      if (!isConfigStickyAtc && usesRxConfigModal()) {
        const button = atcRoot.querySelector('.atc-button')
        if (!button || button.classList.contains('disabled')) return
        // A sold-out Safety product renders SOLD OUT without the .disabled class, so guard on stock
        if (
          window.pdp.currentProduct?.product_type === 'Safety' &&
          !(window.pdp.currentProduct?.variants || []).some((v) => v.available)
        ) {
          return
        }
        openRxConfigModal()
        return
      }

      const button = atcRoot.querySelector('.atc-button')
      if (!button) return
      if (button.classList.contains('disabled')) return
      button.innerHTML = '<div class="spinning_circle"></div>'
      button.classList.add('disabled')
      
      let properties = null

      try {
        if (
          window.pdp.currentProduct.product_type === 'Prescription' ||
          (window.pdp.currentProduct.product_type === 'Ophthalmic' && (window.pdp.selectedVariant?.title.includes('Prescription') || window.pdp.selectedVariant?.title.includes('Readers')))
        ) {
          const frameTag = normalizeProductTags(window.pdp.currentProduct.tags).find(tag => tag.includes('_frame_name:'))
          const frameColorTag = frameTag ? frameTag.split(':').slice(1).join(':').trim() : ''
          
          if (window.pdp.currentProduct.product_type === 'Prescription') {
            properties = {
              _frame_color: toTitleCase(frameColorTag),
              _prescription_type: window.pdp.selectedVariant?.option1,
              _lens_color: window.pdp.selectedVariant?.option2,
              _lens_upgrades: window.pdp.selectedVariant?.option3,
              _SKU: window.pdp.selectedVariant?.sku,
              _range: '-5:6',
              _barcode: window.pdp.selectedVariant?.barcode,
              _choice: 'SUBMIT LATER',
              _collection: window.pdp.mainCollection
            }
          } else {
            properties = {
              _frame_color: toTitleCase(frameColorTag),
              _prescription_type: window.pdp.selectedVariant?.option2,
              _lens_color: 'Clear',
              _lens_upgrades: window.pdp.selectedVariant?.option3,
              _SKU: window.pdp.selectedVariant?.sku,
              _range: '-5:6',
              ...(window.pdp.selectedVariant?.title.includes('Prescription') ? { _choice: 'SUBMIT LATER' } : {}),
              _barcode: window.pdp.selectedVariant?.barcode,
              _collection: window.pdp.mainCollection
            }
          }
          if (window.pdp.rxConfigLineProperties && typeof window.pdp.rxConfigLineProperties === 'object') {
            properties = Object.assign({}, properties, window.pdp.rxConfigLineProperties)
          }
        }
      } catch (err) {
        console.error('[rx atc] properties failed', err)
        button.classList.remove('disabled')
        if (isConfigStickyAtc && typeof window.clearRxConfigAtcLoading === 'function') {
          window.clearRxConfigAtcLoading('Add to cart')
        }
        updateATCText()
        return
      }

      const restoreAtcLabel = () => {
        const atcButton = atcRoot.querySelector('.atc-button')
        if (atcButton) atcButton.classList.remove('is-added')
        if (atcButton && atcRoot.id === 'pdp-sticky-atc') {
          // The sticky button carries the label only; the next sync copies it from the buy box
          atcButton.textContent = ''
          atcButton.classList.remove('disabled')
          if (typeof window.syncPdpMobileStickyAtc === 'function') window.syncPdpMobileStickyAtc()
        } else if (atcButton) {
          atcButton.innerHTML = getAddToCartButtonText(window.pdp.selectedVariant, {
            applyRxDiscount: isConfigStickyAtc,
            hidePrice: !isConfigStickyAtc && usesRxConfigModal()
          })
          atcButton.classList.remove('disabled')
        }
        if (isConfigStickyAtc && typeof window.clearRxConfigAtcLoading === 'function') {
          window.clearRxConfigAtcLoading('Add to cart')
        }
        updateATCText()
      }

      const onAddSuccess = (res) => {
        const atcButton = atcRoot.querySelector('.atc-button')
        if (atcButton) {
          atcButton.innerHTML = "ADDED"
          atcButton.classList.add('disabled')
          // Sticky bar: "Added ✓" on dark for the 2s before restoreAtcLabel
          if (atcRoot.id === 'pdp-sticky-atc') {
            atcButton.textContent = 'ADDED ✓'
            atcButton.classList.add('is-added')
          }
        }
        if (isConfigStickyAtc) {
          const continueBtn = document.getElementById('rx-config-continue')
          if (continueBtn) {
            continueBtn.dataset.loading = '0'
            continueBtn.disabled = true
            continueBtn.textContent = 'ADDED'
          }
        }
        $('#shopify-section-cart-drawer .section_holder').html($(res.sections['cart-drawer']).find('.section_holder').html());
        const bubble = new DOMParser().parseFromString(res.sections['header-classic'], 'text/html').querySelector('.header-cart__count').innerHTML;
        document.querySelectorAll('.header-cart__count').forEach((element) => {
          element.innerHTML = bubble;
          if (+bubble > 0) {
            $(element).show();
          } else {
            $(element).hide();
          }
        });
        closeRxConfigModal()
        open_slider_cart();
        window.pdp.rxConfigLineProperties = null
        if (window.pdp.currentProduct?.product_type === 'Safety') {
          resetSafetyShieldsStaging()
        }
        setTimeout(restoreAtcLabel, 2000)
      }

      if (window.pdp.editMode) {
        fetch('/cart/update.js', {
          body: JSON.stringify({
            updates: {
              [window.pdp.editVariant.id]: 0
            }
          }),
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'POST'
        })
        .then(res => res.json())
        .then(res => {
          const editItem = {
            'id': window.pdp.selectedVariant?.id,
            'quantity': window.pdp.editVariant.qty,
            ...(properties ? { properties } : {})
          }
          const editItems =
            window.pdp.currentProduct?.product_type === 'Safety'
              ? buildSafetyCartItems(editItem)
              : [editItem]
          fetch('/cart/add.js', {
            body: JSON.stringify({
              items: editItems,
              'sections': ['cart-drawer', 'header-classic']
            }),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With':'xmlhttprequest'
            },
            method: 'POST'
          })
          .then(res => res.json())
          .then(onAddSuccess)
          .catch(restoreAtcLabel)
        })
        .catch(restoreAtcLabel)
      } else {
        const addItem = {
          'id': window.pdp.selectedVariant?.id,
          'quantity': 1,
          ...(properties ? { properties } : {})
        }
        const addItems =
          window.pdp.currentProduct?.product_type === 'Safety'
            ? buildSafetyCartItems(addItem)
            : [addItem]
        fetch('/cart/add.js', {
          body: JSON.stringify({
            items: addItems,
            'sections': ['cart-drawer', 'header-classic']
          }),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest'
          },
          method: 'POST'
        })
        .then(res => res.json())
        .then(onAddSuccess)
        .catch(restoreAtcLabel)
      }
    }

    // happy faces grid video item
    if (target.closest('.happy-faces-grid .video-item')) {
      if (target.closest('.happy-faces-grid .video-item').querySelector('.ugc-video').classList.contains('playing')) return
      const allWrappers = document.querySelectorAll('.happy-faces-grid .video-item')
      allWrappers.forEach(wrapper => {
        const video = wrapper.querySelector('.ugc-video')
        const playButton = wrapper.querySelector('.play-button')
        const thumbnail = wrapper.querySelector('.video-thumbnail')
        
        if (video) {
          video.classList.remove('playing')
          video.pause()
        }
        if (playButton) {
          playButton.style.display = 'flex'
        }
        if (thumbnail) {
          thumbnail.style.display = 'block'
        }
      })
      
      const wrap = target.closest('.happy-faces-grid .video-item')
      const video = wrap.querySelector('.ugc-video');
      const thumbnail = wrap.querySelector('.video-thumbnail');
      const playButton = wrap.querySelector('.play-button');
      
      if (video && !video.classList.contains('playing')) {
        video.classList.add('playing');
        video.play();
        if (playButton) playButton.style.display = 'none';
        if (thumbnail) thumbnail.style.display = 'none';
      } else if (video && video.classList.contains('playing')) {
        video.pause();
        video.classList.remove('playing');
        if (playButton) playButton.style.display = 'flex';
        if (thumbnail) thumbnail.style.display = 'block';
      }
    }

    // dropdown label click
    if (target.closest('.dropdown-label')) {
      const wrapper = target.closest('.dropdown-wrapper')
      if (wrapper) {
        const panel = wrapper.querySelector('.dropdown-panel')
        const option = wrapper.querySelector('.dropdown-trigger').getAttribute('data-dropdown')
        console.log('option', option)
        // In Rx config modal, panels stay open — no collapse toggle
        if (usesRxConfigModal()) {
          keepRxConfigOptionPanelsOpen()
          return
        }
        if (window.pdp.currentProduct.product_type === 'Prescription') {
          if (option === 'lens-type' && !window.pdp.rx['lens-color']) return
        }
        if (window.pdp.currentProduct.product_type === 'Ophthalmic') {
          if (option === 'lens-type' && !window.pdp.rx['oph-type']) return
        }
        if (option === 'lens-upgrade' && !window.pdp.rx['lens-color']) return
        if (option === 'lens-upgrade' && !window.pdp.rx['lens-type']) return
        if (panel) {
          panel.classList.toggle('disabled')
        }
      }
    }

    // size selector Standard / XL / XXL (in-place swap, same as rx toggle / color swatches)
    const sizeBtn = target.closest('[data-size-selector] .pdp-size-selector__btn')
    if (sizeBtn) {
      const sizeSelector = sizeBtn.closest('[data-size-selector]')
      if (!sizeSelector || sizeSelector.classList.contains('is-busy') || isPdpProductSwitchBusy()) return
      const size = sizeBtn.dataset.size
      const targetHandle =
        size === 'xxl'
          ? sizeSelector.dataset.xxlHandle
          : size === 'xl'
            ? sizeSelector.dataset.xlHandle
            : sizeSelector.dataset.stdHandle
      if (!targetHandle || targetHandle === window.pdp.currentProduct?.handle) return
      switchPdpSizeProduct(targetHandle)
    }

    const lensTypeBtn =
      target.closest('[data-lens-type-selector] .nvz-lens__row') ||
      target.closest('[data-lens-type-selector] .pdp-lens-type-selector__btn')
    if (lensTypeBtn && window.pdp.currentProduct?.product_type === 'Safety') {
      const variantId = lensTypeBtn.dataset.variantId
      if (!variantId) return
      if (lensTypeBtn.dataset.option) window.pdp.safetyLensType = lensTypeBtn.dataset.option
      const picked = (window.pdp.currentProduct.variants || []).find((v) => String(v.id) === String(variantId))
      setState['variant-id'](variantId)
      syncSafetyLensTypeButtons(picked)
      writeSafetyVariantToUrl(picked)
      updateSafetyTrioBadge(picked)
      paintSafetyAtcTotal()
      changeSliderImages()
      // Sold-out lens: selecting it turns the ATC into Notify me; its row button opens the
      // back-in-stock modal (email or SMS) for that lens.
      if (lensTypeBtn.dataset.available === 'false' && usesNotifyMeModal()) openNotifyMeModal()
    }

    const safetyLensOption = target.closest('[data-safety-lens-type-panel] .dropdown-option')
    if (safetyLensOption && window.pdp.currentProduct?.product_type === 'Safety') {
      if (safetyLensOption.getAttribute('data-unavailable') === 'true') return
      const variantId = safetyLensOption.getAttribute('data-variant-id')
      if (!variantId) return
      window.pdp.safetyLensType = safetyLensOption.getAttribute('data-badge') || ''
      const picked = (window.pdp.currentProduct.variants || []).find((v) => String(v.id) === String(variantId))
      setState['variant-id'](variantId)
      writeSafetyVariantToUrl(picked)
      syncSafetyModalLensTypeSelection(picked)
      updateSafetyTrioBadge(picked)
      paintSafetyAtcTotal()
      changeSliderImages()
      syncRxConfigModalGallery()
    }

    // Notify modal: "In stock now" lens → close and select that lens
    const notifyAlt = target.closest('[data-notify-alt]')
    if (notifyAlt) {
      const id = notifyAlt.getAttribute('data-notify-alt')
      closeSafetyModals()
      visibleSafetyLensRows().find((r) => r.getAttribute('data-variant-id') === id)?.click()
      return
    }

    // Safety: which-lens modal + shield expander
    const safetyOpen = target.closest('[data-safety-open]')
    if (safetyOpen) {
      event.preventDefault()
      openSafetyModal(safetyOpen.getAttribute('data-safety-open'))
      return
    }
    if (target.closest('[data-safety-close], [data-pdp-fit-close]')) {
      closeSafetyModals()
      return
    }
    const shieldToggle = target.closest('[data-safety-shield-toggle]')
    if (shieldToggle) {
      const root =
        shieldToggle.closest('.other-products-container') ||
        document.querySelector('.other-products-container:not(.hidden)')
      const wrap =
        root?.querySelector('[data-safety-shield-wrap]') ||
        document.querySelector('[data-safety-shield-wrap]')
      if (!wrap) return
      const open = wrap.hasAttribute('hidden')
      if (open) {
        wrap.removeAttribute('hidden')
        renderSafetyShields()
        paintSafetyShieldSummary()
      } else {
        wrap.setAttribute('hidden', '')
      }
      shieldToggle.setAttribute('aria-expanded', open ? 'true' : 'false')
      return
    }
  })

  function handleMainSliderPosition(explicitHandle) {
    const handle =
      (typeof explicitHandle === 'string' && explicitHandle) ||
      window.pdp._activeMainSliderHandle ||
      window.pdp.currentProductHandle ||
      window.pdp.currentProduct?.handle
    if (!handle) return

    const currentScreenWidth = window.innerWidth
    const wasMobile = window.pdp.mainSliderPosition.previousScreenWidth < 798
    const isMobile = currentScreenWidth < 798
    const force = typeof explicitHandle === 'string' || window.pdp.mainSliderPosition.isFirstLoad

    // Only proceed if crossing the 798px threshold, unless forced (product switch / first load)
    if (!force && wasMobile === isMobile) {
      window.pdp.mainSliderPosition.previousScreenWidth = currentScreenWidth
      return
    }

    // Ignore stale reposition for a gallery that is no longer active
    if (
      window.pdp._activeMainSliderHandle &&
      window.pdp._activeMainSliderHandle !== handle &&
      explicitHandle == null
    ) {
      window.pdp.mainSliderPosition.previousScreenWidth = currentScreenWidth
      return
    }

    // Check if swiper exists for handle (may not exist yet when toggling)
    if (
      !window.pdp.swipers ||
      !window.pdp.swipers[handle] ||
      !window.pdp.swipers[handle].swiper ||
      !window.pdp.swipers[handle].thumbSwiper
    ) {
      window.pdp.mainSliderPosition.previousScreenWidth = currentScreenWidth
      return
    }

    const mainSliderWrapper = window.pdp.swipers[handle].swiper.el.closest('.mainslider-wrapper')
    const productMain = document.querySelector('.product__main')
    const mainslider =
      getMainSliderRootForHandle(handle) ||
      window.pdp.swipers[handle].thumbSwiper.el.closest('.product__sep-design__mainSlider')

    if (!mainSliderWrapper || !productMain || !mainslider) {
      window.pdp.mainSliderPosition.previousScreenWidth = currentScreenWidth
      return
    }

    // Never sticky-move a hidden gallery
    if (mainslider.classList.contains('hidden')) {
      restoreMainSliderWrapperIntoRoot(handle, mainslider)
      window.pdp.mainSliderPosition.previousScreenWidth = currentScreenWidth
      return
    }

    if (isMobile) {
      // Hoist gallery above info for mobile layout, but do not pin sticky on scroll.
      // Put every other Fits/size wrapper back first or two galleries stack.
      restoreAllHoistedMainSliderWrappers(handle)
      if (mainSliderWrapper.parentNode !== productMain) {
        productMain.insertBefore(mainSliderWrapper, productMain.firstChild)
      }
      mainSliderWrapper.classList.remove('hidden', 'sticky', 'floating')
      removeOrphanedMainSliderWrappers(mainSliderWrapper)
      if (typeof updatePriceBlockStickyTop === 'function') updatePriceBlockStickyTop()
    } else {
      // Return to original place and remove styles
      restoreMainSliderWrapperIntoRoot(handle, mainslider)
      removeOrphanedMainSliderWrappers(null)
    }

    // Update flags and previous screen width
    window.pdp.mainSliderPosition.isFirstLoad = false
    window.pdp.mainSliderPosition.previousScreenWidth = currentScreenWidth
  }

  let priceBlockStickyRo = null
  let priceBlockStickyObservedEl = null

  function teardownPriceBlockStickyObserver() {
    if (priceBlockStickyRo) {
      priceBlockStickyRo.disconnect()
      priceBlockStickyRo = null
      priceBlockStickyObservedEl = null
    }
  }

  function ensurePriceBlockStickyObserver(el) {
    if (typeof ResizeObserver === 'undefined') return
    if (el === priceBlockStickyObservedEl && priceBlockStickyRo) return
    teardownPriceBlockStickyObserver()
    if (!el) return
    priceBlockStickyRo = new ResizeObserver(() => updatePriceBlockStickyTop())
    priceBlockStickyObservedEl = el
    priceBlockStickyRo.observe(el)
  }

  // Mobile: border only while position:sticky is actively pinned (matches resolved `top`)
  function updatePriceBlockStuckState() {
    const el = document.querySelector('.product__information > .pdp-lead .product__information_block.price-block')
      || document.querySelector('.product__information .product__information_block.price-block')
    if (!el) return
    if (window.innerWidth >= 798) {
      el.classList.remove('is-stuck')
      return
    }
    if (getComputedStyle(el).position !== 'sticky') {
      el.classList.remove('is-stuck')
      return
    }
    const stickyTop = parseFloat(getComputedStyle(el).top)
    if (!Number.isFinite(stickyTop)) {
      el.classList.remove('is-stuck')
      return
    }
    const rect = el.getBoundingClientRect()
    const tol = 3
    const isStuck = rect.top <= stickyTop + tol && rect.top >= stickyTop - tol
    el.classList.toggle('is-stuck', isStuck)
  }

  // Mobile: sticky price row sits below header (93px) + visible sticky mainslider height (.floating changes box size)
  function updatePriceBlockStickyTop() {
    const productMain = document.querySelector('.product__main')
    if (!productMain) {
      updatePriceBlockStuckState()
      return
    }
    if (window.innerWidth >= 798) {
      productMain.style.removeProperty('--pdp-sticky-slider-height')
      teardownPriceBlockStickyObserver()
      updatePriceBlockStuckState()
      return
    }
    const slider = document.querySelector('.product__main .mainslider-wrapper.sticky')
    if (!slider) {
      productMain.style.removeProperty('--pdp-sticky-slider-height')
      teardownPriceBlockStickyObserver()
      updatePriceBlockStuckState()
      return
    }
    productMain.style.setProperty('--pdp-sticky-slider-height', `${slider.offsetHeight}px`)
    ensurePriceBlockStickyObserver(slider)
    updatePriceBlockStuckState()
  }

  function adjustSliderWidth() {
    if (!window.pdp.swipers) return
    Object.keys(window.pdp.swipers).forEach(handle => {
      const entry = window.pdp.swipers[handle]
      if (isOtherProductsSwiperEntry(entry)) return
      const swiper = entry?.swiper
      const thumbSwiper = entry?.thumbSwiper
      const root = getMainSliderRootForHandle(handle)
      // Skip hidden product galleries — measuring display:none zeros Swiper and breaks reveal
      if (root && root.classList.contains('hidden')) return
      let swiperToChange
      if (swiper && !thumbSwiper) {
        swiperToChange = swiper
      } else {
        swiperToChange = thumbSwiper
      }
      if (!swiperToChange?.el || !swiperToChange.slides) return
      const totalSlides = swiperToChange.slides.length
      const slidesPerView = swiperToChange.params.slidesPerView
      if (totalSlides <= slidesPerView) {
        swiperToChange.el.style.width = '100%'
      } else {
        swiperToChange.el.removeAttribute('style')
      }
    })
  }

  // Toggle floating class from scroll position (border styled in CSS)
  function updateStickyBorder() {
    const handle =
      window.pdp._activeMainSliderHandle ||
      window.pdp.currentProductHandle ||
      window.pdp.currentProduct?.handle
    const mainSliderWrapper = handle && swiperClosest(window.pdp.swipers[handle]?.swiper, '.mainslider-wrapper')
    if (!mainSliderWrapper) {
      updatePriceBlockStickyTop()
      return
    }
    
    const isSticky = mainSliderWrapper.classList.contains('sticky')
    if (!isSticky) {
      mainSliderWrapper.classList.remove('floating')
      updatePriceBlockStickyTop()
      return
    }
    
    if (window.pageYOffset > 0) {
      mainSliderWrapper.classList.add('floating')
    } else {
      mainSliderWrapper.classList.remove('floating')
    }
    updatePriceBlockStickyTop()
  }

  // Track previous values to avoid unnecessary updates
  let previousSelectedVariantId = null
  let previousCurrentProductHandle = null
  
  setInterval(() => {
    const currentVariantId = window.pdp.selectedVariant?.id
    const currentProductHandle = window.pdp.currentProduct?.handle
    
    // Early return if nothing changed
    if (currentVariantId === previousSelectedVariantId && 
        currentProductHandle === previousCurrentProductHandle) {
      return
    }
    
    // Update tracked values
    previousSelectedVariantId = currentVariantId
    previousCurrentProductHandle = currentProductHandle
    
    updateATCText()
  }, 100)

  placeRxToggleForProductType(window.SEP_DESIGN_PDP.productType);

  (() => {
    const productInformation = document.querySelector(window.SEP_DESIGN_PDP.sectionRoot + ' .product__information')
    const badges = productInformation?.querySelector(':scope > .product__information_block.badges')
    const title = productInformation?.querySelector(':scope > .product__information_block.title')
    const reviews = productInformation?.querySelector(':scope > .product__information_block.judgeme-badge')
    const price = productInformation?.querySelector(':scope > .product__information_block.price-block')
    if (!productInformation || !title || !reviews || !price) return

    // Seed landing badge so RX/XL round-trips keep correct counts
    const landingHandle = window.SEP_DESIGN_PDP?.productHandle
    if (landingHandle && !hasJudgemeHtmlCache(landingHandle)) {
      if (!window.pdp.judgemeHtmls) window.pdp.judgemeHtmls = {}
      window.pdp.judgemeHtmls[landingHandle] = reviews.innerHTML
    }

    const lead = document.createElement('div')
    lead.className = 'pdp-lead'
    productInformation.insertBefore(lead, badges || title)
    if (badges) lead.append(badges)
    lead.append(title, reviews, price)

    const syncGalleryPdpLead = () => {
      const infoLead = document.querySelector(window.SEP_DESIGN_PDP.sectionRoot + ' .product__information > .pdp-lead')
      if (!infoLead) return
      document.querySelectorAll(window.SEP_DESIGN_PDP.sectionRoot + ' .mainslider-wrapper').forEach((wrapper) => {
        let galleryLead = wrapper.querySelector(':scope > .pdp-lead')
        if (!galleryLead) {
          galleryLead = infoLead.cloneNode(true)
          galleryLead.classList.add('pdp-lead--gallery')
          galleryLead.setAttribute('aria-hidden', 'true')
          wrapper.insertBefore(galleryLead, wrapper.firstChild)
        } else {
          galleryLead.innerHTML = infoLead.innerHTML
        }
      })
    }

    window.syncGalleryPdpLead = syncGalleryPdpLead
    syncGalleryPdpLead()

    const mo = new MutationObserver(() => syncGalleryPdpLead())
    mo.observe(lead, { childList: true, subtree: true, characterData: true })
  })()

  if (typeof window.mountRxConfigModal === 'function') {
    window.mountRxConfigModal()
  }

  // Check if WishlistKing is defined before running
  const wishlistCheckInterval = setInterval(() => {
    if (typeof WishlistKing !== 'undefined') {
      console.log('WishlistKing is now defined!', WishlistKing);
      clearInterval(wishlistCheckInterval);
      
      // Run the function once WishlistKing is available
      renderWishlistButton();
    }
  }, 100); // Check every 100ms
  
  // Stop checking after 10 seconds
  setTimeout(() => {
    clearInterval(wishlistCheckInterval);
    console.log('Stopped checking for WishlistKing');
  }, 10000);

initPdpMobileStickyAtc();

